import React__default, { createElement, Component, createRef, cloneElement, Fragment, createContext, useMemo, PureComponent, Children, useContext, useRef, useState, useEffect, isValidElement } from 'react';
import styled, { css, withTheme, createGlobalStyle, ThemeProvider } from 'styled-components';
import { Link as Link$1 } from 'react-router-dom';
import classNames from 'classnames';
import { Collapse, Button as Button$1, DropdownButton as DropdownButton$4, ModalHeader, ModalBody, ModalFooter, ModalTitle, ModalDialog, Modal as Modal$1, Panel, Accordion as Accordion$1, Tabs as Tabs$1, TabContainer, Tab as Tab$1, TabPane, TabContent, ToggleButtonGroup as ToggleButtonGroup$1, HelpBlock, ControlLabel, FormControl, FormGroup } from 'react-bootstrap';
export { Alert, Badge, Breadcrumb, BreadcrumbItem, ButtonGroup, ButtonToolbar, Carousel, CarouselItem, Clearfix, Col, Collapse, ControlLabel, Dropdown, Fade, Form, FormControl, FormGroup, Glyphicon, Grid, HelpBlock, Image, InputGroup, Jumbotron, Label, ListGroup, ListGroupItem, Media, MenuItem, Nav, NavDropdown, NavItem, Navbar, NavbarBrand, Overlay, OverlayTrigger, PageHeader, PageItem, Pager, Pagination, Panel, PanelGroup, Popover, ProgressBar, ResponsiveEmbed, Row, SafeAnchor, SplitButton, TabContent, TabPane, Table, Thumbnail, ToggleButton, Tooltip, Well } from 'react-bootstrap';
import { findDOMNode, createPortal } from 'react-dom';
import { debounce } from 'lodash-es';
import ReactDatePicker from 'react-date-picker/dist/entry.nostyle';
import autosize from 'autosize';
import ReactDropzone from 'react-dropzone';
import { AlertList } from 'react-bs-notifier';
import ReactSelect from 'react-select';
export { Async, AsyncCreatable, Creatable } from 'react-select';
import PanelToggle from 'react-bootstrap/lib/PanelToggle';
import PanelHeading from 'react-bootstrap/lib/PanelHeading';
import PanelBody from 'react-bootstrap/lib/PanelBody';
import debounce$1 from 'lodash-es/debounce';

// This file defines standard colors for use within components in the bundle. For usage guidelines for these colors, please refer to the Style Guide
// Brand Colors
var hcssGreen = "#009639";
var hcssGray = "#636466"; // App Color
// Same color for Project Management and Checkbox component background color

var hcssHeavyJob = "#005EB8"; // Same color as hcssGreen and Pre-Constructions, Insights, Bid Results

var hcssHeavyBid = "#009639";
var hcssSafety = "#FF9E1B";
var hcssTelematics = "#00B5E2";
var hcssDispatcher = "#E35205"; // Same color for Maintenance Request

var hcssE360 = "#007681";
var hcssFuelerPlus = "#642f6c";
var hcssCredentials = "#5E7461";
var hcssELogs = "#7A9A01";
var hcssCloud = "#64A70B";
var hcssTrucking = "#00B2A9";
var hcssForms = "#418FDE";
var hcssPlans = "#485CC7";
var hcssSkills = "#4F758B";
var hcssIntelligence = "#003A70";
var hcssEmployeeApp = "#7B6469";

var standardColors = {
  __proto__: null,
  hcssGreen: hcssGreen,
  hcssGray: hcssGray,
  hcssHeavyJob: hcssHeavyJob,
  hcssHeavyBid: hcssHeavyBid,
  hcssSafety: hcssSafety,
  hcssTelematics: hcssTelematics,
  hcssDispatcher: hcssDispatcher,
  hcssE360: hcssE360,
  hcssFuelerPlus: hcssFuelerPlus,
  hcssCredentials: hcssCredentials,
  hcssELogs: hcssELogs,
  hcssCloud: hcssCloud,
  hcssTrucking: hcssTrucking,
  hcssForms: hcssForms,
  hcssPlans: hcssPlans,
  hcssSkills: hcssSkills,
  hcssIntelligence: hcssIntelligence,
  hcssEmployeeApp: hcssEmployeeApp
};

// Success Green
var successGreen = "#006627"; // Error Red

var errorRed = "#A60000"; // New Grey Names
// charcoalGray

var gray800 = "#1e1e1e"; // stoneGray

var gray700 = "#3e3e3e"; // mediumDarkGray

var gray600 = "#6e6e6e"; // mediumLightGray

var gray500 = "#cccccc"; // silverGray

var gray400 = "#d6d6d6"; // borderGray

var gray300 = "#ececec"; // lightGray

var gray200 = "#f0f0f0"; // offWhite

var gray100 = "#f6f6f6"; // Old Greys
// export const charcoalGray = "#1e1e1e";
// export const stoneGray = "#3e3e3e";
// export const mediumDarkGray = "#6e6e6e";
// export const mediumLightGray = "#cccccc";
// export const silverGray = "#d6d6d6";
// export const borderGray = "#ececec";
// export const lightGray = "#f0f0f0";
// export const offWhite = "#f6f6f6";

var aceColors = {
  __proto__: null,
  successGreen: successGreen,
  errorRed: errorRed,
  gray800: gray800,
  gray700: gray700,
  gray600: gray600,
  gray500: gray500,
  gray400: gray400,
  gray300: gray300,
  gray200: gray200,
  gray100: gray100
};

// Default Blues
var blue400 = "#003E8A";
var blue300 = "#005BCA";
var blue200 = "#0370F5";
var blue150 = "#DFEFFB";
var blue100 = "#ECF5FE"; // Success Greens

var green500 = "#072B21";
var green400 = "#0C4B39";
var green300 = "#11654D";
var green200 = "#14AF80";
var green100 = "#EEFBF5"; // Error Reds

var red400 = "#6E0303";
var red300 = "#9E0A0A";
var red200 = "#DB1010";
var red100 = "#FFEEEE"; // Concrete Greys

var gray700$1 = "#1E1E1E"; // Formerly stoneGray = #3e3e3e

var gray600$1 = "#404040";
var gray500$1 = "#707070";
var gray400$1 = "#CCCCCC";
var gray300$1 = "#ECECEC";
var gray200$1 = "#F0F0F0";
var gray100$1 = "#F6F6F6"; //Highlight Yellows

var yellow100 = "#FFF2BC"; //Used to highlight features that may be unexpectedly active (i.e. if search text is preserved when you come back to a table)

var concreteColors = {
  __proto__: null,
  blue400: blue400,
  blue300: blue300,
  blue200: blue200,
  blue150: blue150,
  blue100: blue100,
  green500: green500,
  green400: green400,
  green300: green300,
  green200: green200,
  green100: green100,
  red400: red400,
  red300: red300,
  red200: red200,
  red100: red100,
  gray700: gray700$1,
  gray600: gray600$1,
  gray500: gray500$1,
  gray400: gray400$1,
  gray300: gray300$1,
  gray200: gray200$1,
  gray100: gray100$1,
  yellow100: yellow100
};

var credentials = {
  baseTheme: "Ace",
  primaryColor: "#39453A",
  navbarColor: "#5f7361",
  navDropdownButtonColor: "#485749",
  navDropdownButtonHoverColor: "#39453A",
  buttonColor: "#5f7361",
  pageColor: "#ffffff",
  sidebarColor: "#f2f2f2",
  sidebarItemColor: "#f8f8f8"
};
var heavyBid = {
  baseTheme: "Ace",
  primaryColor: "#009639",
  navbarColor: "#009639",
  navDropdownButtonColor: "#009639",
  navDropdownButtonHoverColor: "#009639",
  buttonColor: "#009639",
  pageColor: "#ffffff",
  sidebarColor: "#f2f2f2",
  sidebarItemColor: "#f8f8f8"
};
var heavyJob = {
  baseTheme: "Ace",
  primaryColor: "#005eb8",
  navbarColor: "#005eb8",
  navDropdownButtonColor: "#4D8FCD",
  navDropdownButtonHoverColor: "#5996D1",
  buttonColor: "#005eb8",
  pageColor: "#ffffff",
  sidebarColor: "#f2f2f2",
  sidebarItemColor: "#f8f8f8"
};
var employeeApp = {
  baseTheme: "Ace",
  primaryColor: "#7B6469",
  navbarColor: "#7B6469",
  navDropdownButtonColor: "#a18b90",
  navDropdownButtonHoverColor: "#a18b90",
  buttonColor: "#7B6469",
  pageColor: "#ffffff",
  sidebarColor: "#f2f2f2",
  sidebarItemColor: "#f8f8f8"
};
var telematics = {
  baseTheme: "Ace",
  primaryColor: "#00b5e2",
  navbarColor: "#00b5e2",
  navDropdownButtonColor: "#009ac0",
  navDropdownButtonHoverColor: "#08a",
  pageColor: "#ffffff",
  sidebarColor: "#f2f2f2",
  sidebarItemColor: "#f8f8f8"
}; //Needs to be themed properly

var setups = {
  baseTheme: "Ace",
  primaryColor: "#005eb8",
  navbarColor: "#005eb8",
  navDropdownButtonColor: "#4D8FCD",
  navDropdownButtonHoverColor: "#5996D1",
  buttonColor: "#005eb8",
  pageColor: "#ffffff",
  sidebarColor: "#f2f2f2",
  sidebarItemColor: "#f8f8f8"
}; //Needs to be themed properly

var safety = {
  baseTheme: "Ace",
  primaryColor: "#ff9e1b",
  navbarColor: "#000000",
  navDropdownButtonColor: "#000000",
  navDropdownButtonHoverColor: "#000000",
  pageColor: "#f0f0f0",
  sidebarColor: "#ffffff",
  sidebarItemColor: "#ffffff"
}; //Needs to be themed properly

var skills = {
  baseTheme: "Ace",
  primaryColor: "#50748a",
  navbarColor: "#000000",
  navDropdownButtonColor: "#000000",
  navDropdownButtonHoverColor: "#000000",
  buttonColor: "#50748a",
  pageColor: "#ffffff",
  sidebarColor: "#f2f2f2",
  sidebarItemColor: "#f8f8f8"
}; //Needs to be themed properly

var forms = {
  baseTheme: "Ace",
  primaryColor: "#3f8ddf",
  navbarColor: "#000000",
  navDropdownButtonColor: "#000000",
  navDropdownButtonHoverColor: "#000000",
  buttonColor: "#3f8ddf",
  pageColor: "#ffffff",
  sidebarColor: "#f2f2f2",
  sidebarItemColor: "#f8f8f8"
}; //Needs to be themed properly

var eLogs = {
  baseTheme: "Ace",
  primaryColor: "#79993d",
  navbarColor: "#000000",
  navDropdownButtonColor: "#000000",
  navDropdownButtonHoverColor: "#000000",
  buttonColor: "#79993d",
  pageColor: "#ffffff",
  sidebarColor: "#f2f2f2",
  sidebarItemColor: "#f8f8f8"
}; //Needs to be themed properly

var community = {
  baseTheme: "Ace",
  primaryColor: "#0f9948",
  navbarColor: "#000000",
  navDropdownButtonColor: "#000000",
  navDropdownButtonHoverColor: "#000000",
  buttonColor: "#0f9948",
  pageColor: "#ffffff",
  sidebarColor: "#f2f2f2",
  sidebarItemColor: "#f8f8f8"
}; //Needs to be themed properly

var academy = {
  baseTheme: "Ace",
  primaryColor: "#009639",
  navbarColor: "#000000",
  navDropdownButtonColor: "#000000",
  navDropdownButtonHoverColor: "#000000",
  buttonColor: "#009639",
  pageColor: "#ffffff",
  sidebarColor: "#f2f2f2",
  sidebarItemColor: "#f8f8f8"
}; //Needs to be themed properly

var projectmanager = {
  baseTheme: "Concrete",
  primaryColor: "#005eb8",
  navbarColor: "#ffffff",
  navDropdownButtonColor: "#ffffff",
  navDropdownButtonHoverColor: "#f0f0f0",
  buttonColor: "#1e1e1e",
  pageColor: "#f0f0f0",
  sidebarColor: "#ffffff",
  sidebarItemColor: "#f0f0f0"
};
var preConstruction = {
  baseTheme: "Concrete",
  primaryColor: blue200,
  navbarColor: "#ffffff",
  navDropdownButtonColor: "#6e6e6e",
  navDropdownButtonHoverColor: "#cccccc",
  buttonColor: blue200,
  pageColor: "#f2f2f2",
  sidebarColor: "#ffffff",
  sidebarItemColor: "#f8f8f8"
};
var equipment360 = {
  baseTheme: "Ace",
  primaryColor: "#007681",
  navbarColor: "#007681",
  navDropdownButtonColor: "#075f67",
  navDropdownButtonHoverColor: "#034248",
  buttonColor: "#007681",
  pageColor: "#f2f2f2",
  sidebarColor: "#ffffff",
  sidebarItemColor: "#f8f8f8"
};
var themes = {
  credentials: credentials,
  heavyJob: heavyJob,
  heavyBid: heavyBid,
  telematics: telematics,
  employeeApp: employeeApp,
  setups: setups,
  safety: safety,
  skills: skills,
  forms: forms,
  eLogs: eLogs,
  community: community,
  academy: academy,
  projectmanager: projectmanager,
  preConstruction: preConstruction,
  equipment360: equipment360
};

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  strings.raw = raw;
  return strings;
}

function _templateObject5() {
  var data = _taggedTemplateLiteralLoose(["\n  float: left;\n  line-height: 45px;\n  height: 45px;\n  margin-left: 2px;\n  position: relative;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteralLoose(["\n  font-size: 36px;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["\n  background-color: ", ";\n  &:hover {\n    background-color: ", ";\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n  display: block;\n  border: none;\n  color: white;\n  height: 100%;\n  padding: 0 8px;\n  text-align: left;\n  &:focus {\n    outline-color: transparent;\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  list-style: none;\n  margin: 0;\n  -webkit-padding-start: 0;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}
var DropdownGroup =
/*#__PURE__*/
styled.ul(
/*#__PURE__*/
_templateObject());
var DropdownToggle =
/*#__PURE__*/
styled.a.attrs(function () {
  return {
    href: "#"
  };
})(
/*#__PURE__*/
_templateObject2());
var DropdownButton =
/*#__PURE__*/
styled(DropdownToggle)(
/*#__PURE__*/
_templateObject3(), function (props) {
  return props.theme.navDropdownButtonColor;
}, function (props) {
  return props.theme.navDropdownButtonHoverColor;
});
var DropdownIcon =
/*#__PURE__*/
styled.i(
/*#__PURE__*/
_templateObject4());

var UnstyledDropdown =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(UnstyledDropdown, _React$Component);

  function UnstyledDropdown(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.dropdownToggleRef = createRef();
    _this.dropdownMenuRef = createRef();

    _this.toggleClose = function (event) {
      if (_this.dropdownToggleRef.current && !_this.dropdownToggleRef.current.contains(event.target) && _this.dropdownMenuRef.current && !_this.dropdownMenuRef.current.contains(event.target)) {
        _this.setState(function (prevState, props) {
          return {
            isOpen: false
          };
        });
      }
    };

    _this.handleToggleFromMenu = function (event) {
      _this.setState(function (prevState, props) {
        return {
          isOpen: !prevState.isOpen
        };
      });
    };

    _this.handleToggle = function (event) {
      event.preventDefault();

      _this.setState(function (prevState, props) {
        return {
          isOpen: !prevState.isOpen
        };
      });
    };

    _this.state = {
      isOpen: false
    };

    if (props.children.length !== 2) {
      throw new Error("Dropdown requires dropdown toggle and dropdown menu");
    }

    return _this;
  }

  var _proto = UnstyledDropdown.prototype;

  _proto.componentDidMount = function componentDidMount() {
    document.addEventListener("mousedown", this.toggleClose);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    document.removeEventListener("mousedown", this.toggleClose);
  };

  _proto.render = function render() {
    //inner ref is used for styled components and ref should be used if dom element
    //currently only supporting inner ref as there isn't a use case yet for ref
    var dropdownToggle = cloneElement(this.props.children[0], {
      onClick: this.handleToggle,
      ref: this.dropdownToggleRef
    }, this.props.children[0].props.children);
    var dropdownMenu = cloneElement(this.props.children[1], {
      isOpen: this.state.isOpen,
      onClick: this.handleToggleFromMenu,
      ref: this.dropdownMenuRef
    }, this.props.children[1].props.children);
    return createElement("li", {
      className: this.props.className
    }, dropdownToggle, dropdownMenu);
  };

  return UnstyledDropdown;
}(Component);

var StyledDropdown =
/*#__PURE__*/
styled(UnstyledDropdown)(
/*#__PURE__*/
_templateObject5());

var Dropdown =
/*#__PURE__*/
function (_React$Component2) {
  _inheritsLoose(Dropdown, _React$Component2);

  function Dropdown() {
    return _React$Component2.apply(this, arguments) || this;
  }

  var _proto2 = Dropdown.prototype;

  _proto2.render = function render() {
    var _this$props = this.props,
        children = _this$props.children,
        props = _objectWithoutPropertiesLoose(_this$props, ["children"]);

    return createElement(StyledDropdown, Object.assign({}, props), children);
  };

  return Dropdown;
}(Component);
Dropdown.Group = DropdownGroup;
Dropdown.Toggle = DropdownToggle;
Dropdown.ToggleButton = DropdownButton;
Dropdown.Icon = DropdownIcon;

function _templateObject3$1() {
  var data = _taggedTemplateLiteralLoose(["\n        right: 0;\n        left: auto;\n        &::before {\n          content: \"\";\n          display: inline-block;\n          position: absolute;\n          border-bottom: 7px solid white;\n          border-left: 7px solid transparent;\n          border-right: 7px solid transparent;\n          right: 9px;\n          top: -6px;\n        }\n      "]);

  _templateObject3$1 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$1() {
  var data = _taggedTemplateLiteralLoose(["\n  z-index: 1031;\n  top: 99%;\n  position: absolute;\n  list-style: none;\n  background-color: white;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\n  border-radius: 0;\n  border: 1px solid rgba(0, 0, 0, 0.15);\n  -webkit-padding-start: 0;\n  display: ", ";\n  ", ";\n"]);

  _templateObject2$1 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$1() {
  var data = _taggedTemplateLiteralLoose(["\n  height: 1px;\n  margin: 9px 0;\n  overflow: hidden;\n  background-color: #e5e5e5;\n  font-size: 0;\n"]);

  _templateObject$1 = function _templateObject() {
    return data;
  };

  return data;
}
var Divider =
/*#__PURE__*/
styled.li(
/*#__PURE__*/
_templateObject$1());
var StyledDropdownMenu =
/*#__PURE__*/
styled.ul(
/*#__PURE__*/
_templateObject2$1(), function (props) {
  return props.isOpen ? "block" : "none";
}, function (props) {
  return props.right && css(_templateObject3$1());
});
/** Causing issues when using ref and .contains in Dropdown.tsx when detecting if a click was made outside the dropdown.
 * Ref forwarding is a solution but exporting styled components is a lot simpler. */
// export class DropdownMenu extends React.Component<DropdownMenuProps> {
//   static defaultProps = { right: false };
//   render() {
//     const { children, ...props } = this.props;
//     return (
//       <StyledDropdownMenu {...props as any}>{children}</StyledDropdownMenu>
//     );
//   }
// }

function _templateObject2$2() {
  var data = _taggedTemplateLiteralLoose(["\n  display: block;\n  font-size: 13px;\n  line-height: 1.42857143;\n  padding: 4px 12px;\n  white-space: nowrap;\n  min-width: 160px;\n  cursor: pointer;\n  &&,\n  &&:hover {\n    color: #333;\n  }\n  &&:hover {\n    background-color: rgb(245, 245, 245);\n  }\n"]);

  _templateObject2$2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$2() {
  var data = _taggedTemplateLiteralLoose(["\n  width: 19.5px;\n  margin-right: 10px;\n"]);

  _templateObject$2 = function _templateObject() {
    return data;
  };

  return data;
}
var Icon =
/*#__PURE__*/
styled.i(
/*#__PURE__*/
_templateObject$2());
var MenuItemLink =
/*#__PURE__*/
styled.a(
/*#__PURE__*/
_templateObject2$2());
function DropdownMenuItem(_ref) {
  var iconClassName = _ref.iconClassName,
      children = _ref.children,
      props = _objectWithoutPropertiesLoose(_ref, ["iconClassName", "children"]);

  var href = props.href,
      rest = _objectWithoutPropertiesLoose(props, ["ref", "href"]);

  return createElement("li", null, createElement(MenuItemLink, Object.assign({
    href: href
  }, rest), createElement(Icon, {
    className: iconClassName
  }), children));
}

var HelpMenu = function HelpMenu(_ref) {
  var children = _ref.children;
  return createElement(Dropdown, null, createElement(Dropdown.ToggleButton, null, createElement(Dropdown.Icon, {
    className: "fa fa-question-circle"
  })), createElement(StyledDropdownMenu, {
    right: true
  }, children));
};

HelpMenu.defaultProps = {
  children:
  /*#__PURE__*/
  createElement(Fragment, null,
  /*#__PURE__*/
  createElement(DropdownMenuItem, {
    href: "https://help.hcss.com",
    target: "_blank",
    iconClassName: "fa fa-file-text-o"
  }, "Help Center"),
  /*#__PURE__*/
  createElement(DropdownMenuItem, {
    href: "https://support.hcss.com/chat/",
    target: "_blank",
    iconClassName: "fa fa-comments"
  }, "Live Chat with Support"),
  /*#__PURE__*/
  createElement(DropdownMenuItem, {
    href: "https://help.hcss.com/s/contactsupport",
    target: "_blank",
    iconClassName: "fa fa-envelope"
  }, "Contact Support"),
  /*#__PURE__*/
  createElement(DropdownMenuItem, {
    href: "tel:+18004443196",
    iconClassName: "fa fa-phone"
  }, "Help Line: 1-800-444-3196"),
  /*#__PURE__*/
  createElement(Divider, null),
  /*#__PURE__*/
  createElement(DropdownMenuItem, {
    href: "http://ideas.hcss.com/",
    target: "_blank",
    iconClassName: "fa fa-lightbulb-o"
  }, "Log a Product Suggestion"),
  /*#__PURE__*/
  createElement(DropdownMenuItem, {
    href: "http://www.hcss.com/about-us/",
    target: "_blank",
    iconClassName: "fa fa-hcss"
  }, "About HCSS"))
};

function _templateObject3$2() {
  var data = _taggedTemplateLiteralLoose(["\n  ", "\n"]);

  _templateObject3$2 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$3() {
  var data = _taggedTemplateLiteralLoose(["\n  ", "\n"]);

  _templateObject2$3 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$3() {
  var data = _taggedTemplateLiteralLoose(["\n  cursor: pointer;\n  color: ", ";\n\n  :hover,\n  :focus {\n    color: ", ";\n  }\n"]);

  _templateObject$3 = function _templateObject() {
    return data;
  };

  return data;
}

var LinkStyle = function LinkStyle(_ref) {
  var hcssStyle = _ref.hcssStyle;
  return css(_templateObject$3(), hcssStyle === "Delete" ? "#dd3214" : "#005eb8", hcssStyle === "Delete" ? "#dd3214" : "#005eb8");
};

var StyledLink =
/*#__PURE__*/
styled.a(
/*#__PURE__*/
_templateObject2$3(), LinkStyle);
var StyledReactRouterLink =
/*#__PURE__*/
styled(function (_ref2) {
  var rest = _objectWithoutPropertiesLoose(_ref2, ["hcssStyle"]);

  return createElement(Link$1, Object.assign({}, rest));
})(
/*#__PURE__*/
_templateObject3$2(), LinkStyle);
var _defaultTestId = "Link";

var Link =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Link, _React$Component);

  function Link() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Link.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        to = _this$props.to,
        children = _this$props.children,
        href = _this$props.href,
        renderHtmlAnchor = _this$props.renderHtmlAnchor,
        testId = _this$props.testId,
        props = _objectWithoutPropertiesLoose(_this$props, ["to", "children", "href", "ref", "renderHtmlAnchor", "testId", "as"]);

    if (to !== undefined && !renderHtmlAnchor) {
      return createElement(StyledReactRouterLink, Object.assign({
        to: to,
        "data-testid": testId !== null && testId !== void 0 ? testId : _defaultTestId
      }, props), children);
    }

    return createElement(StyledLink, Object.assign({
      href: to ? to : href,
      "data-testid": testId !== null && testId !== void 0 ? testId : _defaultTestId
    }, props), children);
  };

  return Link;
}(Component);

function _templateObject4$1() {
  var data = _taggedTemplateLiteralLoose(["\n  color: white;\n  font-size: 28px;\n  padding: auto;\n  margin-top: 20px;\n  margin-right: 5px;\n  line-height: normal;\n"]);

  _templateObject4$1 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$3() {
  var data = _taggedTemplateLiteralLoose(["\n  float: right;\n  margin-right: 10px;\n"]);

  _templateObject3$3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$4() {
  var data = _taggedTemplateLiteralLoose(["\n  color: white;\n  margin-left: 10px;\n  text-decoration: none;\n  font-family: \"ProximaNova\";\n  font-size: 28px;\n  line-height: normal;\n\n  & > b {\n    font-family: \"ProximaNova Heavy\";\n  }\n\n  :focus {\n    color: white;\n  }\n"]);

  _templateObject2$4 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$4() {
  var data = _taggedTemplateLiteralLoose(["\n  font-size: 14px;\n  background-color: ", ";\n  height: 45px;\n  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.2),\n    0 1px 5px 0 rgba(0, 0, 0, 0.12);\n  z-index: 1000;\n\n  & a,\n  & a:hover {\n    color: white;\n    text-decoration: none;\n  }\n"]);

  _templateObject$4 = function _templateObject() {
    return data;
  };

  return data;
}
var Nav =
/*#__PURE__*/
styled.nav(
/*#__PURE__*/
_templateObject$4(), function (props) {
  return props.theme.navbarColor;
});
var ProductLogo =
/*#__PURE__*/
styled(Link)(
/*#__PURE__*/
_templateObject2$4());
var NavbarHeader =
/*#__PURE__*/
styled.div(
/*#__PURE__*/
_templateObject3$3());
var StyledLogoIcon =
/*#__PURE__*/
styled.i(
/*#__PURE__*/
_templateObject4$1());

var Navbar =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Navbar, _React$Component);

  function Navbar() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Navbar.prototype;

  _proto.render = function render() {
    return createElement(Nav, null, this.props.hamburgerMenu, createElement(ProductLogo, {
      to: this.props.homeTo,
      renderHtmlAnchor: this.props.renderHtmlAnchorForHomeTo
    }, createElement(StyledLogoIcon, null, this.props.logoIcon), this.props.productBrandLight, " ", createElement("b", null, this.props.productBrandBold)), createElement(NavbarHeader, null, createElement(Dropdown.Group, null, this.props.helpMenu, this.props.profileMenu)));
  };

  return Navbar;
}(Component);
Navbar.defaultProps = {
  homeTo: "/",
  helpMenu:
  /*#__PURE__*/
  createElement(HelpMenu, null)
};

function _templateObject$5() {
  var data = _taggedTemplateLiteralLoose(["\n  padding-left: ", ";\n  padding-right: ", ";\n"]);

  _templateObject$5 = function _templateObject() {
    return data;
  };

  return data;
}
/**
 * Use the standard FontAwesome v4.7 icon names [found here](https://fontawesome.com/v4.7.0/icons/) plus our [custom HCSS font names](https://hcss-pattern-library-test.azurewebsites.net/#!/elements/typography) (without the fa- prefix)
 * So, "name: info" not "name: fa-info"
 */

var StyledIcon =
/*#__PURE__*/
styled.i(
/*#__PURE__*/
_templateObject$5(), function (props) {
  return props.margin === "left" || props.margin === "both" ? "5px" : 0;
}, function (props) {
  return props.margin === "right" || props.margin === "both" ? "5px" : 0;
});
var Icon$1 =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Icon, _React$Component);

  function Icon() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Icon.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        className = _this$props.className,
        name = _this$props.name,
        margin = _this$props.margin,
        other = _objectWithoutPropertiesLoose(_this$props, ["className", "name", "margin"]);

    if (className === undefined || className === null) className = "";
    var iconClass = className + " fa fa-" + name;
    return createElement(StyledIcon, Object.assign({
      className: iconClass,
      name: name,
      margin: margin
    }, other));
  };

  return Icon;
}(Component);

function _templateObject3$4() {
  var data = _taggedTemplateLiteralLoose(["\n  z-index: 1031;\n  top: 99%;\n  position: absolute;\n  list-style: none;\n  background-color: white;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\n  border-radius: 0;\n  border: 1px solid rgba(0, 0, 0, 0.15);\n  -webkit-padding-start: 0;\n  margin-top: 0;\n  & > li p {\n    white-space: normal;\n  }\n\n  & > li:hover > a {\n    background: unset;\n    color: unset;\n  }\n  &#dropdownList > li > a:hover {\n    background-color: rgb(245, 245, 245);\n  }\n  display: ", ";\n\n  .btn-home {\n    margin: 15px 0;\n    div {\n      text-align: center;\n      a {\n        color: ", ";\n        border: 1px solid ", ";\n        padding: 10px 15px;\n        font-size: 12px;\n        border-radius: 5px;\n        i {\n          margin-right: 2px;\n        }\n      }\n    }\n  }\n"]);

  _templateObject3$4 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$5() {
  var data = _taggedTemplateLiteralLoose(["\n  font-size: 17pt;\n  margin-top: 8px;\n"]);

  _templateObject2$5 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$6() {
  var data = _taggedTemplateLiteralLoose(["\n  background: inherit;\n  padding: 0 20px 0 8px;\n  &:hover {\n    opacity: 0.7;\n  }\n"]);

  _templateObject$6 = function _templateObject() {
    return data;
  };

  return data;
}
var DropdownButton$1 =
/*#__PURE__*/
styled(Dropdown.Toggle)(
/*#__PURE__*/
_templateObject$6());
var HamburgerMenuDropdownIcon =
/*#__PURE__*/
styled(Dropdown.Icon)(
/*#__PURE__*/
_templateObject2$5());
var HackedDropdownMenu =
/*#__PURE__*/
styled.ul(
/*#__PURE__*/
_templateObject3$4(), function (props) {
  return props.isOpen ? "block" : "none";
}, gray600, gray400);
/** NEEDS SOME WORK: Currently hacking it */

var HamburgerMenu =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(HamburgerMenu, _React$Component);

  function HamburgerMenu() {
    var _this;

    _this = _React$Component.apply(this, arguments) || this;

    _this.getHomeLink = function () {
      var loc = window.location.href;
      if (loc.includes("dev")) return "https://dev.hcssapps.com";else if (loc.includes("staging")) return "https://staging.hcssapps.com";else return "https://hcssapps.com";
    };

    return _this;
  }

  var _proto = HamburgerMenu.prototype;

  _proto.render = function render() {
    var homeUrl = this.getHomeLink();
    return createElement(Dropdown.Group, null, createElement(Dropdown, null, createElement(DropdownButton$1, null, createElement(HamburgerMenuDropdownIcon, {
      className: "fa fa-bars"
    })), createElement(HackedDropdownMenu, {
      id: "dropdownList",
      className: "user-menu dropdown-menu-left dropdown-menu"
    }, this.props.children, createElement("li", {
      className: "btn-home"
    }, createElement("div", null, createElement("a", {
      href: homeUrl
    }, createElement(Icon$1, {
      name: "home"
    }), "HCSS Apps Home"))))));
  };

  return HamburgerMenu;
}(Component);

function _templateObject$7() {
  var data = _taggedTemplateLiteralLoose(["\n  &.hamburgermenu-item {\n    a {\n      cursor: pointer;\n      padding: 4px 12px;\n      .product-name {\n        color: ", ";\n        font-size: 18pt;\n        font-family: \"ProximaNova\";\n        line-height: 0.1;\n        & > i {\n          margin-right: 10px;\n        }\n      }\n      .subtitle {\n        font-size: 13px;\n        color: ", ";\n      }\n    }\n  }\n"]);

  _templateObject$7 = function _templateObject() {
    return data;
  };

  return data;
}
var MenuItemStlying =
/*#__PURE__*/
styled.li(
/*#__PURE__*/
_templateObject$7(), function (props) {
  return props.color || "#000";
}, gray600);
var HamburgerMenuItem = function HamburgerMenuItem(props) {
  var iconName = props.iconName,
      productBrandBold = props.productBrandBold,
      productBrandLight = props.productBrandLight,
      subtitle = props.subtitle,
      className = props.className,
      href = props.href,
      others = _objectWithoutPropertiesLoose(props, ["iconName", "productBrandBold", "productBrandLight", "subtitle", "className", "href", "ref"]);

  return createElement(MenuItemStlying, Object.assign({
    className: classNames("hamburgermenu-item", className)
  }, others), createElement("a", {
    href: href,
    target: "_blank",
    rel: "noopener noreferrer"
  }, createElement("div", {
    className: "product-name"
  }, createElement(Icon$1, {
    name: iconName
  }), productBrandLight, createElement("strong", null, productBrandBold)), createElement("p", {
    className: "subtitle"
  }, subtitle)));
};

var ProfileMenu =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(ProfileMenu, _React$Component);

  function ProfileMenu() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = ProfileMenu.prototype;

  _proto.render = function render() {
    return createElement(Dropdown, null, createElement(Dropdown.ToggleButton, null, createElement(Dropdown.Icon, {
      className: "fa fa-user-profile",
      style: {
        "float": "left",
        padding: "0 15px 0 0",
        marginTop: "3px"
      }
    }), createElement("div", {
      style: {
        "float": "left",
        padding: "0 15px 0 0"
      }
    }, createElement("span", {
      style: {
        display: "inline-block",
        position: "relative",
        lineHeight: "16px",
        width: "100px",
        whiteSpace: "nowrap",
        textOverflow: "ellipsis",
        overflow: "hidden",
        fontSize: "14.6667px",
        verticalAlign: "middle"
      }
    }, this.props.firstName, " ", this.props.lastName && this.props.lastName[0] + ".", createElement("small", {
      style: {
        display: "block",
        fontSize: "80%",
        color: "lightgrey",
        textOverflow: "ellipsis",
        overflow: "hidden"
      }
    }, this.props.subtext))), createElement("i", {
      className: "fa fa-caret-down"
    })), createElement(StyledDropdownMenu, {
      right: true
    }, this.props.children));
  };

  return ProfileMenu;
}(Component);

/** This is exported as a default module for testing purposes.
 * We should expect to use this for level 1 menu containers only.
 * This is very hacky and best I can think of right now.
 */
var ContainerSingularOpenManager = function ContainerSingularOpenManager() {
  var _this = this;

  this.sidebarContainerMenuItemToCloseMap = {};
  this.containers = [];

  this.addCloseCallback = function (name, close) {
    _this.sidebarContainerMenuItemToCloseMap[name] = close;
  };

  this.addContainer = function (name) {
    _this.containers.push(name);
  };

  this.handleOnOpen = function (name) {
    if (!_this.containers.some(function (c) {
      return c === name;
    })) return;

    _this.containers.filter(function (n) {
      return n !== name;
    }).forEach(function (n) {
      return _this.sidebarContainerMenuItemToCloseMap[n]();
    });
  };
};
var containerSingularOpenManager =
/*#__PURE__*/
new ContainerSingularOpenManager();

function _templateObject2$6() {
  var data = _taggedTemplateLiteralLoose(["\n  background-color: #ffffff;\n  border-color: #e5e5e5;\n  margin: 0;\n  padding: 0;\n  position: relative;\n  display: \"block\";\n  &::before {\n    content: \"\";\n    display: block;\n    position: absolute;\n    z-index: 1;\n    left: 18px;\n    top: 0;\n    bottom: 0;\n    border: 1px dotted #9dbdd6;\n    border-width: 0 0 0 1px;\n  }\n  & > li > a {\n    background-color: #ffffff;\n    color: #616161;\n  }\n\n  & li:not(:first-of-type) {\n    border-top-color: #e4e4e4;\n    border-top-style: dotted;\n  }\n\n  & li > & > li:not(.active) a:not(:hover) {\n    color: #757575;\n  }\n\n  & li > & > li > a {\n    margin-left: 5px;\n  }\n  & > li a > i {\n    font-size: 12px;\n    line-height: 17px;\n    vertical-align: top;\n  }\n\n  & > li::before {\n    content: \"\";\n    display: inline-block;\n    position: absolute;\n    z-index: 1;\n    width: 7px;\n    left: 20px;\n    top: 17px;\n    border-top: 1px dotted #9dbdd6;\n  }\n\n  & > li & > li::before {\n    display: none;\n  }\n"]);

  _templateObject2$6 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$8() {
  var data = _taggedTemplateLiteralLoose(["\n  display: block;\n  width: 14px !important;\n  height: 14px;\n  line-height: 14px;\n  text-shadow: none;\n  font-size: 18px;\n  position: absolute;\n  right: 10px;\n  top: 12px;\n  padding: 0;\n  text-align: center;\n"]);

  _templateObject$8 = function _templateObject() {
    return data;
  };

  return data;
}
var ContainerArrow =
/*#__PURE__*/
styled.b.attrs(function () {
  return {
    className: "fa fa-angle-down"
  };
})(
/*#__PURE__*/
_templateObject$8());
var StyledContainerMenuList =
/*#__PURE__*/
styled.ul(
/*#__PURE__*/
_templateObject2$6());

function ContainerMenuList(_ref) {
  var children = _ref.children,
      props = _objectWithoutPropertiesLoose(_ref, ["children"]);

  return createElement(StyledContainerMenuList, Object.assign({}, props), children);
}

function _templateObject$9() {
  var data = _taggedTemplateLiteralLoose(["\n  display: block;\n  position: relative;\n  float: none;\n  padding: 0;\n  border-style: solid;\n  border-width: 1px 0px 0px;\n  border-color: rgb(224, 224, 224);\n  margin: 0;\n  &.active > a {\n    font-weight: 700;\n    color: ", ";\n  }\n\n  &.active::after {\n    display: block;\n    content: \"\";\n    position: absolute;\n    right: -2px;\n    top: -1px;\n    bottom: 0;\n    z-index: 1;\n    border: 2px solid ", ";\n    border-width: 0 2px 0 0;\n  }\n"]);

  _templateObject$9 = function _templateObject() {
    return data;
  };

  return data;
}
var SidebarMenuItem =
/*#__PURE__*/
styled.li.attrs(function () {
  return {
    "data-testid": "sidebar-menu-item"
  };
})(
/*#__PURE__*/
_templateObject$9(), function (props) {
  return props.theme.primaryColor;
}, function (props) {
  return props.theme.primaryColor;
});

function _templateObject2$7() {
  var data = _taggedTemplateLiteralLoose(["\n  font-size: 18px;\n  display: inline-block;\n  min-width: 30px;\n  margin-right: 2px;\n  vertical-align: sub;\n  text-align: center;\n  font-weight: 400;\n"]);

  _templateObject2$7 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$a() {
  var data = _taggedTemplateLiteralLoose(["\n  font-size: 13px;\n  margin: 0;\n  padding-left: 7px;\n  padding-top: 8px;\n  padding-bottom: 8px;\n  display: block;\n  height: 39px;\n  line-height: 20px;\n  text-shadow: none;\n  position: relative;\n\n  &,\n  &:visited,\n  &:focus,\n  &:active,\n  &:hover {\n    color: rgb(64, 64, 64);\n    text-decoration: none;\n  }\n  &:hover {\n    background-color: #ffffff;\n    font-weight: 700;\n    color: ", ";\n  }\n"]);

  _templateObject$a = function _templateObject() {
    return data;
  };

  return data;
}
var SidebarMenuItemLink =
/*#__PURE__*/
styled(Link)(
/*#__PURE__*/
_templateObject$a(), function (props) {
  return props.theme.primaryColor;
});
var SidebarMenuItemIcon =
/*#__PURE__*/
styled.i(
/*#__PURE__*/
_templateObject2$7());

function isSidebarLinkMenuItemActive(to, toAlternatives, windowLocationPathname) {
  if (windowLocationPathname === void 0) {
    windowLocationPathname = window.location.pathname;
  }

  return windowLocationPathname.toLowerCase() === to.toLowerCase() || toAlternatives && toAlternatives.some(function (t) {
    return windowLocationPathname.toLowerCase().startsWith(t.toLowerCase());
  });
}
function SidebarLinkMenuItem(_ref) {
  var children = _ref.children,
      to = _ref.to,
      toAlternatives = _ref.toAlternatives,
      iconClassName = _ref.iconClassName,
      className = _ref.className,
      onClick = _ref.onClick,
      renderHtmlAnchor = _ref.renderHtmlAnchor,
      _ref$windowLocationPa = _ref.windowLocationPathname,
      windowLocationPathname = _ref$windowLocationPa === void 0 ? window.location.pathname : _ref$windowLocationPa;
  return createElement(SidebarMenuItem, {
    className: classNames({
      active: isSidebarLinkMenuItemActive(to, toAlternatives, windowLocationPathname)
    })
  }, createElement(SidebarMenuItemLink, {
    onClick: onClick,
    className: className,
    to: to,
    renderHtmlAnchor: renderHtmlAnchor
  }, iconClassName && createElement(SidebarMenuItemIcon, {
    className: iconClassName
  }), createElement("span", null, children)));
}

var SidebarContainerMenuItem =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(SidebarContainerMenuItem, _React$Component);

  function SidebarContainerMenuItem(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;

    _this.close = function () {
      _this.setState(function (prevState, props) {
        return {
          isOpen: false
        };
      });
    };

    _this.hasAnActiveDescendant = function (children) {
      if (Array.isArray(children)) return children.some(function (i) {
        return i.type === SidebarLinkMenuItem && _this.isSidebarLinkMenuItemActive(i.props) || i.type === SidebarContainerMenuItem && _this.hasAnActiveDescendant(i.props.children);
      });else return _this.isSidebarLinkMenuItemActive(children.props) || false;
    };

    _this.isSidebarLinkMenuItemActive = function (_ref) {
      var to = _ref.to,
          toAlternatives = _ref.toAlternatives,
          windowLocationPathname = _ref.windowLocationPathname;
      return isSidebarLinkMenuItemActive(to, toAlternatives, windowLocationPathname);
    };

    _this.handleDropdownToggleClick = function (e) {
      e.preventDefault();

      _this.setState(function (prevState, props) {
        var isOpen = !prevState.isOpen;
        if (isOpen) containerSingularOpenManager.handleOnOpen(_this.props.name);
        return {
          isOpen: isOpen
        };
      });
    };

    containerSingularOpenManager.addCloseCallback(props.name, _this.close);

    var hasAnActiveDescendant = _this.hasAnActiveDescendant(props.children);

    _this.state = {
      isActive: hasAnActiveDescendant,
      isOpen: hasAnActiveDescendant
    };
    return _this;
  }

  var _proto = SidebarContainerMenuItem.prototype;

  _proto.render = function render() {
    return createElement(SidebarMenuItem, {
      className: classNames({
        active: this.state.isActive
      })
    }, createElement(SidebarMenuItemLink, {
      to: "#",
      renderHtmlAnchor: this.props.renderHtmlAnchor,
      onClick: this.handleDropdownToggleClick
    }, this.props.iconClassName && createElement(SidebarMenuItemIcon, {
      className: this.props.iconClassName
    }), createElement("span", {
      className: "container-menu-text"
    }, this.props.name), createElement(ContainerArrow, null)), createElement(Collapse, {
      "data-testid": "collapse",
      "in": this.state.isOpen
    }, createElement(ContainerMenuList, null, this.props.children)));
  } //container-menu-text is hack to easily style :(
  ;

  return SidebarContainerMenuItem;
}(Component);
SidebarContainerMenuItem.defaultProps = {
  windowLocationPathname: window.location.pathname
};

function _templateObject$b() {
  var data = _taggedTemplateLiteralLoose(["\n  margin: 0px;\n  padding: 0;\n  list-style: none;\n  & > li {\n    background-color: ", ";\n  }\n  & > li:last-child {\n    border-bottom-width: 1px;\n  }\n  & > li:hover::before {\n    display: block;\n    position: absolute;\n    top: -1px;\n    left: 0;\n    z-index: 1;\n    height: 41px;\n    width: 3px;\n    max-width: 3px;\n    overflow: hidden;\n    background-color: ", ";\n    content: \"\";\n  }\n  & > li ul {\n    line-height: 19.5px;\n  }\n  & > li ul > li > a {\n    height: 100%;\n    padding-left: 37px;\n  }\n  & > li ul > li ul > li {\n    line-height: 18px;\n  }\n"]);

  _templateObject$b = function _templateObject() {
    return data;
  };

  return data;
}
var StyledSidebarMenuList =
/*#__PURE__*/
styled.ul(
/*#__PURE__*/
_templateObject$b(), function (props) {
  return props.theme.sidebarItemColor;
}, function (props) {
  return props.theme.primaryColor;
});

var SidebarMenuList =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(SidebarMenuList, _React$Component);

  function SidebarMenuList(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    var children = props.children;
    if (!Array.isArray(children)) return _assertThisInitialized(_this);
    children.forEach(function (i) {
      if (i.type === SidebarContainerMenuItem) containerSingularOpenManager.addContainer(i.props.name);
    });
    return _this;
  }

  var _proto = SidebarMenuList.prototype;

  _proto.render = function render() {
    return createElement(StyledSidebarMenuList, null, this.props.children);
  };

  return SidebarMenuList;
}(Component);

function _templateObject2$8() {
  var data = _taggedTemplateLiteralLoose(["\n  padding: 0 5px;\n  line-height: 18px;\n  cursor: pointer;\n  font-size: 14px;\n  border-radius: 100%;\n  position: relative;\n  background-color: white;\n  color: rgb(170, 170, 170);\n  border-width: 1px;\n  border-style: solid;\n  border-color: rgb(224, 224, 224);\n  border-image: initial;\n"]);

  _templateObject2$8 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$c() {
  var data = _taggedTemplateLiteralLoose(["\n  border-style: solid;\n  border-width: 0 0 1px;\n  text-align: center;\n  padding: 3px 0;\n  position: relative;\n  border-color: #e0e0e0;\n  &::before {\n    content: \"\";\n    display: block;\n    height: 0;\n\n    border-top: 1px solid;\n    border-color: inherit;\n    position: absolute;\n    left: 15px;\n    right: 15px;\n    top: 13px;\n  }\n"]);

  _templateObject$c = function _templateObject() {
    return data;
  };

  return data;
}
var SidebarToggleContainer =
/*#__PURE__*/
styled.div(
/*#__PURE__*/
_templateObject$c());
var SidebarToggleIcon =
/*#__PURE__*/
styled.i(
/*#__PURE__*/
_templateObject2$8());

var SidebarToggle =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(SidebarToggle, _React$Component);

  function SidebarToggle() {
    var _this;

    _this = _React$Component.apply(this, arguments) || this;

    _this.toggleExistingLayoutContainer = function (expand) {
      var sidebarContainer = document.getElementById("sidebar-container");
      if (sidebarContainer === null) return;
      if (expand) sidebarContainer.classList.remove("menu-min");else sidebarContainer.classList.add("menu-min");
    };

    return _this;
  }

  var _proto = SidebarToggle.prototype;

  _proto.render = function render() {
    return createElement(SidebarToggleContainer, null, createElement(SidebarToggleIcon, {
      "data-testid": "sidebar-toggle-icon",
      onClick: this.props.onToggle,
      className: classNames({
        "fa fa-angle-double-left": this.props.sidebarExpanded,
        "fa fa-angle-double-right": !this.props.sidebarExpanded
      })
    }));
  };

  return SidebarToggle;
}(Component);

function _templateObject$d() {
  var data = _taggedTemplateLiteralLoose(["\n  margin-top: 2px;\n  width: 189px;\n  background-color: ", ";\n  border-style: solid;\n  border-color: #cccccc;\n  border-width: 0 1px 0 0;\n  line-height: normal;\n  height: calc(100% - 2px);\n\n  &.menu-min {\n    width: 42px;\n\n    > ul > li > a > span {\n      display: none;\n      position: absolute;\n      height: 39px;\n      line-height: 38px;\n      background-color: #f5f5f5;\n      z-index: 121;\n      box-shadow: 2px 1px 2px 0 rgba(0, 0, 0, 0.2);\n      padding-left: 12px;\n      border: 1px solid #ccc;\n      top: -1px;\n      left: 42px;\n      width: 173px;\n      border-bottom: 1px solid #ddd;\n    }\n\n    > ul > li > a > span.container-menu-text {\n      border: none;\n      box-shadow: none;\n      border-bottom: 1px solid #ddd;\n    }\n\n    > ul > li ul::before,\n    > ul > li ul li::before,\n    > ul > li > a > b,\n    > ul > li ul i {\n      display: none;\n    }\n\n    > ul > li > ul {\n      background: #fff;\n      position: absolute;\n      z-index: 120;\n      left: 41px;\n      top: -2px;\n      width: 175px;\n      border: 1px solid #ccc;\n      box-shadow: 2px 1px 2px 0 rgba(0, 0, 0, 0.2);\n      padding-top: 38px;\n      padding-bottom: 2px;\n      display: none;\n    }\n\n    > ul > li > ul > li > a {\n      padding: 7px 0 8px 24px;\n    }\n\n    > ul > li:hover > a > span,\n    > ul > li:hover > ul {\n      display: block;\n    }\n  }\n"]);

  _templateObject$d = function _templateObject() {
    return data;
  };

  return data;
}
var Nav$1 =
/*#__PURE__*/
styled.nav(
/*#__PURE__*/
_templateObject$d(), function (props) {
  return props.theme.sidebarColor;
}); //Interesting logic to support existing pages layout scenario

var Sidebar =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Sidebar, _React$Component);

  function Sidebar(props) {
    var _props$sidebarExpande;

    var _this;

    _this = _React$Component.call(this, props) || this;

    _this.handleToggle = function () {
      _this.setState(function (prevState, props) {
        var newState = !prevState.sidebarExpanded;
        return {
          sidebarExpanded: newState
        };
      });
    };

    _this.state = {
      sidebarExpanded: (_props$sidebarExpande = props.sidebarExpanded) !== null && _props$sidebarExpande !== void 0 ? _props$sidebarExpande : props.viewportWidth > 1024
    };
    return _this;
  }

  var _proto = Sidebar.prototype;

  _proto.render = function render() {
    return createElement(Nav$1, {
      "data-testid": "sidebar",
      style: {
        minHeight: "calc(100vh - " + this.props.navbarHeight + ")"
      },
      className: this.props.sidebarExpanded !== undefined ? classNames({
        "menu-min": !this.props.sidebarExpanded
      }) : classNames({
        "menu-min": !this.state.sidebarExpanded
      })
    }, createElement(SidebarMenuList, null, this.props.children), createElement(SidebarToggle, {
      "data-testid": "sidebar-toggle",
      onToggle: this.props.sidebarExpanded !== undefined ? this.props.onToggle : this.handleToggle,
      sidebarExpanded: this.props.sidebarExpanded !== undefined ? this.props.sidebarExpanded : this.state.sidebarExpanded
    }));
  };

  return Sidebar;
}(Component);
Sidebar.defaultProps = {
  viewportWidth:
  /*#__PURE__*/
  Math.max(document.documentElement.clientWidth, window.innerWidth || 0),
  navbarHeight: "47px"
};

function _templateObject3$5() {
  var data = _taggedTemplateLiteralLoose(["\n  background-color: ", ";\n"]);

  _templateObject3$5 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$9() {
  var data = _taggedTemplateLiteralLoose(["\n  width: 100%;\n"]);

  _templateObject2$9 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$e() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: row;\n"]);

  _templateObject$e = function _templateObject() {
    return data;
  };

  return data;
}
var SidebarAndMainContainer =
/*#__PURE__*/
styled.div(
/*#__PURE__*/
_templateObject$e());
var StyledMain =
/*#__PURE__*/
styled.main(
/*#__PURE__*/
_templateObject2$9());
var StyledAppContainer =
/*#__PURE__*/
styled.div(
/*#__PURE__*/
_templateObject3$5(), function (props) {
  return props.theme.pageColor;
});

var Layout =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Layout, _React$Component);

  function Layout() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Layout.prototype;

  _proto.render = function render() {
    return createElement(StyledAppContainer, null, createElement("div", {
      id: "navbar-container"
    }, this.props.navbar), createElement(SidebarAndMainContainer, {
      id: "sidebar-and-main-container"
    }, createElement("div", {
      id: "sidebar-container"
    }, this.props.sidebar), createElement(StyledMain, null, this.props.mainContent, this.props.footer)));
  };

  return Layout;
}(Component);
Layout.Navbar = Navbar;
Layout.DropdownMenuItem = DropdownMenuItem;
Layout.DropdownDivider = Divider;
Layout.HamburgerMenu = HamburgerMenu;
Layout.HamburgerMenuItem = HamburgerMenuItem;
Layout.HelpMenu = HelpMenu;
Layout.ProfileMenu = ProfileMenu;
Layout.Sidebar = Sidebar;
Layout.SidebarLinkMenuItem = SidebarLinkMenuItem;
Layout.SidebarContainerMenuItem = SidebarContainerMenuItem;

var DropdownContext =
/*#__PURE__*/
createContext(function () {});

function _templateObject5$1() {
  var data = _taggedTemplateLiteralLoose(["\n  display: inline-block;\n  height: 100%;\n  z-index: 2000;\n"]);

  _templateObject5$1 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$2() {
  var data = _taggedTemplateLiteralLoose(["\n  font-size: 1.8rem;\n  font-weight: 400;\n  margin-top: -4px;\n"]);

  _templateObject4$2 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$6() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: row;\n  flex-wrap: nowrap;\n  align-items: center;\n  background: none;\n  padding: 0 16px;\n  font-size: 1.25rem;\n  letter-spacing: 0.02rem;\n  font-weight: 600;\n  color: ", ";\n  z-index: 3;\n  transition: 0.2s;\n\n  /* to prevent overriding from the default styling for anchor elements */\n  &:focus:not(:hover):not(.dropdown-active) {\n    color: ", ";\n  }\n\n  &:after {\n    transition: 0.2s;\n  }\n\n  /* triangular pointer, shown only while Dropdown is active and DropdownMenu is visible */\n  &:after {\n    content: \"\";\n    display: block;\n    position: absolute;\n    width: 0;\n    height: 0;\n    top: 100%;\n    left: 0;\n    background: none;\n    border-top: 0px solid transparent;\n\n    border-left-style: solid;\n    border-left-color: transparent;\n    border-left-width: calc(", "px / 2);\n\n    border-right-style: solid;\n    border-right-color: transparent;\n    border-right-width: calc(", "px / 2);\n    transition: 0.2s, border-right-width, border-left-width 0s; /* prevents glitching when toggle region's width changes for whatever reason */\n  }\n\n  &:hover {\n    color: ", ";\n    background: ", ";\n\n    &:after {\n      border-top-color: ", ";\n    }\n  }\n\n  &.dropdown-active {\n    color: white;\n    background: ", ";\n\n    &:after {\n      border-top-color: ", ";\n    }\n  }\n\n  &:hover,\n  &.dropdown-active {\n    text-decoration: none !important;\n  }\n\n  &.dropdown-active {\n    &:after {\n      border-top-width: 12px;\n      /* if we go with the green background color instead, and hover background is same as active background, use the timing function below */\n      /* transition: border-top-width 0.2s cubic-bezier(0.5, 0.0, 0.5, 0.5); */\n    }\n  }\n"]);

  _templateObject3$6 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$a() {
  var data = _taggedTemplateLiteralLoose(["\n  display: block;\n  position: relative;\n  border: none;\n  height: 100%;\n  text-align: left;\n\n  &:hover,\n  &:focus,\n  &.dropdown-active {\n    outline: none;\n  }\n"]);

  _templateObject2$a = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$f() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: row;\n  flex-wrap: nowrap;\n  align-items: center;\n  justify-content: space-around;\n  list-style-type: none;\n  margin: 0;\n  height: 100%;\n"]);

  _templateObject$f = function _templateObject() {
    return data;
  };

  return data;
}

var StyledDropdownGroup =
/*#__PURE__*/
styled.ul(
/*#__PURE__*/
_templateObject$f());
var DropdownToggle$1 =
/*#__PURE__*/
styled("a").attrs(function () {
  return {
    href: "#"
  };
})(
/*#__PURE__*/
_templateObject2$a());
var DropdownButton$2 =
/*#__PURE__*/
styled(DropdownToggle$1)(
/*#__PURE__*/
_templateObject3$6(), gray700$1, gray700$1, function (props) {
  return props.togglewidth;
}, function (props) {
  return props.togglewidth;
}, blue200, blue100, blue100, blue200, blue200);
var DropdownIcon$1 =
/*#__PURE__*/
styled.i(
/*#__PURE__*/
_templateObject4$2()); // #endregion

var DropdownGroup$1 =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(DropdownGroup, _React$Component);

  function DropdownGroup() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = DropdownGroup.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        children = _this$props.children,
        className = _this$props.className,
        props = _objectWithoutPropertiesLoose(_this$props, ["children", "className"]);

    return createElement(StyledDropdownGroup, Object.assign({
      className: classNames(className, "dropdown-group")
    }, props), children);
  };

  return DropdownGroup;
}(Component);

var UnstyledDropdown$1 =
/*#__PURE__*/
function (_React$Component2) {
  _inheritsLoose(UnstyledDropdown, _React$Component2);

  function UnstyledDropdown(props) {
    var _this;

    _this = _React$Component2.call(this, props) || this;
    _this.dropdownToggleRef = createRef();
    _this.dropdownMenuRef = createRef();
    _this.dropdownToggleRegionRef = createRef();

    _this.toggleClose = function (event) {
      if (_this.dropdownToggleRef.current && !_this.dropdownToggleRef.current.contains(event.target) && _this.dropdownMenuRef.current && !_this.dropdownMenuRef.current.contains(event.target)) {
        _this.setState({
          isOpen: false
        });
      }
    };

    _this.forceClose = function () {
      return _this.setState({
        isOpen: false
      });
    };

    _this.handleToggleFromMenu = function (event) {
      /* prevent the dropdown menu from hiding if the user clicks somewhere inside the menu container, but not on a link in the menu */
      if (!event.target.className.includes("dropdown-menu")) {
        _this.setState(function (prevState, props) {
          return {
            isOpen: !prevState.isOpen
          };
        });
      }
    };

    _this.handleToggle = function (event) {
      var toggleDropdown = function toggleDropdown() {
        _this.setState(function (prevState) {
          return {
            isOpen: !prevState.isOpen
          };
        });
      };

      event.preventDefault();
      /* immediately recalculate width of toggle region, then trigger the open/close animation, with the dropdown toggle button pointer */

      _this.setState({
        toggleRegionWidth: _this.dropdownToggleRegionRef.current.getBoundingClientRect().width
      }, toggleDropdown);
    };

    _this.state = {
      isOpen: false,
      toggleRegionWidth: 0
    };

    if (props.children.length !== 2) {
      throw new Error("Dropdown requires dropdown toggle and dropdown menu");
    }

    return _this;
  }

  var _proto2 = UnstyledDropdown.prototype;

  _proto2.componentDidMount = function componentDidMount() {
    var _this2 = this;

    document.addEventListener("mousedown", this.toggleClose);
    setTimeout(function () {
      if (_this2.dropdownToggleRegionRef.current) {
        _this2.setState({
          toggleRegionWidth: _this2.dropdownToggleRegionRef.current.getBoundingClientRect().width
        });
      }
    }, 250);
  };

  _proto2.componentWillUnmount = function componentWillUnmount() {
    document.removeEventListener("mousedown", this.toggleClose);
  };

  _proto2.render = function render() {
    //inner ref is used for styled components and ref should be used if dom element
    //currently only supporting inner ref as there isn't a use case yet for ref
    var dropdownToggle = cloneElement(this.props.children[0], {
      onClick: this.handleToggle,
      ref: this.dropdownToggleRef,
      className: classNames("dropdown-toggle", {
        "dropdown-active": this.state.isOpen
      }),
      togglewidth: this.state.toggleRegionWidth
    }, this.props.children[0].props.children);
    var dropdownMenu = cloneElement(this.props.children[1], {
      isOpen: this.state.isOpen,
      onClick: this.handleToggleFromMenu,
      ref: this.dropdownMenuRef,
      className: classNames("dropdown-menu", {
        "dropdown-active": this.state.isOpen
      })
    }, this.props.children[1].props.children);
    return createElement(DropdownContext.Provider, {
      value: this.forceClose
    }, createElement("li", {
      className: classNames(this.props.className, "dropdown-upgraded", {
        "dropdown-active": this.state.isOpen
      }),
      ref: this.dropdownToggleRegionRef
    }, dropdownToggle, dropdownMenu));
  };

  return UnstyledDropdown;
}(Component);

var StyledDropdown$1 =
/*#__PURE__*/
styled(UnstyledDropdown$1)(
/*#__PURE__*/
_templateObject5$1());

var UpgradedDropdown =
/*#__PURE__*/
function (_React$Component3) {
  _inheritsLoose(UpgradedDropdown, _React$Component3);

  function UpgradedDropdown() {
    return _React$Component3.apply(this, arguments) || this;
  }

  var _proto3 = UpgradedDropdown.prototype;

  _proto3.render = function render() {
    var _this$props2 = this.props,
        children = _this$props2.children,
        props = _objectWithoutPropertiesLoose(_this$props2, ["children", "className"]);

    return createElement(StyledDropdown$1, Object.assign({}, props), children);
  };

  return UpgradedDropdown;
}(Component);
UpgradedDropdown.Group = DropdownGroup$1;
UpgradedDropdown.Toggle = DropdownToggle$1;
UpgradedDropdown.ToggleButton = DropdownButton$2;
UpgradedDropdown.Icon = DropdownIcon$1;

function _templateObject7() {
  var data = _taggedTemplateLiteralLoose(["\n      width: 100vw;\n      left: 0px;\n      margin-left: 0px;\n      max-width: ", ";\n      columns: ", " ", "rem;\n    "]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteralLoose(["\n        column-width: ", "em;\n      "]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5$2() {
  var data = _taggedTemplateLiteralLoose(["\n        columns: ", "em ", ";\n      "]);

  _templateObject5$2 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$3() {
  var data = _taggedTemplateLiteralLoose(["\n        width: 70vw;\n        max-width: ", "em;\n      "]);

  _templateObject4$3 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$7() {
  var data = _taggedTemplateLiteralLoose(["\n        right: 0;\n        left: auto;\n      "]);

  _templateObject3$7 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$b() {
  var data = _taggedTemplateLiteralLoose(["\n  z-index: 1031;\n  position: absolute;\n  top: 42px;\n  margin: 0;\n  padding: 0 16px 48px 16px;\n  background-color: white;\n  border: none;\n  border-radius: 0;\n  box-shadow: -2px 6px 8px -6px ", ";\n  z-index: 2;\n\n  display: ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n"]);

  _templateObject2$b = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$g() {
  var data = _taggedTemplateLiteralLoose(["\n  height: 1px;\n  margin: 8px 0;\n  overflow: hidden;\n  background-color: ", ";\n  font-size: 0;\n"]);

  _templateObject$g = function _templateObject() {
    return data;
  };

  return data;
}

var Divider$1 =
/*#__PURE__*/
styled.div.attrs(function () {
  return {
    className: "dropdown-menu-divider"
  };
})(
/*#__PURE__*/
_templateObject$g(), gray300$1);
var StyledDropdownMenu$1 =
/*#__PURE__*/
styled.div(
/*#__PURE__*/
_templateObject2$b(), gray500$1, function (props) {
  return props.isOpen ? "block" : "none";
}, function (props) {
  return props.right && css(_templateObject3$7());
}, function (props) {
  return props.widthEm && css(_templateObject4$3(), props.widthEm);
}, function (props) {
  return props.columnCount && css(_templateObject5$2(), props.columnWidthEm, props.columnCount);
}, function (props) {
  return props.columnWidthEm && css(_templateObject6(), props.columnWidthEm);
}, function (props) {
  return props.fullWidth && css(_templateObject7(), props.width, props.columnCount, props.columnWidthEm);
});
/** Causing issues when using ref and .contains in Dropdown.tsx when detecting if a click was made outside the dropdown.
 * Ref forwarding is a solution but exporting styled components is a lot simpler. */
// export default class UpgradedDropdownMenu extends React.Component<
//   DropdownMenuProps
// > {
//   static defaultProps = { right: false };
//   render() {
//     const { children, ...props } = this.props;
//     return (
//       <StyledDropdownMenu {...props as any}>{children}</StyledDropdownMenu>
//     );
//   }
// }

var useDropdownMenuManager = function useDropdownMenuManager(WrappedComponent) {
  return function (props) {
    return createElement(DropdownContext.Consumer, null, function (value) {
      return createElement(WrappedComponent, Object.assign({
        onClick: value
      }, props));
    });
  };
};

function _templateObject4$4() {
  var data = _taggedTemplateLiteralLoose(["\n      text-decoration: none;\n      filter: alpha(opacity=65);\n      -webkit-box-shadow: none;\n      box-shadow: none;\n      opacity: 0.65;\n      pointer-events: none;\n      cursor: not-allowed;\n    "]);

  _templateObject4$4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$8() {
  var data = _taggedTemplateLiteralLoose(["\n  ", ";\n"]);

  _templateObject3$8 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$c() {
  var data = _taggedTemplateLiteralLoose(["\n  .dropdown-menu-link {\n    display: inline-block;\n    font-size: 1.35rem;\n    line-height: normal;\n    padding: 6px 0;\n    /* min-width: 160px; */\n    max-width: 100%;\n    color: ", ";\n    cursor: pointer;\n  }\n  .dropdown-menu-link:hover {\n    color: ", ";\n  }\n\n  .dropdown-menu-link:active {\n    color: ", ";\n  }\n"]);

  _templateObject2$c = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$h() {
  var data = _taggedTemplateLiteralLoose(["\n  width: 19.5px;\n  margin-right: 10px;\n"]);

  _templateObject$h = function _templateObject() {
    return data;
  };

  return data;
}
var Icon$2 =
/*#__PURE__*/
styled.i(
/*#__PURE__*/
_templateObject$h());
var MenuItemLink$1 =
/*#__PURE__*/
styled.div(
/*#__PURE__*/
_templateObject2$c(), gray700$1, blue200, blue300);

function UpgradedDropdownMenuItem(_ref) {
  var className = _ref.className,
      iconClassName = _ref.iconClassName,
      children = _ref.children,
      to = _ref.to,
      onClick = _ref.onClick,
      props = _objectWithoutPropertiesLoose(_ref, ["className", "iconClassName", "children", "to", "ref", "onClick"]);

  var useReactRouterLink = to !== undefined;
  return createElement(MenuItemLink$1, {
    className: classNames("dropdown-menu-item", className)
  }, useReactRouterLink ? createElement(Link$1, Object.assign({
    to: to
  }, props, {
    className: "dropdown-menu-link",
    onClick: onClick
  }), iconClassName && createElement(Icon$2, {
    className: iconClassName
  }), children) : createElement("a", Object.assign({
    onClick: onClick
  }, props, {
    className: "dropdown-menu-link"
  }), iconClassName && createElement(Icon$2, {
    className: iconClassName
  }), children));
}

var HcssDropdownMenuItem =
/*#__PURE__*/
styled(useDropdownMenuManager(UpgradedDropdownMenuItem))(
/*#__PURE__*/
_templateObject3$8(), function (props) {
  return props.disabled === true && css(_templateObject4$4());
});

function _templateObject$i() {
  var data = _taggedTemplateLiteralLoose(["\n  padding: 16px 24px 12px 24px;\n\n  & .dropdown-menu-item > a {\n    padding: 10px 0;\n  }\n"]);

  _templateObject$i = function _templateObject() {
    return data;
  };

  return data;
}
var HelpDropdownMenu =
/*#__PURE__*/
styled(StyledDropdownMenu$1)(
/*#__PURE__*/
_templateObject$i());

var HelpMenu$1 = function HelpMenu(props) {
  var children = props.guest !== undefined && props.guest ? HelpMenuGuestProps.children : props.children;
  return createElement(UpgradedDropdown, null, createElement(UpgradedDropdown.ToggleButton, null, createElement(UpgradedDropdown.Icon, {
    className: "fa fa-question-circle-o",
    style: {
      fontSize: "2rem"
    }
  })), createElement(HelpDropdownMenu, {
    right: true
  }, children));
};

var HelpMenuGuestProps = {
  children:
  /*#__PURE__*/
  createElement(Fragment, null,
  /*#__PURE__*/
  createElement(HcssDropdownMenuItem, {
    href: "https://help.hcss.com",
    target: "_blank",
    iconClassName: "fa fa-file-text-o"
  }, "Help Center"),
  /*#__PURE__*/
  createElement(HcssDropdownMenuItem, {
    href: "https://help.hcss.com/s/contactsupport",
    target: "_blank",
    iconClassName: "fa fa-envelope"
  }, "Contact Support"),
  /*#__PURE__*/
  createElement(Divider$1, null),
  /*#__PURE__*/
  createElement(HcssDropdownMenuItem, {
    href: "http://www.hcss.com/about-us/",
    target: "_blank",
    iconClassName: "fa fa-hcss"
  }, "About HCSS"))
};
HelpMenu$1.defaultProps = {
  children:
  /*#__PURE__*/
  createElement(Fragment, null,
  /*#__PURE__*/
  createElement(HcssDropdownMenuItem, {
    href: "https://help.hcss.com",
    target: "_blank",
    iconClassName: "fa fa-file-text-o"
  }, "Help Center"),
  /*#__PURE__*/
  createElement(HcssDropdownMenuItem, {
    href: "https://support.hcss.com/chat/",
    target: "_blank",
    iconClassName: "fa fa-comments"
  }, "Live Chat with Support"),
  /*#__PURE__*/
  createElement(HcssDropdownMenuItem, {
    href: "https://help.hcss.com/s/contactsupport",
    target: "_blank",
    iconClassName: "fa fa-envelope"
  }, "Contact Support"),
  /*#__PURE__*/
  createElement(HcssDropdownMenuItem, {
    href: "tel:+18004443196",
    iconClassName: "fa fa-phone"
  }, "Help Line: 1-800-444-3196"),
  /*#__PURE__*/
  createElement(Divider$1, null),
  /*#__PURE__*/
  createElement(HcssDropdownMenuItem, {
    href: "http://ideas.hcss.com/",
    target: "_blank",
    iconClassName: "fa fa-lightbulb-o"
  }, "Log a Product Suggestion"),
  /*#__PURE__*/
  createElement(HcssDropdownMenuItem, {
    href: "http://www.hcss.com/about-us/",
    target: "_blank",
    iconClassName: "fa fa-hcss"
  }, "About HCSS"))
};

function _templateObject4$5() {
  var data = _taggedTemplateLiteralLoose(["\n  position: relative;\n  display: flex;\n  flex-direction: row;\n  flex-wrap: nowrap;\n  align-items: center;\n  height: 100%;\n  margin-left: 12px;\n  font-family: \"ProximaNova\";\n  font-size: 20px;\n\n  &:hover,\n  &:active {\n    text-decoration: none;\n\n    & > .navbar-product-name {\n      color: ", ";\n      text-decoration: none !important;\n    }\n  }\n\n  & > .navbar-product-icon,\n  & > .navbar-product-name {\n    display: inline-block;\n    vertical-align: middle;\n    transition: 0.2s;\n  }\n\n  & > .navbar-product-icon {\n    color: ", ";\n    line-height: 0;\n    margin: -1px 10px 0 0;\n\n    & > i {\n      font-size: 2.5rem;\n    }\n  }\n\n  & > .navbar-product-name {\n    color: ", ";\n    font-family: \"Inter\", \"ProximaNova\", Arial, Helvetica, sans-serif;\n    font-size: 1.7rem;\n    margin: -1px 0 0 0;\n\n    & > strong {\n      font-weight: 800;\n    }\n  }\n"]);

  _templateObject4$5 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$9() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: row;\n  flex-wrap: nowrap;\n  align-items: center;\n  justify-content: flex-end;\n  height: 100%;\n"]);

  _templateObject3$9 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$d() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: row;\n  flex-wrap: nowrap;\n  align-items: center;\n  justify-content: flex-start;\n  height: 100%;\n"]);

  _templateObject2$d = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$j() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex; /* will ensure responsiveness based on screen size */\n  flex-direction: row;\n  flex-wrap: nowrap; /* will prevent the tools on the right from jumping down when the screen is made smaller */\n  align-items: center; /* ensures that text, icons, and other content will appear centered along the same x-axis, in the middle */\n  justify-content: space-between; /* ensures that app logo area stays at left, and menus and tools stay at right */\n  height: 45px;\n\n  background-color: white;\n  border-bottom: 2px solid ", ";\n  font-size: 14px;\n  z-index: 1000;\n"]);

  _templateObject$j = function _templateObject() {
    return data;
  };

  return data;
}

var Navbar$1 =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Navbar, _React$Component);

  function Navbar() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Navbar.prototype;

  _proto.render = function render() {
    return createElement(Nav$2, {
      className: "page-navbar"
    }, createElement(NavLogoArea, {
      className: "navbar-logo-area"
    }, this.props.hamburgerMenu, createElement(ProductLogo$1, {
      className: "navbar-product-home-link",
      to: this.props.homeTo,
      renderHtmlAnchor: this.props.renderHtmlAnchorForHomeTo
    }, createElement("div", {
      className: "navbar-product-icon"
    }, this.props.logoIcon), createElement("div", {
      className: "navbar-product-name"
    }, this.props.productBrandLight, " ", createElement("strong", null, this.props.productBrandBold)))), createElement(NavFeatureMenus, {
      className: "navbar-feature-menus"
    }, createElement(UpgradedDropdown.Group, null, this.props.navMenu, this.props.helpMenu, this.props.profileMenu)));
  };

  return Navbar;
}(Component);
Navbar$1.defaultProps = {
  homeTo: "/",
  helpMenu:
  /*#__PURE__*/
  createElement(HelpMenu$1, null),
  logoIcon:
  /*#__PURE__*/
  createElement(Icon$1, {
    name: "hcss"
  })
};
var Nav$2 =
/*#__PURE__*/
styled.nav(
/*#__PURE__*/
_templateObject$j(), gray300$1);
var NavLogoArea =
/*#__PURE__*/
styled("div")(
/*#__PURE__*/
_templateObject2$d());
var NavFeatureMenus =
/*#__PURE__*/
styled("div")(
/*#__PURE__*/
_templateObject3$9());
var ProductLogo$1 =
/*#__PURE__*/
styled(Link)(
/*#__PURE__*/
_templateObject4$5(), function (props) {
  return props.theme.primaryColor;
}, function (props) {
  return props.theme.primaryColor;
}, gray700$1);

function _templateObject$k() {
  var data = _taggedTemplateLiteralLoose(["\n  display: block;\n  line-height: normal;\n  break-inside: avoid; // used to prevent breaking group across columns in mega-menu\n  padding: 36px 24px 0 24px;\n"]);

  _templateObject$k = function _templateObject() {
    return data;
  };

  return data;
}
var MenuGroup =
/*#__PURE__*/
styled.div.attrs(function () {
  return {
    className: "nav-menu-group"
  };
})(
/*#__PURE__*/
_templateObject$k());

var NavMenu =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(NavMenu, _React$Component);

  function NavMenu() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = NavMenu.prototype;

  _proto.render = function render() {
    var iconClassName;

    if (this.props.menuIcon) {
      iconClassName = "fa fa-" + this.props.menuIcon;
    }

    var iconStyle;

    if (this.props.menuIcon && this.props.menuName) {
      iconStyle = {
        marginRight: "0.25em"
      };
    }

    if (this.props.fullWidth === true) {
      return createElement(UpgradedDropdown, {
        fullWidth: true
      }, createElement(UpgradedDropdown.ToggleButton, null, this.props.menuIcon && createElement(UpgradedDropdown.Icon, {
        className: iconClassName,
        style: iconStyle
      }), this.props.menuName), createElement(StyledDropdownMenu$1, {
        fullWidth: true,
        columnCount: this.props.columnCount,
        columnWidthEm: this.props.columnWidthEm
      }, this.props.children));
    } else {
      return createElement(UpgradedDropdown, null, createElement(UpgradedDropdown.ToggleButton, null, this.props.menuIcon && createElement(UpgradedDropdown.Icon, {
        className: iconClassName,
        style: iconStyle
      }), this.props.menuName), createElement(StyledDropdownMenu$1, {
        right: true,
        widthEm: this.props.widthEm,
        columnCount: this.props.columnCount,
        columnWidthEm: this.props.columnWidthEm
      }, this.props.children));
    }
  };

  return NavMenu;
}(Component);
NavMenu.Group = MenuGroup;
NavMenu.defaultProps = {
  columnCount: 1,
  columnWidthEm: 15
};

function _templateObject4$6() {
  var data = _taggedTemplateLiteralLoose(["\n  position: absolute;\n  top: 40px;\n  padding: 16px 0;\n  list-style: none;\n  background-color: white;\n  border: none;\n  border-radius: 0;\n  box-shadow: 0 6px 8px -6px ", ";\n  z-index: 2;\n\n  & > li p {\n    white-space: normal;\n  }\n\n  & > li:hover > a {\n    background: unset;\n    color: unset;\n  }\n\n  display: ", ";\n"]);

  _templateObject4$6 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$a() {
  var data = _taggedTemplateLiteralLoose(["\n  color: ", ";\n  font-size: 2rem;\n  margin-top: -3px;\n"]);

  _templateObject3$a = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$e() {
  var data = _taggedTemplateLiteralLoose(["\n  &:hover i {\n    color: ", ";\n  }\n\n  &.dropdown-active i {\n    color: white;\n  }\n"]);

  _templateObject2$e = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$l() {
  var data = _taggedTemplateLiteralLoose([""]);

  _templateObject$l = function _templateObject() {
    return data;
  };

  return data;
}
var HamburgerDropdown =
/*#__PURE__*/
styled(UpgradedDropdown)(
/*#__PURE__*/
_templateObject$l());
var HamburgerDropdownButton =
/*#__PURE__*/
styled(UpgradedDropdown.ToggleButton)(
/*#__PURE__*/
_templateObject2$e(), blue200);
var HamburgerMenuDropdownIcon$1 =
/*#__PURE__*/
styled(UpgradedDropdown.Icon)(
/*#__PURE__*/
_templateObject3$a(), gray400$1);
var HamburgerDropdownMenu =
/*#__PURE__*/
styled.ul(
/*#__PURE__*/
_templateObject4$6(), gray500$1, function (props) {
  return props.isOpen ? "block" : "none";
});

var HamburgerMenu$1 =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(HamburgerMenu, _React$Component);

  function HamburgerMenu() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = HamburgerMenu.prototype;

  _proto.render = function render() {
    return createElement(UpgradedDropdown.Group, {
      className: "dropdown-group"
    }, createElement(HamburgerDropdown, {
      className: "hamburger-dropdown"
    }, createElement(HamburgerDropdownButton, {
      className: "hamburger-dropdown-button"
    }, createElement(HamburgerMenuDropdownIcon$1, {
      className: "fa fa-bars"
    })), createElement(HamburgerDropdownMenu, {
      id: "dropdownList",
      className: "user-menu dropdown-menu-left dropdown-menu"
    }, this.props.children)));
  };

  return HamburgerMenu;
}(Component);

function _templateObject$m() {
  var data = _taggedTemplateLiteralLoose(["\n  &.hamburgermenu-item {\n    a {\n      padding: 16px 32px 16px 16px;\n      cursor: pointer;\n\n      &:hover,\n      &:active {\n        background: ", ";\n      }\n\n      .product-link {\n        display: flex;\n        flex-direction: row;\n        flex-wrap: nowrap;\n        align-items: stretch;\n        justify-content: flex-start;\n\n        & > .product-link-icon {\n          margin-top: -3px;\n          margin-right: 8px;\n          flex-shrink: 0;\n          font-size: 3.2rem;\n          color: ", ";\n        }\n\n        & > .product-link-info {\n          flex-grow: 1;\n          font-family: \"Inter\", Arial, Helvetica, sans-serif;\n\n          & > .product-name {\n            font-size: 2rem;\n            font-weight: 400;\n            color: ", ";\n            line-height: 2.6rem;\n\n            & > strong {\n              font-weight: 800;\n            }\n          }\n\n          & > .product-desc {\n            font-size: 1.3rem;\n            font-weight: 400;\n            color: ", ";\n          }\n        }\n      }\n    }\n  }\n"]);

  _templateObject$m = function _templateObject() {
    return data;
  };

  return data;
}
var MenuItemStyling =
/*#__PURE__*/
styled("li")(
/*#__PURE__*/
_templateObject$m(), gray200$1, function (props) {
  return props.color || gray700$1;
}, function (props) {
  return props.color || gray700$1;
}, gray700$1);
var HamburgerMenuItem$1 = function HamburgerMenuItem(_ref) {
  var props = _extends({}, _ref);

  var iconName = props.iconName,
      productBrandBold = props.productBrandBold,
      productBrandLight = props.productBrandLight,
      subtitle = props.subtitle,
      className = props.className,
      href = props.href,
      others = _objectWithoutPropertiesLoose(props, ["iconName", "productBrandBold", "productBrandLight", "subtitle", "className", "href", "ref"]);

  return createElement(MenuItemStyling, Object.assign({
    className: classNames("hamburgermenu-item", className)
  }, others), createElement("a", {
    href: href,
    target: "_blank",
    rel: "noopener noreferrer"
  }, createElement("div", {
    className: "product-link"
  }, createElement("div", {
    className: "product-link-icon"
  }, createElement(Icon$1, {
    name: iconName
  })), createElement("div", {
    className: "product-link-info"
  }, createElement("div", {
    className: "product-name"
  }, productBrandLight, " ", createElement("strong", null, productBrandBold)), createElement("div", {
    className: "product-desc"
  }, subtitle)))));
};

function _templateObject2$f() {
  var data = _taggedTemplateLiteralLoose(["\n  display: grid;\n  grid-template-columns: auto 1fr;\n  grid-template-rows: 2.4rem 2.8rem;\n  grid-template-areas:\n    \"initials name\"\n    \"initials company\";\n  grid-column-gap: 16px;\n  grid-row-gap: 3px;\n  margin: 1px 0 8px;\n  padding: 24px 20px 0;\n  background: #ffffff;\n  box-shadow: inset 0 96px 24px -48px #ececec;\n\n  & > .user-initials {\n    grid-area: initials;\n    display: flex;\n    flex-wrap: nowrap;\n    align-items: center;\n    justify-content: center;\n    width: 60px;\n    height: 60px;\n\n    background: ", ";\n    border-radius: 60px;\n    color: #ffffff;\n    font-family: \"ProximaNova\", Arial, Helvetica, sans-serif;\n    font-size: 2.4rem;\n    letter-spacing: 0.1rem;\n    ", "\n  }\n\n  & > .user-full-name {\n    grid-area: name;\n    color: ", ";\n    font-family: \"ProximaNova Heavy\", Arial, Helvetica, sans-serif;\n    font-size: 2rem;\n    line-height: normal;\n    ", "\n  }\n\n  & > .user-company-name {\n    grid-area: company;\n    color: ", ";\n    font-size: 1.3rem;\n    align-self: self-start;\n    line-height: normal;\n    ", "\n  }\n"]);

  _templateObject2$f = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$n() {
  var data = _taggedTemplateLiteralLoose(["\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n"]);

  _templateObject$n = function _templateObject() {
    return data;
  };

  return data;
}

var UserInfoSection = function UserInfoSection(props) {
  // Destructure props
  var firstName = props.firstName,
      lastName = props.lastName,
      companyName = props.companyName; // Get user's initials

  var getFirstInitial = function getFirstInitial() {
    var _ref, _firstName$;

    return (_ref = (_firstName$ = firstName[0]) === null || _firstName$ === void 0 ? void 0 : _firstName$.toUpperCase()) !== null && _ref !== void 0 ? _ref : "";
  };

  var getLastInitial = function getLastInitial() {
    var _ref2, _lastName$;

    return (_ref2 = lastName && ((_lastName$ = lastName[0]) === null || _lastName$ === void 0 ? void 0 : _lastName$.toUpperCase())) !== null && _ref2 !== void 0 ? _ref2 : "";
  }; // Render user's full name


  var getFullName = function getFullName() {
    if (!lastName || lastName.trim() === "") return firstName;
    return firstName + " " + lastName;
  }; //
  //
  //


  return React__default.createElement(StyledUserInfoSection, {
    className: "user-info-section"
  }, React__default.createElement("div", {
    className: "user-initials"
  }, React__default.createElement("span", {
    className: "initials-wrapper",
    "data-testid": "profile-menu-user-info-initials"
  }, getFirstInitial(), getLastInitial())), React__default.createElement("div", {
    className: "user-full-name",
    "data-testid": "profile-menu-user-info-full-name",
    title: getFullName()
  }, getFullName()), React__default.createElement("div", {
    className: "user-company-name",
    "data-testid": "profile-menu-user-info-company-name",
    title: companyName
  }, companyName));
};

var cutoffText =
/*#__PURE__*/
css(
/*#__PURE__*/
_templateObject$n());
var StyledUserInfoSection =
/*#__PURE__*/
styled.div(
/*#__PURE__*/
_templateObject2$f(), blue200, cutoffText, gray700$1, cutoffText, gray500$1, cutoffText);

function _templateObject7$1() {
  var data = _taggedTemplateLiteralLoose(["\n  grid-area: caret;\n  align-self: center;\n  justify-self: self-end;\n\n  color: ", ";\n  font-size: 2.2rem;\n\n  & > i {\n    transition: 0.2s;\n  }\n"]);

  _templateObject7$1 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6$1() {
  var data = _taggedTemplateLiteralLoose(["\n  grid-area: status;\n  align-self: self-start;\n  margin-top: 2px;\n\n  color: ", ";\n  font-size: 1.5rem;\n  ", "\n"]);

  _templateObject6$1 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5$3() {
  var data = _taggedTemplateLiteralLoose(["\n  grid-area: label;\n  align-self: self-end;\n  font-size: 1.5rem;\n\n  color: ", ";\n  ", "\n"]);

  _templateObject5$3 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$7() {
  var data = _taggedTemplateLiteralLoose(["\n  & > .static-item,\n  & > .link-item {\n    ", "\n    ", "\n  }\n\n  & > .button-item {\n    ", "\n    background: none;\n    border: 0;\n    box-shadow: none;\n    ", "\n    text-align: left;\n  }\n"]);

  _templateObject4$7 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$b() {
  var data = _taggedTemplateLiteralLoose(["\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n"]);

  _templateObject3$b = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$g() {
  var data = _taggedTemplateLiteralLoose(["\n  display: block;\n  position: relative;\n  width: 100%;\n  padding: 10px 20px;\n\n  transition: 0.2s;\n\n  &.setting-item {\n    display: grid;\n    grid-template-columns: 1fr 24px;\n    grid-template-rows: auto auto;\n    grid-template-areas:\n      \"label caret\"\n      \"status caret\";\n\n    margin: -16px 0 16px;\n    padding: 16px 20px;\n\n    border-bottom: 1px solid ", ";\n\n    & > .profile-menu-item-label {\n      font-size: 1.2rem;\n      font-weight: 600;\n      letter-spacing: 0.02rem;\n      text-transform: uppercase;\n    }\n  }\n\n  &,\n  &:active,\n  &:focus {\n    outline: none;\n  }\n\n  &,\n  &:hover,\n  &:active,\n  &:focus,\n  &:active:focus {\n    text-decoration: none;\n  }\n\n  &:hover,\n  &:active,\n  &:focus,\n  &:active:focus {\n    background: ", ";\n    cursor: pointer;\n\n    &,\n    & * {\n      color: ", ";\n    }\n  }\n"]);

  _templateObject2$g = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$o() {
  var data = _taggedTemplateLiteralLoose(["\n  display: block;\n  position: relative;\n  padding: 0;\n  width: 100%;\n"]);

  _templateObject$o = function _templateObject() {
    return data;
  };

  return data;
}

var ProfileMenuItem = function ProfileMenuItem(props) {
  // Destructure props
  var label = props.label,
      status = props.status,
      linkTo = props.linkTo,
      onClick = props.onClick,
      testId = props.testId,
      title = props.title,
      rest = _objectWithoutPropertiesLoose(props, ["label", "status", "linkTo", "onClick", "testId", "title"]); // Render the label of the menu item.


  var itemLabel = useMemo(function () {
    return React__default.createElement(MenuItemLabel, {
      className: "profile-menu-item-label",
      "data-testid": "profile-menu-item-label"
    }, label);
  }, [label]); // Render the current status of the setting this item is related
  // to, if provided a status

  var itemStatus = useMemo(function () {
    if (!!status) return React__default.createElement(MenuItemStatus, {
      className: "profile-menu-item-status",
      "data-testid": "profile-menu-item-status"
    }, status);
    return null;
  }, [status]); // Render a right-pointing caret as a click affordance, if a status
  // is provided (i.e. if this is "setting" item)

  var clickAffordance = useMemo(function () {
    if (!!status) return React__default.createElement(MenuItemClickAffordance, {
      className: "profile-menu-item-click-affordance",
      "data-testid": "profile-menu-item-click-affordance"
    }, React__default.createElement(Icon$1, {
      name: "angle-right"
    }));
    return null;
  }, [status]); // Render the click target that houses the menu item.
  // -- If a value is provided for "onClick", this click target will be
  //    a "button" DOM node
  // -- If a value if provided for "linkTo" this click target will be an
  //    anchor DOM node
  // -- If a value is passed for both, an anchor tag will be rendered, but
  //    both the link (href) and "onClick" values will be passed to it.
  // -- If no value is passed for either, a static item will be rendered
  //    and a warning will be thrown.

  var clickTarget = useMemo(function () {
    var itemTypeClass = !!status ? "setting-item" : "standard-item";

    if (!linkTo && !onClick) {
      console.warn("Warning: Each ProfileMenu item should have a value for either the linkTo or the onClick property\n[HCSS Components Bundle | LayoutConcrete.ProfileMenu.ProfileMenuItem]");
      return React__default.createElement("div", {
        className: "profile-menu-static-item static-item " + itemTypeClass,
        "data-testid": "profile-menu-item-click-target",
        title: title
      }, itemLabel, itemStatus, clickAffordance);
    }

    if (linkTo) return React__default.createElement(Link$1, {
      className: "profile-menu-item link-item " + itemTypeClass,
      "data-testid": "profile-menu-item-click-target",
      to: linkTo || "",
      onClick: onClick,
      title: title
    }, itemLabel, itemStatus, clickAffordance);
    return React__default.createElement("button", {
      className: "profile-menu-item button-item " + itemTypeClass,
      "data-testid": "profile-menu-item-click-target",
      onClick: onClick,
      title: title
    }, itemLabel, itemStatus, clickAffordance);
  }, [status, linkTo, onClick, title, itemLabel, itemStatus, clickAffordance]); //
  //
  //

  return React__default.createElement(MenuItemWrapper, Object.assign({
    className: "profile-menu-item-wrapper",
    "data-testid": testId || "profile-menu-item-wrapper"
  }, rest), React__default.createElement(MenuItemClickTargetWrapper, null, clickTarget));
};

var MenuItemWrapper =
/*#__PURE__*/
styled.li(
/*#__PURE__*/
_templateObject$o());
var clickTargetBaseProps =
/*#__PURE__*/
css(
/*#__PURE__*/
_templateObject2$g(), gray300$1, blue150, blue200);
var cutoffText$1 =
/*#__PURE__*/
css(
/*#__PURE__*/
_templateObject3$b()); // Simple fix in order to prevent an issue with styled-components
// when trying to created styled extension on top of the react-router-dom
// Link component

var MenuItemClickTargetWrapper =
/*#__PURE__*/
styled.div(
/*#__PURE__*/
_templateObject4$7(), clickTargetBaseProps, cutoffText$1, clickTargetBaseProps, cutoffText$1); // Content inside the menu item -- label, status, and click affordance

var MenuItemLabel =
/*#__PURE__*/
styled.div(
/*#__PURE__*/
_templateObject5$3(), gray600$1, cutoffText$1);
var MenuItemStatus =
/*#__PURE__*/
styled.div(
/*#__PURE__*/
_templateObject6$1(), gray700$1, cutoffText$1);
var MenuItemClickAffordance =
/*#__PURE__*/
styled.div(
/*#__PURE__*/
_templateObject7$1(), gray400$1);

function _templateObject$p() {
  var data = _taggedTemplateLiteralLoose(["\n  position: relative;\n  margin: 0 -16px;\n  width: 360px;\n\n  & > ul {\n    margin: 32px 0 -32px;\n    list-style-type: none;\n    width: 100%;\n  }\n"]);

  _templateObject$p = function _templateObject() {
    return data;
  };

  return data;
}

var ProfileMenu$1 = function ProfileMenu(props) {
  // Destructure props
  var firstName = props.firstName,
      lastName = props.lastName,
      companyName = props.companyName,
      children = props.children,
      className = props.className,
      menuClassName = props.menuClassName,
      userInfoComponent = props.userInfoComponent,
      menuIcon = props.menuIcon;

  var renderUserInfo = function renderUserInfo() {
    var UserInfo = userInfoComponent || UserInfoSection;
    return React__default.createElement(UserInfo, {
      firstName: firstName,
      lastName: lastName,
      companyName: companyName
    });
  };

  return React__default.createElement(UpgradedDropdown, {
    className: "profile-menu " + (className || "")
  }, React__default.createElement(UpgradedDropdown.ToggleButton, null, React__default.createElement(UpgradedDropdown.Icon, {
    className: menuIcon || "fa fa-user-circle-o"
  })), React__default.createElement(StyledDropdownMenu$1, {
    right: true,
    className: "profile-menu-dropdown " + (menuClassName || "")
  }, React__default.createElement(MenuInnerWrapper, {
    className: "profile-menu-inner-wrapper"
  }, renderUserInfo(), React__default.createElement("ul", {
    className: "menu-item-list"
  }, children))));
};

ProfileMenu$1.Item = ProfileMenuItem;

var MenuInnerWrapper =
/*#__PURE__*/
styled.div(
/*#__PURE__*/
_templateObject$p());

function _templateObject2$h() {
  var data = _taggedTemplateLiteralLoose(["\n  background-color: #ffffff;\n  border-color: #e5e5e5;\n  margin: 0;\n  padding: 0;\n  position: relative;\n  display: \"block\";\n  &::before {\n    content: \"\";\n    display: block;\n    position: absolute;\n    z-index: 1;\n    left: 18px;\n    top: 0;\n    bottom: 0;\n    border: 1px dotted #9dbdd6;\n    border-width: 0 0 0 1px;\n  }\n  & > li > a {\n    background-color: #ffffff;\n    color: #616161;\n  }\n\n  & li:not(:first-of-type) {\n    border-top-color: #e4e4e4;\n    border-top-style: dotted;\n  }\n\n  & li > & > li:not(.active) a:not(:hover) {\n    color: #757575;\n  }\n\n  & li > & > li > a {\n    margin-left: 5px;\n  }\n  & > li a > i {\n    font-size: 12px;\n    line-height: 17px;\n    vertical-align: top;\n  }\n\n  & > li::before {\n    content: \"\";\n    display: inline-block;\n    position: absolute;\n    z-index: 1;\n    width: 7px;\n    left: 20px;\n    top: 17px;\n    border-top: 1px dotted #9dbdd6;\n  }\n\n  & > li & > li::before {\n    display: none;\n  }\n"]);

  _templateObject2$h = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$q() {
  var data = _taggedTemplateLiteralLoose(["\n  display: block;\n  width: 14px !important;\n  height: 14px;\n  line-height: 14px;\n  text-shadow: none;\n  font-size: 18px;\n  position: absolute;\n  right: 10px;\n  top: 12px;\n  padding: 0;\n  text-align: center;\n"]);

  _templateObject$q = function _templateObject() {
    return data;
  };

  return data;
}
var ContainerArrow$1 =
/*#__PURE__*/
styled.b.attrs(function () {
  return {
    className: "fa fa-angle-down"
  };
})(
/*#__PURE__*/
_templateObject$q());
var StyledContainerMenuList$1 =
/*#__PURE__*/
styled.ul(
/*#__PURE__*/
_templateObject2$h());

function ContainerMenuList$1(_ref) {
  var children = _ref.children,
      props = _objectWithoutPropertiesLoose(_ref, ["children"]);

  return createElement(StyledContainerMenuList$1, Object.assign({}, props), children);
}

function _templateObject$r() {
  var data = _taggedTemplateLiteralLoose(["\n  display: block;\n  position: relative;\n  float: none;\n  padding: 0;\n  border-style: solid;\n  border-width: 1px 0px 0px;\n  border-color: rgb(224, 224, 224);\n  margin: 0;\n  &.active > a {\n    font-weight: 700;\n    color: ", ";\n  }\n\n  &.active::after {\n    display: block;\n    content: \"\";\n    position: absolute;\n    right: -2px;\n    top: -1px;\n    bottom: 0;\n    z-index: 1;\n    border: 2px solid ", ";\n    border-width: 0 2px 0 0;\n  }\n"]);

  _templateObject$r = function _templateObject() {
    return data;
  };

  return data;
}
var SidebarMenuItem$1 =
/*#__PURE__*/
styled.li.attrs(function () {
  return {
    "data-testid": "sidebar-menu-item"
  };
})(
/*#__PURE__*/
_templateObject$r(), function (props) {
  return props.theme.primaryColor;
}, function (props) {
  return props.theme.primaryColor;
});

function _templateObject2$i() {
  var data = _taggedTemplateLiteralLoose(["\n  font-size: 18px;\n  display: inline-block;\n  min-width: 30px;\n  margin-right: 2px;\n  vertical-align: sub;\n  text-align: center;\n  font-weight: 400;\n"]);

  _templateObject2$i = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$s() {
  var data = _taggedTemplateLiteralLoose(["\n  font-size: 13px;\n  margin: 0;\n  padding-left: 7px;\n  padding-top: 8px;\n  padding-bottom: 8px;\n  display: block;\n  height: 39px;\n  line-height: 20px;\n  text-shadow: none;\n  position: relative;\n\n  &,\n  &:visited,\n  &:focus,\n  &:active,\n  &:hover {\n    color: rgb(64, 64, 64);\n    text-decoration: none;\n  }\n  &:hover {\n    background-color: #f0f0f0;\n    font-weight: 700;\n    color: ", ";\n  }\n"]);

  _templateObject$s = function _templateObject() {
    return data;
  };

  return data;
}
var SidebarMenuItemLink$1 =
/*#__PURE__*/
styled(Link)(
/*#__PURE__*/
_templateObject$s(), function (props) {
  return props.theme.primaryColor;
});
var SidebarMenuItemIcon$1 =
/*#__PURE__*/
styled.i(
/*#__PURE__*/
_templateObject2$i());

function isSidebarLinkMenuItemActive$1(to, toAlternatives, windowLocationPathname) {
  if (windowLocationPathname === void 0) {
    windowLocationPathname = window.location.pathname;
  }

  return windowLocationPathname.toLowerCase() === to.toLowerCase() || toAlternatives && toAlternatives.some(function (t) {
    return windowLocationPathname.toLowerCase().startsWith(t.toLowerCase());
  });
}
function SidebarLinkMenuItem$1(_ref) {
  var children = _ref.children,
      to = _ref.to,
      toAlternatives = _ref.toAlternatives,
      iconClassName = _ref.iconClassName,
      className = _ref.className,
      onClick = _ref.onClick,
      renderHtmlAnchor = _ref.renderHtmlAnchor,
      _ref$windowLocationPa = _ref.windowLocationPathname,
      windowLocationPathname = _ref$windowLocationPa === void 0 ? window.location.pathname : _ref$windowLocationPa;
  return createElement(SidebarMenuItem$1, {
    className: classNames({
      active: isSidebarLinkMenuItemActive$1(to, toAlternatives, windowLocationPathname)
    })
  }, createElement(SidebarMenuItemLink$1, {
    onClick: onClick,
    className: className,
    to: to,
    renderHtmlAnchor: renderHtmlAnchor
  }, iconClassName && createElement(SidebarMenuItemIcon$1, {
    className: iconClassName
  }), createElement("span", null, children)));
}

var SidebarContainerMenuItem$1 =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(SidebarContainerMenuItem, _React$Component);

  function SidebarContainerMenuItem(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;

    _this.close = function () {
      _this.setState(function (prevState, props) {
        return {
          isOpen: false
        };
      });
    };

    _this.hasAnActiveDescendant = function (children) {
      if (Array.isArray(children)) return children.some(function (i) {
        return i.type === SidebarLinkMenuItem$1 && _this.isSidebarLinkMenuItemActive(i.props) || i.type === SidebarContainerMenuItem && _this.hasAnActiveDescendant(i.props.children);
      });else return _this.isSidebarLinkMenuItemActive(children.props) || false;
    };

    _this.isSidebarLinkMenuItemActive = function (_ref) {
      var to = _ref.to,
          toAlternatives = _ref.toAlternatives,
          windowLocationPathname = _ref.windowLocationPathname;
      return isSidebarLinkMenuItemActive$1(to, toAlternatives, windowLocationPathname);
    };

    _this.handleDropdownToggleClick = function (e) {
      e.preventDefault();

      _this.setState(function (prevState, props) {
        var isOpen = !prevState.isOpen;
        if (isOpen) containerSingularOpenManager.handleOnOpen(_this.props.name);
        return {
          isOpen: isOpen
        };
      });
    };

    containerSingularOpenManager.addCloseCallback(props.name, _this.close);

    var hasAnActiveDescendant = _this.hasAnActiveDescendant(props.children);

    _this.state = {
      isActive: hasAnActiveDescendant,
      isOpen: hasAnActiveDescendant
    };
    return _this;
  }

  var _proto = SidebarContainerMenuItem.prototype;

  _proto.render = function render() {
    return createElement(SidebarMenuItem$1, {
      className: classNames({
        active: this.state.isActive
      })
    }, createElement(SidebarMenuItemLink$1, {
      renderHtmlAnchor: this.props.renderHtmlAnchor,
      to: "#",
      onClick: this.handleDropdownToggleClick
    }, this.props.iconClassName && createElement(SidebarMenuItemIcon$1, {
      className: this.props.iconClassName
    }), createElement("span", {
      className: "container-menu-text"
    }, this.props.name), createElement(ContainerArrow$1, null)), createElement(Collapse, {
      "data-testid": "collapse",
      "in": this.state.isOpen
    }, createElement(ContainerMenuList$1, null, this.props.children)));
  };

  return SidebarContainerMenuItem;
}(Component);
SidebarContainerMenuItem$1.defaultProps = {
  windowLocationPathname: window.location.pathname
};

function _templateObject$t() {
  var data = _taggedTemplateLiteralLoose(["\n  margin: 0px;\n  padding: 0;\n  list-style: none;\n  & > li {\n    background-color: #ffffff;\n  }\n  & > li:last-child {\n    border-bottom-width: 1px;\n  }\n  & > li:hover::before {\n    display: block;\n    position: absolute;\n    top: -1px;\n    left: 0;\n    z-index: 1;\n    height: 41px;\n    width: 3px;\n    max-width: 3px;\n    overflow: hidden;\n    background-color: ", ";\n    content: \"\";\n  }\n  & > li ul {\n    line-height: 19.5px;\n  }\n  & > li ul > li > a {\n    height: 100%;\n    padding-left: 37px;\n  }\n  & > li ul > li ul > li {\n    line-height: 18px;\n  }\n"]);

  _templateObject$t = function _templateObject() {
    return data;
  };

  return data;
}
var StyledSidebarMenuList$1 =
/*#__PURE__*/
styled.ul(
/*#__PURE__*/
_templateObject$t(), function (props) {
  return props.theme.primaryColor;
});

var SidebarMenuList$1 =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(SidebarMenuList, _React$Component);

  function SidebarMenuList(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    var children = props.children;
    if (!Array.isArray(children)) return _assertThisInitialized(_this);
    children.forEach(function (i) {
      if (i.type === SidebarContainerMenuItem$1) containerSingularOpenManager.addContainer(i.props.name);
    });
    return _this;
  }

  var _proto = SidebarMenuList.prototype;

  _proto.render = function render() {
    return createElement(StyledSidebarMenuList$1, null, this.props.children);
  };

  return SidebarMenuList;
}(Component);

function _templateObject2$j() {
  var data = _taggedTemplateLiteralLoose(["\n  padding: 0 5px;\n  line-height: 18px;\n  cursor: pointer;\n  font-size: 14px;\n  border-radius: 100%;\n  position: relative;\n  background-color: white;\n  color: rgb(170, 170, 170);\n  border-width: 1px;\n  border-style: solid;\n  border-color: rgb(224, 224, 224);\n  border-image: initial;\n"]);

  _templateObject2$j = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$u() {
  var data = _taggedTemplateLiteralLoose(["\n  border-style: solid;\n  border-width: 0 0 1px;\n  text-align: center;\n  padding: 3px 0;\n  position: relative;\n  border-color: #e0e0e0;\n  &::before {\n    content: \"\";\n    display: block;\n    height: 0;\n\n    border-top: 1px solid;\n    border-color: inherit;\n    position: absolute;\n    left: 15px;\n    right: 15px;\n    top: 13px;\n  }\n"]);

  _templateObject$u = function _templateObject() {
    return data;
  };

  return data;
}
var SidebarToggleContainer$1 =
/*#__PURE__*/
styled.div(
/*#__PURE__*/
_templateObject$u());
var SidebarToggleIcon$1 =
/*#__PURE__*/
styled.i(
/*#__PURE__*/
_templateObject2$j());

var SidebarToggle$1 =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(SidebarToggle, _React$Component);

  function SidebarToggle() {
    var _this;

    _this = _React$Component.apply(this, arguments) || this;

    _this.toggleExistingLayoutContainer = function (expand) {
      var sidebarContainer = document.getElementById("sidebar-container");
      if (sidebarContainer === null) return;
      if (expand) sidebarContainer.classList.remove("menu-min");else sidebarContainer.classList.add("menu-min");
    };

    return _this;
  }

  var _proto = SidebarToggle.prototype;

  _proto.render = function render() {
    return createElement(SidebarToggleContainer$1, null, createElement(SidebarToggleIcon$1, {
      onClick: this.props.onToggle,
      className: classNames({
        "fa fa-angle-double-left": this.props.sidebarExpanded,
        "fa fa-angle-double-right": !this.props.sidebarExpanded
      })
    }));
  };

  return SidebarToggle;
}(Component);

function _templateObject$v() {
  var data = _taggedTemplateLiteralLoose(["\n  width: 190px;\n  background-color: #fff;\n  line-height: normal;\n  height: calc(100% - 2px);\n  border-right: 2px solid #ececec;\n\n  > ul > li:first-child {\n    border-top-width: 0 !important;\n  }\n\n  &.menu-min {\n    width: 42px;\n\n    > ul > li > a > span {\n      display: none;\n      position: absolute;\n      height: 39px;\n      line-height: 38px;\n      background-color: #f5f5f5;\n      z-index: 121;\n      box-shadow: 2px 1px 2px 0 rgba(0, 0, 0, 0.2);\n      padding-left: 12px;\n      border: 1px solid #ccc;\n      top: -1px;\n      left: 42px;\n      width: 173px;\n      border-bottom: 1px solid #ddd;\n    }\n\n    > ul > li > a > span.container-menu-text {\n      border: none;\n      box-shadow: none;\n      border-bottom: 1px solid #ddd;\n    }\n\n    > ul > li ul::before,\n    > ul > li ul li::before,\n    > ul > li > a > b,\n    > ul > li ul i {\n      display: none;\n    }\n\n    > ul > li > ul {\n      background: #fff;\n      position: absolute;\n      z-index: 120;\n      left: 41px;\n      top: -2px;\n      width: 175px;\n      border: 1px solid #ccc;\n      box-shadow: 2px 1px 2px 0 rgba(0, 0, 0, 0.2);\n      padding-top: 38px;\n      padding-bottom: 2px;\n      display: none;\n    }\n\n    > ul > li > ul > li > a {\n      padding: 7px 0 8px 24px;\n    }\n\n    > ul > li:hover > a > span,\n    > ul > li:hover > ul {\n      display: block;\n    }\n  }\n"]);

  _templateObject$v = function _templateObject() {
    return data;
  };

  return data;
}
var Nav$3 =
/*#__PURE__*/
styled.nav(
/*#__PURE__*/
_templateObject$v()); //Interesting logic to support existing pages layout scenario

var Sidebar$1 =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Sidebar, _React$Component);

  function Sidebar(props) {
    var _props$sidebarExpande;

    var _this;

    _this = _React$Component.call(this, props) || this;

    _this.handleToggle = function () {
      _this.setState(function (prevState, props) {
        var newState = !prevState.sidebarExpanded;
        return {
          sidebarExpanded: newState
        };
      });
    };

    _this.state = {
      sidebarExpanded: (_props$sidebarExpande = props.sidebarExpanded) !== null && _props$sidebarExpande !== void 0 ? _props$sidebarExpande : props.viewportWidth > 1024
    };
    return _this;
  }

  var _proto = Sidebar.prototype;

  _proto.render = function render() {
    return createElement(Nav$3, {
      style: {
        minHeight: "calc(100vh - " + this.props.navbarHeight + ")"
      },
      className: this.props.sidebarExpanded !== undefined ? classNames({
        "menu-min": !this.props.sidebarExpanded
      }) : classNames({
        "menu-min": !this.state.sidebarExpanded
      })
    }, createElement(SidebarMenuList$1, null, this.props.children), createElement(SidebarToggle$1, {
      onToggle: this.props.sidebarExpanded !== undefined ? this.props.onToggle : this.handleToggle,
      sidebarExpanded: this.props.sidebarExpanded !== undefined ? this.props.sidebarExpanded : this.state.sidebarExpanded
    }));
  };

  return Sidebar;
}(Component);
Sidebar$1.defaultProps = {
  viewportWidth:
  /*#__PURE__*/
  Math.max(document.documentElement.clientWidth, window.innerWidth || 0),
  navbarHeight: "47px"
};

function _templateObject2$k() {
  var data = _taggedTemplateLiteralLoose(["\n  display: block;\n  font-size: 1.22rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  margin: 0 0 12px 0;\n  color: ", ";\n"]);

  _templateObject2$k = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$w() {
  var data = _taggedTemplateLiteralLoose(["\n  width: 19.5px;\n  margin-right: 10px;\n"]);

  _templateObject$w = function _templateObject() {
    return data;
  };

  return data;
}
var Icon$3 =
/*#__PURE__*/
styled.i(
/*#__PURE__*/
_templateObject$w());
var MenuHeading =
/*#__PURE__*/
styled.div(
/*#__PURE__*/
_templateObject2$k(), gray600$1);
function DropdownMenuHeading(_ref) {
  var iconClassName = _ref.iconClassName,
      children = _ref.children;
  return createElement(MenuHeading, {
    className: "dropdown-menu-heading"
  }, iconClassName && createElement(Icon$3, {
    className: iconClassName
  }), children);
}

function _templateObject3$c() {
  var data = _taggedTemplateLiteralLoose(["\n  background-color: ", ";\n"]);

  _templateObject3$c = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$l() {
  var data = _taggedTemplateLiteralLoose(["\n  width: 100%;\n"]);

  _templateObject2$l = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$x() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: row;\n"]);

  _templateObject$x = function _templateObject() {
    return data;
  };

  return data;
}
var SidebarAndMainContainer$1 =
/*#__PURE__*/
styled("div")(
/*#__PURE__*/
_templateObject$x());
var StyledMain$1 =
/*#__PURE__*/
styled.main(
/*#__PURE__*/
_templateObject2$l());
var BackgroundColorDiv =
/*#__PURE__*/
styled.div(
/*#__PURE__*/
_templateObject3$c(), gray200$1);

var Layout$1 =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Layout, _React$Component);

  function Layout() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Layout.prototype;

  _proto.render = function render() {
    return createElement(BackgroundColorDiv, {
      className: "background-color-div"
    }, this.props.navbar, createElement(SidebarAndMainContainer$1, {
      id: "sidebar-and-main-container"
    }, createElement("div", {
      id: "sidebar-container"
    }, this.props.sidebar), createElement(StyledMain$1, null, this.props.mainContent, this.props.footer)));
  };

  return Layout;
}(Component);
Layout$1.Navbar = Navbar$1;
Layout$1.DropdownMenuItem = HcssDropdownMenuItem;
Layout$1.DropdownMenuHeading = DropdownMenuHeading;
Layout$1.DropdownDivider = Divider$1;
Layout$1.HamburgerMenu = HamburgerMenu$1;
Layout$1.HamburgerMenuItem = HamburgerMenuItem$1;
Layout$1.HelpMenu = HelpMenu$1;
Layout$1.ProfileMenu = ProfileMenu$1;
Layout$1.Sidebar = Sidebar$1;
Layout$1.SidebarLinkMenuItem = SidebarLinkMenuItem$1;
Layout$1.SidebarContainerMenuItem = SidebarContainerMenuItem$1;
Layout$1.NavMenu = NavMenu;
Layout$1.Dropdown = UpgradedDropdown;

var BreadcrumbItem = function BreadcrumbItem(props) {
  var other = _objectWithoutPropertiesLoose(props, ["className"]);

  if (other.to) {
    return createElement("li", {
      className: "breadcrumb-item"
    }, createElement(Link, Object.assign({
      className: classNames("breadcrumb-link", props.className)
    }, other), props.children));
  }

  return createElement("li", {
    className: "breadcrumb-item"
  }, props.children);
};

function _templateObject$y() {
  var data = _taggedTemplateLiteralLoose(["\n  & > .breadcrumb {\n    margin: 10px 0 10px;\n    font-size: 13px;\n    padding: 0;\n    background-color: unset;\n\n    > i {\n      font-size: 18px;\n    }\n\n    > li:last-child {\n      font-weight: bold;\n    }\n  }\n  & > .breadcrumb > li {\n    padding: 0 3px;\n  }\n  & > .breadcrumb > li > a {\n    color: #0370f5;\n  }\n  & > .breadcrumb > li + li:before {\n    font-family: FontAwesome;\n    font-size: 14px;\n    content: \"\f105\";\n    color: ", ";\n    padding: 0;\n    margin-right: 6px;\n    font-weight: normal;\n  }\n"], ["\n  & > .breadcrumb {\n    margin: 10px 0 10px;\n    font-size: 13px;\n    padding: 0;\n    background-color: unset;\n\n    > i {\n      font-size: 18px;\n    }\n\n    > li:last-child {\n      font-weight: bold;\n    }\n  }\n  & > .breadcrumb > li {\n    padding: 0 3px;\n  }\n  & > .breadcrumb > li > a {\n    color: #0370f5;\n  }\n  & > .breadcrumb > li + li:before {\n    font-family: FontAwesome;\n    font-size: 14px;\n    content: \"\\f105\";\n    color: ", ";\n    padding: 0;\n    margin-right: 6px;\n    font-weight: normal;\n  }\n"]);

  _templateObject$y = function _templateObject() {
    return data;
  };

  return data;
}
var BreadcrumbsWrapper =
/*#__PURE__*/
styled("div")(
/*#__PURE__*/
_templateObject$y(), gray600);

var Breadcrumbs =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Breadcrumbs, _React$Component);

  function Breadcrumbs() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Breadcrumbs.prototype;

  _proto.render = function render() {
    return createElement(BreadcrumbsWrapper, null, createElement("ul", {
      className: "breadcrumb"
    }, this.props.iconName && createElement(Icon$1, {
      name: this.props.iconName,
      margin: "right"
    }), this.props.children));
  };

  return Breadcrumbs;
}(Component);
Breadcrumbs.defaultProps = {};
Breadcrumbs.Item = BreadcrumbItem;

function _templateObject2$m() {
  var data = _taggedTemplateLiteralLoose(["\n  display: inline-flex;\n  flex-direction: row;\n  flex-wrap: nowrap;\n  align-items: center;\n  border-radius: 100px;\n  font-size: 1.25rem;\n  letter-spacing: 0.06rem;\n  line-height: normal;\n  text-transform: uppercase;\n  padding: 5px 20px;\n\n  /*\n    Standard (pre-interaction) colors\n    - If hcssStyle prop is supplied a value, it takes precedence\n    - Otherwise, use the custom color values, if supplied, or use the default accent blue and default white text color\n  */\n  &:not(:disabled) {\n    font-weight: 800;\n    background-color: ", ";\n    border-color: ", ";\n    color: ", ";\n  }\n\n  /* Hover-state colors */\n  &:not(:disabled):hover {\n    background-color: ", ";\n    border-color: ", ";\n    color: ", ";\n  }\n\n  /* Active-state and focus-state colors */\n  &:not(:disabled):active,\n  &:not(:disabled):focus {\n    outline: none;\n    background-color: ", ";\n    border-color: ", ";\n    color: ", ";\n  }\n\n  &,\n  &:hover,\n  &:active,\n  &:focus {\n    box-shadow: none;\n    cursor: pointer;\n  }\n\n  &:disabled,\n  &:disabled:hover,\n  &:disabled:active &:disabled:focus {\n    background: ", ";\n    border-color: ", ";\n    color: ", ";\n    font-weight: 600;\n    opacity: 1;\n    cursor: not-allowed;\n  }\n\n  &.btn-sm {\n    font-size: 1.1rem;\n    padding: 4px 16px;\n  }\n\n  &.btn-lg {\n    font-size: 1.6rem;\n    padding: 8px 50px;\n  }\n\n  & > i {\n    height: 15px;\n    font-size: 1.22rem;\n  }\n"]);

  _templateObject2$m = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$z() {
  var data = _taggedTemplateLiteralLoose(["\n  border-radius: 0;\n  border-width: 1px;\n  border-color: ", ";\n  background-color: ", ";\n  color: ", ";\n  :hover:not(.btn-link) {\n    box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14),\n      0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 1px 5px 0 rgba(0, 0, 0, 0.12);\n    background-color: ", ";\n    border-color: ", ";\n    color: ", ";\n  }\n  :active {\n    background-color: ", ";\n    border-color: ", ";\n    box-shadow: none;\n    color: ", ";\n  }\n  :focus {\n    background-color: ", ";\n    border-color: ", ";\n    color: ", ";\n  }\n  :active:focus {\n    background-color: ", ";\n    border-color: ", ";\n    color: ", ";\n  }\n  :disabled,\n  :disabled:hover {\n    background-color: #f9f9f9;\n    color: #696969;\n    border-color: #ccc;\n    opacity: 1;\n    box-shadow: none;\n  }\n"]);

  _templateObject$z = function _templateObject() {
    return data;
  };

  return data;
}

var ButtonStyle =
/*#__PURE__*/
styled(function (_ref) {
  var rest = _objectWithoutPropertiesLoose(_ref, ["buttontextcolor", "buttonbackgroundcolor", "buttonbordercolor"]);

  return createElement(Button$1, Object.assign({}, rest));
})(
/*#__PURE__*/
_templateObject$z(), function (props) {
  return props.buttonbordercolor;
}, function (props) {
  return props.buttonbackgroundcolor;
}, function (props) {
  return props.buttontextcolor;
}, function (props) {
  return props.buttonbackgroundcolor;
}, function (props) {
  return props.buttonbordercolor;
}, function (props) {
  return props.buttontextcolor;
}, function (props) {
  return props.buttonbackgroundcolor;
}, function (props) {
  return props.buttonbordercolor;
}, function (props) {
  return props.buttontextcolor;
}, function (props) {
  return props.buttonbackgroundcolor;
}, function (props) {
  return props.buttonbordercolor;
}, function (props) {
  return props.buttontextcolor;
}, function (props) {
  return props.buttonbackgroundcolor;
}, function (props) {
  return props.buttonbordercolor;
}, function (props) {
  return props.buttontextcolor;
});
function Button(_ref2) {
  var children = _ref2.children,
      theme = _ref2.theme,
      testId = _ref2.testId,
      hcssStyle = _ref2.hcssStyle,
      backgroundColor = _ref2.backgroundColor,
      color = _ref2.color,
      props = _objectWithoutPropertiesLoose(_ref2, ["children", "theme", "testId", "hcssStyle", "backgroundColor", "color"]);

  var buttonColor = theme && theme.buttonColor ? theme.buttonColor : gray800;
  var buttontextcolor = "white";
  var buttonbackgroundcolor = buttonColor;
  var buttonbordercolor = buttonColor;
  var defaultTestId = "Button";

  if (theme && theme.baseTheme === "Ace") {
    switch (hcssStyle) {
      default:
      case "Theme":
        buttontextcolor = "white";
        buttonbackgroundcolor = buttonColor;
        buttonbordercolor = buttonColor;
        break;

      case "ThemeInverted":
        buttontextcolor = buttonColor;
        buttonbackgroundcolor = "white";
        buttonbordercolor = buttonColor;
        break;

      case "Delete":
        buttontextcolor = "white";
        buttonbackgroundcolor = errorRed;
        buttonbordercolor = errorRed;
        break;

      case "DeleteInverted":
        buttontextcolor = errorRed;
        buttonbackgroundcolor = "white";
        buttonbordercolor = errorRed;
        break;

      case "Success":
        buttontextcolor = "white";
        buttonbackgroundcolor = successGreen;
        buttonbordercolor = successGreen;
        break;

      case "SuccessInverted":
        buttontextcolor = successGreen;
        buttonbackgroundcolor = "white";
        buttonbordercolor = successGreen;
        break;
    } // override theme color if custom colors are sent


    if (backgroundColor) {
      buttonbackgroundcolor = backgroundColor;
    }

    if (color) {
      buttontextcolor = color;
    }

    if (testId) {
      defaultTestId = testId;
    }
  }

  return createElement(Fragment, null, props.bsStyle ? createElement(ButtonStyle, Object.assign({
    "data-testid": defaultTestId
  }, props), children) : theme && theme.baseTheme === "Concrete" ? createElement(ConcreteButton, Object.assign({
    hcssStyle: hcssStyle,
    backgroundColor: backgroundColor,
    textColor: color,
    "data-testid": defaultTestId
  }, props), children) : createElement(ButtonStyle, Object.assign({
    buttontextcolor: buttontextcolor,
    buttonbackgroundcolor: buttonbackgroundcolor,
    buttonbordercolor: buttonbordercolor,
    "data-testid": defaultTestId
  }, props), children));
}
var StyledConcreteButton =
/*#__PURE__*/
styled(Button$1)(
/*#__PURE__*/
_templateObject2$m(), function (props) {
  if (props.hcssstyle) {
    if (props.hcssstyle.endsWith("Inverted")) return "white";else if (props.hcssstyle === "Theme") return blue200;else if (props.hcssstyle === "Success") return green300;else if (props.hcssstyle === "Delete") return red200;
  }

  return props.backgroundcolor || blue200;
}, function (props) {
  if (props.hcssstyle) {
    if (props.hcssstyle.startsWith("Theme")) return blue200;else if (props.hcssstyle.startsWith("Success")) return green300;else if (props.hcssstyle.startsWith("Delete")) return red200;
  }

  return props.backgroundcolor || blue200;
}, function (props) {
  if (props.hcssstyle) {
    if (!props.hcssstyle.endsWith("Inverted")) return "white";else if (props.hcssstyle === "ThemeInverted") return blue200;else if (props.hcssstyle === "SuccessInverted") return green300;else if (props.hcssstyle === "DeleteInverted") return red200;
  }

  return props.textcolor || "white";
}, function (props) {
  if (props.hcssstyle) {
    if (props.hcssstyle === "Theme") return blue300;else if (props.hcssstyle === "ThemeInverted") return blue100;else if (props.hcssstyle === "Success") return green400;else if (props.hcssstyle === "SuccessInverted") return green100;else if (props.hcssstyle === "Delete") return red300;else if (props.hcssstyle === "DeleteInverted") return red100;
  }

  return props.backgroundcolor || blue300;
}, function (props) {
  if (props.hcssstyle) {
    if (props.hcssstyle.startsWith("Theme")) return blue300;else if (props.hcssstyle.startsWith("Success")) return green400;else if (props.hcssstyle.startsWith("Delete")) return red300;
  }

  return props.backgroundcolor || blue300;
}, function (props) {
  if (props.hcssstyle) {
    if (!props.hcssstyle.endsWith("Inverted")) return "white";else if (props.hcssstyle === "ThemeInverted") return blue300;else if (props.hcssstyle === "SuccessInverted") return green400;else if (props.hcssstyle === "DeleteInverted") return red300;
  }

  return props.textcolor || "white";
}, function (props) {
  if (props.hcssstyle) {
    if (props.hcssstyle === "Theme") return blue400;else if (props.hcssstyle === "ThemeInverted") return blue100;else if (props.hcssstyle === "Success") return green500;else if (props.hcssstyle === "SuccessInverted") return green100;else if (props.hcssstyle === "Delete") return red400;else if (props.hcssstyle === "DeleteInverted") return red100;
  }

  return props.backgroundcolor || blue400;
}, function (props) {
  if (props.hcssstyle) {
    if (props.hcssstyle.startsWith("Theme")) return blue400;else if (props.hcssstyle.startsWith("Success")) return green500;else if (props.hcssstyle.startsWith("Delete")) return red400;
  }

  return props.backgroundcolor || blue400;
}, function (props) {
  if (props.hcssstyle) {
    if (!props.hcssstyle.endsWith("Inverted")) return "white";else if (props.hcssstyle === "ThemeInverted") return blue400;else if (props.hcssstyle === "SuccessInverted") return green500;else if (props.hcssstyle === "DeleteInverted") return red400;
  }

  return props.textcolor || "white";
}, gray100$1, gray400$1, gray500$1);

var ConcreteButton =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(ConcreteButton, _React$Component);

  function ConcreteButton() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = ConcreteButton.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        hcssStyle = _this$props.hcssStyle,
        textColor = _this$props.textColor,
        backgroundColor = _this$props.backgroundColor,
        rest = _objectWithoutPropertiesLoose(_this$props, ["hcssStyle", "textColor", "backgroundColor"]);

    return createElement(StyledConcreteButton, Object.assign({
      hcssstyle: hcssStyle,
      textcolor: textColor,
      backgroundcolor: backgroundColor
    }, rest), this.props.children);
  };

  return ConcreteButton;
}(Component);

var stupidVariable =
/*#__PURE__*/
withTheme(Button);

function _templateObject$A() {
  var data = _taggedTemplateLiteralLoose(["\n  border-radius: ", ";\n\n  &,\n  &:hover,\n  &:focus,\n  &:active,\n  &:active:focus,\n  .open > &.dropdown-toggle.btn-default,\n  .open > &.dropdown-toggle.btn-default:focus {\n    color: ", ";\n    border-color: ", ";\n    background-color: ", ";\n  }\n  :hover:not(:disabled) {\n    box-shadow: rgba(0, 0, 0, 0.14) 0px 2px 2px 0px,\n      rgba(0, 0, 0, 0.2) 0px 3px 1px -2px, rgba(0, 0, 0, 0.12) 0px 1px 5px 0px;\n  }\n  &.btn .caret {\n    margin-left: 5px;\n  }\n  &:disabled,\n  &:disabled:hover {\n    background-color: #f9f9f9;\n    color: #696969;\n    border-color: #ccc;\n    opacity: 1;\n    box-shadow: none;\n  }\n"]);

  _templateObject$A = function _templateObject() {
    return data;
  };

  return data;
}
var StyledDropdownButton =
/*#__PURE__*/
styled(function (_ref) {
  var rest = _objectWithoutPropertiesLoose(_ref, ["backgroundColor", "foregroundColor", "borderColor", "baseTheme"]);

  return createElement(DropdownButton$4, Object.assign({}, rest));
})(
/*#__PURE__*/
_templateObject$A(), function (props) {
  return props.baseTheme === "Concrete" ? "32px" : "0px";
}, function (props) {
  return props.foregroundColor;
}, function (props) {
  return props.borderColor;
}, function (props) {
  return props.backgroundColor;
});
function DropdownButton$3(_ref2) {
  var children = _ref2.children,
      color = _ref2.color,
      _ref2$inverted = _ref2.inverted,
      inverted = _ref2$inverted === void 0 ? false : _ref2$inverted,
      testId = _ref2.testId,
      props = _objectWithoutPropertiesLoose(_ref2, ["children", "color", "inverted", "testId"]);

  var buttonBackgroundColor = gray700$1;
  var buttonForegroundColor = "white";
  var buttonBorderColor = gray700$1;
  var defaultTestId = "DropdownButton";

  if (color) {
    buttonBackgroundColor = color;
    buttonBorderColor = color;
  } else if (props.theme && props.theme.buttonColor) {
    buttonBackgroundColor = props.theme.buttonColor;
    buttonBorderColor = props.theme.buttonColor;
  }

  if (inverted) {
    buttonForegroundColor = buttonBackgroundColor;
    buttonBackgroundColor = "white";
  }

  var baseTheme = "";

  if (props.theme) {
    baseTheme = props.theme.baseTheme;
  }

  if (testId) {
    defaultTestId = testId;
  }

  return createElement(Fragment, null, createElement(StyledDropdownButton, Object.assign({
    backgroundColor: buttonBackgroundColor,
    foregroundColor: buttonForegroundColor,
    borderColor: buttonBorderColor,
    baseTheme: baseTheme,
    "data-testid": defaultTestId
  }, props), children));
}
var ThemedDropdownButton =
/*#__PURE__*/
withTheme(DropdownButton$3);

var PaneledPageContext =
/*#__PURE__*/
createContext({});

function _templateObject5$4() {
  var data = _taggedTemplateLiteralLoose(["\n  position: relative;\n  margin-top: 12px;\n  padding: 10x 16px;\n  transition: 0.2s;\n\n  @media print {\n    display: none;\n  }\n\n  & > .filters-content {\n    font-size: 0.92em;\n  }\n\n  &[data-panel-expanded=\"true\"] {\n    background: #ffffff;\n    .filters-content {\n      padding-top: 10px;\n      padding-bottom: 20px;\n      background: #ffffff;\n      box-shadow: -8px 16px 20px -12px #aaaaaa, 8px 16px 20px -12px #aaaaaa;\n      overflow: visible;\n    }\n  }\n  &[data-panel-expanded=\"false\"] {\n    background: #d6d6d6;\n    & > .filters-controls {\n      & > .filters-collapsed-toggle-region {\n        position: absolute;\n        top: 0;\n        left: 0;\n        width: 100%;\n        height: 100%;\n        cursor: pointer;\n        z-index: 0;\n      }\n    }\n    .filters-content {\n      max-height: 0;\n      background: #d6d6d6;\n      box-shadow: none;\n      overflow: hidden;\n    }\n  }\n\n  & > .filters-controls {\n    padding: 10px 0;\n    overflow: auto;\n\n    & > .filters-controls-toggle,\n    & > .filters-controls-label,\n    & > .filters-controls-status {\n      position: relative;\n      cursor: pointer;\n      z-index: 2;\n    }\n\n    & > .filters-controls-toggle {\n      font-size: 1em;\n      margin-top: ", ";\n      margin-right: 10px;\n      vertical-align: text-top;\n    }\n    & > .filters-controls-label {\n      margin-right: 4px;\n      font-size: 0.85em;\n      font-weight: ", ";\n      text-transform: uppercase;\n      &:hover {\n        text-decoration: underline;\n      }\n    }\n    & > .filters-controls-status {\n      font-size: 0.9em;\n    }\n  }\n\n  & > .filters-content {\n    position: absolute;\n    left: 0;\n    width: 100%;\n    transition: 0.2s;\n    z-index: 50;\n  }\n\n  &.default-content-padding {\n    & > .filters-content {\n      padding-left: 20px;\n      padding-right: 20px;\n    }\n  }\n"]);

  _templateObject5$4 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$8() {
  var data = _taggedTemplateLiteralLoose(["\n  margin: 16px auto 8px auto;\n  @media print {\n    display: none;\n  }\n"]);

  _templateObject4$8 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$d() {
  var data = _taggedTemplateLiteralLoose(["\n  font-size: 0.92em;\n  @media print {\n    margin-bottom: 10px;\n  }\n"]);

  _templateObject3$d = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$n() {
  var data = _taggedTemplateLiteralLoose(["\n  margin: 6px auto;\n  border-bottom: none;\n\n  & > h1 {\n    margin: 0;\n    padding: 0;\n    font-size: 1.1em;\n    font-weight: 700;\n    color: #000000;\n  }\n\n  @media print {\n    & > h1 {\n      font-size: 22px;\n      margin-bottom: 12px;\n    }\n  }\n"]);

  _templateObject2$n = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$B() {
  var data = _taggedTemplateLiteralLoose(["\n  background: ", ";\n  border-bottom: 2px solid ", ";\n  z-index: 1;\n\n  & > div {\n    padding: 0 16px;\n  }\n  & > div:first-child {\n    padding-top: 10px;\n    margin-bottom: 4px;\n    border-bottom: none;\n    padding-bottom: 0;\n  }\n  & > div:last-child:not(.header-panel-filters) {\n    padding-bottom: 10px;\n  }\n\n  & > * {\n    max-width: ", ";\n  }\n\n  &[data-content-align=\"center\"] > * {\n    margin-left: auto;\n    margin-right: auto;\n  }\n  &[data-content-align=\"left\"] > * {\n    margin-left: 0;\n    margin-right: auto;\n  }\n"]);

  _templateObject$B = function _templateObject() {
    return data;
  };

  return data;
}
var HeaderPanelTitle =
/*#__PURE__*/
function (_React$PureComponent) {
  _inheritsLoose(HeaderPanelTitle, _React$PureComponent);

  function HeaderPanelTitle() {
    return _React$PureComponent.apply(this, arguments) || this;
  }

  var _proto = HeaderPanelTitle.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        children = _this$props.children,
        passThroughProps = _this$props.passThroughProps;
    return createElement(StyledHeaderPanelTitle, Object.assign({
      className: "header-panel-title",
      "data-testid": this.props.testId || "paneledpage-header-title"
    }, passThroughProps), createElement("h1", null, children));
  };

  return HeaderPanelTitle;
}(PureComponent);
var HeaderPanelSubtitle =
/*#__PURE__*/
function (_React$PureComponent2) {
  _inheritsLoose(HeaderPanelSubtitle, _React$PureComponent2);

  function HeaderPanelSubtitle() {
    return _React$PureComponent2.apply(this, arguments) || this;
  }

  var _proto2 = HeaderPanelSubtitle.prototype;

  _proto2.render = function render() {
    var _this$props2 = this.props,
        children = _this$props2.children,
        passThroughProps = _this$props2.passThroughProps;
    return createElement(StyledHeaderPanelSubtitle, Object.assign({
      className: "header-panel-subtitle",
      "data-testid": this.props.testId || "paneledpage-header-subtitle"
    }, passThroughProps), children);
  };

  return HeaderPanelSubtitle;
}(PureComponent);
var HeaderPanelTools =
/*#__PURE__*/
function (_React$PureComponent3) {
  _inheritsLoose(HeaderPanelTools, _React$PureComponent3);

  function HeaderPanelTools() {
    return _React$PureComponent3.apply(this, arguments) || this;
  }

  var _proto3 = HeaderPanelTools.prototype;

  _proto3.render = function render() {
    var _this$props3 = this.props,
        children = _this$props3.children,
        passThroughProps = _this$props3.passThroughProps;
    return createElement(StyledHeaderPanelTools, Object.assign({
      className: "header-panel-tools",
      "data-testid": this.props.testId || "paneledpage-header-tools"
    }, passThroughProps), children);
  };

  return HeaderPanelTools;
}(PureComponent);
var HeaderPanelFiltersTemplate =
/*#__PURE__*/
function (_React$PureComponent4) {
  _inheritsLoose(HeaderPanelFiltersTemplate, _React$PureComponent4);

  function HeaderPanelFiltersTemplate() {
    return _React$PureComponent4.apply(this, arguments) || this;
  }

  var _proto4 = HeaderPanelFiltersTemplate.prototype;

  _proto4.render = function render() {
    var _this = this;

    return createElement(PaneledPageContext.Consumer, null, function (pageContext) {
      return createElement(HeaderPanelFilters, Object.assign({
        pageContext: pageContext
      }, _this.props));
    });
  };

  return HeaderPanelFiltersTemplate;
}(PureComponent);

var HeaderPanelFilters =
/*#__PURE__*/
function (_React$PureComponent5) {
  _inheritsLoose(HeaderPanelFilters, _React$PureComponent5);

  function HeaderPanelFilters() {
    return _React$PureComponent5.apply(this, arguments) || this;
  }

  var _proto5 = HeaderPanelFilters.prototype;

  _proto5.componentDidMount = function componentDidMount() {
    if (this.props.defaultExpanded && this.props.pageContext.onDefaultExpandFilters) this.props.pageContext.onDefaultExpandFilters();
  };

  _proto5.render = function render() {
    var pageContext = this.props.pageContext;
    return createElement(StyledFiltersPanelContainer, Object.assign({
      className: "header-panel-filters " + (this.props.defaultContentPadding ? "default-content-padding" : ""),
      "data-dropdown-open": pageContext.filtersHasOpenDropdown,
      "data-panel-expanded": pageContext.filtersPanelExpanded,
      "data-testid": this.props.testId || "paneledpage-header-filters"
    }, this.props.passThroughProps), this.props.templateTools && createElement("div", null, "This feature is not yet supported."), createElement("div", {
      className: "filters-controls"
    }, !pageContext.filtersPanelExpanded && createElement("div", {
      className: "filters-collapsed-toggle-region",
      onClick: pageContext.onToggleFiltersPanel
    }), createElement("i", {
      className: "filters-controls-toggle fa fa-filter",
      onClick: pageContext.onToggleFiltersPanel
    }), createElement("span", {
      className: "filters-controls-label",
      onClick: pageContext.onToggleFiltersPanel
    }, this.props.panelLabel || "Filters"), this.props.status && createElement("div", {
      className: "filters-controls-status"
    }, this.props.status || "")), createElement("div", {
      className: "filters-content"
    }, this.props.children));
  };

  return HeaderPanelFilters;
}(PureComponent);

var PageHeaderPanelTemplate =
/*#__PURE__*/
function (_React$PureComponent6) {
  _inheritsLoose(PageHeaderPanelTemplate, _React$PureComponent6);

  function PageHeaderPanelTemplate() {
    return _React$PureComponent6.apply(this, arguments) || this;
  }

  var _proto6 = PageHeaderPanelTemplate.prototype;

  _proto6.render = function render() {
    var _this$props4 = this.props,
        children = _this$props4.children,
        passThroughProps = _this$props4.passThroughProps;
    return createElement(PaneledPageContext.Consumer, null, function (pageContext) {
      return createElement(StyledPageHeaderPanel, Object.assign({
        className: "page-header-panel",
        "data-content-align": pageContext.contentAlign,
        maxpagewidth: pageContext.maxPageWidth
      }, passThroughProps), children);
    });
  };

  return PageHeaderPanelTemplate;
}(PureComponent);
PageHeaderPanelTemplate.Title = HeaderPanelTitle;
PageHeaderPanelTemplate.Subtitle = HeaderPanelSubtitle;
PageHeaderPanelTemplate.Tools = HeaderPanelTools;
PageHeaderPanelTemplate.Filters = HeaderPanelFiltersTemplate;
var StyledPageHeaderPanel =
/*#__PURE__*/
styled("div")(
/*#__PURE__*/
_templateObject$B(), gray100$1, gray300$1, function (props) {
  return props.maxpagewidth ? props.maxpagewidth + "px" : "none";
});
var StyledHeaderPanelTitle =
/*#__PURE__*/
styled("div")(
/*#__PURE__*/
_templateObject2$n());
var StyledHeaderPanelSubtitle =
/*#__PURE__*/
styled("div")(
/*#__PURE__*/
_templateObject3$d());
var StyledHeaderPanelTools =
/*#__PURE__*/
styled("div")(
/*#__PURE__*/
_templateObject4$8());
var StyledFiltersPanelContainer =
/*#__PURE__*/
styled("div")(
/*#__PURE__*/
_templateObject5$4(), function (props) {
  return props.theme.baseTheme === "Concrete" ? "1px" : "0";
}, function (props) {
  return props.theme.baseTheme === "Concrete" ? 600 : 700;
});

function _templateObject$C() {
  var data = _taggedTemplateLiteralLoose(["\n  @media print {\n    height: auto;\n    overflow: visible !important;\n\n    .content-inner-wrapper {\n      height: auto;\n      overflow: visible !important;\n    }\n  }\n\n  display: inline-block;\n  position: relative;\n  flex: 1 0;\n  z-index: 1;\n\n  .content-inner-wrapper {\n    position: relative;\n    padding: 12px 16px;\n    min-height: 100%;\n\n    & > h1,\n    h2,\n    h3,\n    h4,\n    h5,\n    h6 {\n      margin: 6px 0;\n      font-weight: 700;\n    }\n\n    & > h1 {\n      font-size: 1.6em;\n    }\n    & > h2 {\n      font-size: 1.4em;\n    }\n    & > h3 {\n      font-size: 1.2em;\n    }\n  }\n"]);

  _templateObject$C = function _templateObject() {
    return data;
  };

  return data;
}

var ContentMain =
/*#__PURE__*/
function (_React$PureComponent) {
  _inheritsLoose(ContentMain, _React$PureComponent);

  function ContentMain() {
    var _this;

    _this = _React$PureComponent.apply(this, arguments) || this;
    _this.handleScroll = debounce(function (event) {
      if (_this.props.onScroll) _this.props.onScroll(event, event.target.scrollTop);
    }, 200);
    return _this;
  }

  var _proto = ContentMain.prototype;

  _proto.componentDidMount = function componentDidMount() {
    if (this.props.mainContainerRef && this.props.mainContainerRef.current) {
      var node = findDOMNode(this.props.mainContainerRef.current);
      if (node) node.addEventListener("scroll", this.handleScroll, true);
    }

    if (this.props.onMount) this.props.onMount();
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    if (this.props.mainContainerRef && this.props.mainContainerRef.current) {
      var node = findDOMNode(this.props.mainContainerRef.current);
      if (node) node.removeEventListener("scroll", this.handleScroll, true);
    }
  };

  _proto.render = function render() {
    return createElement(StyledContentMain, Object.assign({
      className: "page-content-main",
      ref: this.props.mainContainerRef,
      id: this.props.id || "paneledpage-content-main",
      "data-testid": this.props.testId || "paneledpage-content-main"
    }, this.props.passThroughProps), createElement("div", {
      className: "content-inner-wrapper",
      id: this.props.innerWrapperId || "paneledpage-content-main-inner-wrapper-id",
      "data-testid": this.props.innerWrapperTestId || "paneledpage-content-main-inner-wrapper"
    }, this.props.children));
  };

  return ContentMain;
}(PureComponent);
var StyledContentMain =
/*#__PURE__*/
styled("main")(
/*#__PURE__*/
_templateObject$C());

function _templateObject$D() {
  var data = _taggedTemplateLiteralLoose(["\n  display: inline-block;\n  position: absolute;\n  top: 0;\n  left: 0;\n  max-height: 100%;\n  width: ", ";\n  padding: 12px 16px;\n  overflow: auto;\n  z-index: 2;\n\n  &[data-fill-content-height=\"true\"] {\n    height: 100%;\n  }\n"]);

  _templateObject$D = function _templateObject() {
    return data;
  };

  return data;
}
var defaultAsideWidth = 200;
var isContentAsideTemplate = function isContentAsideTemplate(node) {
  if (node && node.props && node.type.componentType === "ContentAsideTemplate" && node.props.width !== undefined) return true;else return false;
};
var ContentAsideTemplate =
/*#__PURE__*/
function (_React$PureComponent) {
  _inheritsLoose(ContentAsideTemplate, _React$PureComponent);

  function ContentAsideTemplate() {
    return _React$PureComponent.apply(this, arguments) || this;
  }

  return ContentAsideTemplate;
}(PureComponent);
ContentAsideTemplate.defaultProps = {
  testId: "paneledpage-content-aside",
  width: 200,
  fillContentHeight: true
};
ContentAsideTemplate.componentType = "ContentAsideTemplate";

var ContentAside =
/*#__PURE__*/
function (_React$PureComponent2) {
  _inheritsLoose(ContentAside, _React$PureComponent2);

  function ContentAside() {
    return _React$PureComponent2.apply(this, arguments) || this;
  }

  var _proto = ContentAside.prototype;

  _proto.componentDidMount = function componentDidMount() {
    if (this.props.pageContext.setAsideWidth) {
      this.props.pageContext.setAsideWidth(this.props.width);
    }
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (this.props.width !== prevProps.width && this.props.pageContext.setAsideWidth) {
      this.props.pageContext.setAsideWidth(this.props.width);
    }
  };

  _proto.render = function render() {
    return createElement(StyledContentAside, Object.assign({
      className: "page-content-aside",
      "data-testid": this.props.testId,
      "data-fill-content-height": this.props.fillContentHeight,
      expandedwidth: this.props.pageContext.asideWidth
    }, this.props.passThroughProps), this.props.children);
  };

  return ContentAside;
}(PureComponent);
ContentAside.componentType = "ContentAside";
/* eslint-disable-next-line */

var StyledContentAside =
/*#__PURE__*/
styled.aside(
/*#__PURE__*/
_templateObject$D(), function (props) {
  return props.expandedwidth + "px";
});

function _templateObject$E() {
  var data = _taggedTemplateLiteralLoose(["\n  position: relative;\n  box-sizing: border-box;\n  margin-bottom: 32px;\n  padding: 0;\n  border-radius: 4px;\n  border-left: 4px solid transparent;\n  /*box-shadow: 0 0 0 0 transparent*/\n  background: #ffffff;\n  transition: 0.3s;\n\n  &[data-table-of-contents=\"active\"] {\n    &[data-current-section=\"true\"] {\n      box-shadow: -4px 4px 10px -2px #d6d6d6;\n    }\n    &:not([data-current-section=\"true\"]) {\n      box-shadow: -4px 4px 10px -12px #d6d6d6;\n    }\n  }\n\n  & > .content-section-header {\n    display: flex;\n    flex-wrap: nowrap;\n    flex-direction: row;\n    align-items: center;\n    justify-content: space-between;\n    padding: 20px 24px 24px 24px;\n\n    & > .content-at-left {\n      display: flex;\n      flex-wrap: nowrap;\n      flex-direction: row;\n      align-items: stretch;\n      flex-grow: 1;\n    }\n    & > .content-at-right {\n      flex-shrink: 0;\n      margin-left: 36px;\n      text-align: right;\n    }\n\n    .content-section-collapse-toggle {\n      display: inline-block;\n      position: relative;\n      margin-right: 8px;\n      font-size: 1em;\n      vertical-align: middle;\n      cursor: pointer;\n      transition: 0.2s;\n      width: 20px;\n      height: 20px;\n\n      & > i {\n        position: absolute;\n        transition: 0.2s;\n      }\n\n      &:hover > i,\n      &:active > i {\n        color: #0370f5;\n      }\n    }\n\n    & .content-section-title {\n      display: inline-block;\n      margin: 2px 0 0 0;\n      font-size: 1.2em;\n      font-weight: 500;\n      vertical-align: middle;\n\n      &.section-collapsible {\n        cursor: pointer;\n      }\n    }\n  }\n\n  & > .content-section-body {\n    padding: 0 24px 28px 24px;\n    height: auto;\n    font-size: 0.95em;\n\n    h4,\n    h5,\n    h6 {\n      color: #404040;\n      font-weight: 700;\n      text-transform: uppercase;\n    }\n  }\n\n  &[data-widget-collapsed=\"false\"] {\n    min-height: 192px;\n\n    & > .content-section-header {\n      .content-section-collapse-toggle > i {\n        transform: rotate(0deg);\n        margin-top: ", ";\n      }\n    }\n\n    & > .content-section-body {\n      & > .content-inner-container {\n        height: auto;\n      }\n    }\n  }\n  &[data-widget-collapsed=\"true\"] {\n    & > .content-section-header {\n      padding-bottom: 0;\n      .content-section-collapse-toggle > i {\n        transform: rotate(-90deg);\n        margin-top: ", ";\n        margin-left: -1px;\n      }\n    }\n\n    & > .content-section-body {\n      & > .content-inner-container {\n        height: 0;\n        overflow: hidden;\n      }\n    }\n  }\n\n  & > .height-resize-listener {\n    display: block !important;\n    position: absolute;\n    width: 0;\n    height: 100%;\n    background-color: none;\n    border: none;\n  }\n"]);

  _templateObject$E = function _templateObject() {
    return data;
  };

  return data;
}
var isContentSectionTemplate = function isContentSectionTemplate(node) {
  if (node && node.props && node.type.componentType === "ContentSectionTemplate" && node.props.title !== undefined) return true;else return false;
};
var ContentSectionTemplate =
/*#__PURE__*/
function (_React$PureComponent) {
  _inheritsLoose(ContentSectionTemplate, _React$PureComponent);

  function ContentSectionTemplate() {
    return _React$PureComponent.apply(this, arguments) || this;
  }

  return ContentSectionTemplate;
}(PureComponent);
ContentSectionTemplate.componentType = "ContentSectionTemplate";

var ContentSection =
/*#__PURE__*/
function (_React$PureComponent2) {
  _inheritsLoose(ContentSection, _React$PureComponent2);

  function ContentSection() {
    var _this;

    _this = _React$PureComponent2.apply(this, arguments) || this;
    _this.componentClassIdentifier = "paneled-page-content-main-section";
    _this.resizeListener = createRef();
    _this.state = {
      collapsed: _this.props.collapsible && _this.props.defaultCollapsed ? _this.props.defaultCollapsed : false,
      haveContentReady: _this.props.collapsible && _this.props.defaultCollapsed ? false : true
    };

    _this.handleHeightChange = function (event) {
      // Sections can unexpectedly change height due to lazy-loaded content 'jumping' into appearance.
      if (_this.props.onHeightChange) _this.props.onHeightChange(_this.props.isLastSection);
    };

    _this.toggleCollapse = function () {
      _this.setState({
        collapsed: _this.props.collapsible ? !_this.state.collapsed : false
      });
    };

    _this.onSectionToolsClicked = function (event) {
      if (_this.state.collapsed) {
        _this.setState({
          collapsed: false
        });
      }
    };

    _this.renderTestId = function () {
      if (_this.props.testId) return _this.props.testId.replace(/%(INDEX)%/g, "" + _this.props.index).replace(/%(TITLE)%/g, "" + _this.props.title);else return "paneledpage-content-section-" + _this.props.index;
    };

    return _this;
  }

  var _proto = ContentSection.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.resizeListener.current.contentWindow.addEventListener("resize", this.handleHeightChange, true);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.resizeListener.current.contentWindow.removeEventListener("resize", this.handleHeightChange, true);
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
    /* this way, the callbacks are executed after the section-widget has been collapsed/expanded */
    if (this.state.collapsed !== prevState.collapsed) {
      var targetSectionListModel = {
        sectionIndex: this.props.index,
        sectionTitle: this.props.title,
        sectionFlagged: this.props.flagged
      };

      if (this.state.collapsed) {
        if (this.props.onSectionCollapse) this.props.onSectionCollapse(targetSectionListModel);
        if (this.props.unmountContentOnCollapse) this.setState({
          haveContentReady: false
        });
      } else {
        if (this.props.onSectionExpand) this.props.onSectionExpand(targetSectionListModel);
        if (!this.state.haveContentReady) this.setState({
          haveContentReady: true
        });
      }
    }
  };

  _proto.render = function render() {
    var sectionId = "section-" + this.props.index;
    var hasSectionTools = this.props.tools && this.props.tools !== "";
    return createElement(StyledContentSection, Object.assign({
      className: "content-section content-section-card card-flat",
      id: "section-" + this.props.index,
      "data-section-index": this.props.index,
      "data-widget-collapsed": this.state.collapsed,
      "data-current-section": this.props.isCurrentSection,
      "data-table-of-contents": this.props.tableOfContentsActive ? "active" : "inactive",
      "data-testid": this.renderTestId()
    }, this.props.passThroughProps), createElement("iframe", {
      className: "height-resize-listener",
      "data-target-section": sectionId,
      ref: this.resizeListener,
      title: "height-resize-listener-" + sectionId
    }), createElement("div", {
      className: "content-section-header"
    }, createElement("div", {
      className: "content-at-left"
    }, this.props.collapsible && createElement("div", {
      className: "content-section-collapse-toggle",
      onClick: this.toggleCollapse
    }, createElement("i", {
      className: "fa fa-chevron-down"
    })), createElement("h3", {
      onClick: this.toggleCollapse,
      className: "content-section-title " + (this.props.collapsible ? "section-collapsible" : "")
    }, this.props.title)), hasSectionTools && createElement("div", {
      className: "section-widget-tools content-at-right",
      onClick: this.onSectionToolsClicked
    }, this.props.tools)), createElement("div", {
      className: "content-section-body"
    }, this.state.haveContentReady && createElement("div", {
      className: "content-inner-container"
    }, this.props.children)));
  };

  return ContentSection;
}(PureComponent);
ContentSection.componentType = "ContentSection";
var StyledContentSection =
/*#__PURE__*/
styled("section")(
/*#__PURE__*/
_templateObject$E(), function (props) {
  return props.theme.baseTheme === "Concrete" ? "2px" : "1px";
}, function (props) {
  return props.theme.baseTheme === "Concrete" ? "4px" : "3px";
});

function _templateObject$F() {
  var data = _taggedTemplateLiteralLoose(["\n  display: inline-block;\n  cursor: pointer;\n\n  & > i {\n    font-size: 0.92em;\n  }\n\n  & > .icon-spacer {\n    display: inline-block;\n    margin-right: 8px;\n  }\n"]);

  _templateObject$F = function _templateObject() {
    return data;
  };

  return data;
}
var StyledStatusFlag =
/*#__PURE__*/
styled("div")(
/*#__PURE__*/
_templateObject$F());

var StatusFlag =
/*#__PURE__*/
function (_React$PureComponent) {
  _inheritsLoose(StatusFlag, _React$PureComponent);

  function StatusFlag() {
    return _React$PureComponent.apply(this, arguments) || this;
  }

  var _proto = StatusFlag.prototype;

  _proto.render = function render() {
    var combinedClassNames = this.props.additionalClassNames ? "status-flag " + this.props.additionalClassNames : "status-flag";
    var flagIconColor = this.props.flagIconColor || "#ff3f1f";
    return createElement(StyledStatusFlag, {
      className: combinedClassNames
    }, createElement(Icon$1, {
      name: this.props.flagIcon || "asterisk",
      style: {
        color: flagIconColor
      }
    }), this.props.children ? createElement("div", {
      className: "icon-spacer"
    }) : "", this.props.children);
  };

  return StatusFlag;
}(PureComponent);

function _templateObject$G() {
  var data = _taggedTemplateLiteralLoose(["\n  @media print {\n    display: none;\n  }\n\n  position: relative;\n  z-index: 2;\n\n  & > ul {\n    list-style: none;\n    margin: 0 0 0 2px;\n    padding: 0;\n\n    & > li {\n      height: 28px;\n\n      & > a {\n        display: inline-block;\n        max-width: calc(100% - 20px);\n        font-size: 13px;\n        line-height: 28px;\n        overflow: hidden;\n        white-space: nowrap;\n        text-overflow: ellipsis;\n        transition: 0.2s;\n        color: #1e1e1e;\n        cursor: pointer;\n\n        &:hover {\n          color: #0370f5;\n        }\n      }\n\n      & > .section-flag-container {\n        display: inline-block;\n        position: absolute;\n        height: 28px;\n        right: 0;\n        line-height: 28px;\n\n        & * {\n          display: inline-block;\n        }\n      }\n\n      &[data-current-section=\"true\"] {\n        & > a {\n          font-weight: 600;\n          font-size: 14.5px;\n          color: #0370f5;\n        }\n      }\n    }\n  }\n\n  & .selected-section-indicator {\n    position: absolute;\n    margin-left: -12px;\n    transition: 0.5s;\n\n    &:before {\n      content: \"\";\n      display: block;\n      position: absolute;\n      border-top: 5px solid transparent;\n      border-bottom: 5px solid transparent;\n      border-left: 8px solid #0370f5;\n    }\n  }\n"]);

  _templateObject$G = function _templateObject() {
    return data;
  };

  return data;
}
var StyledTableOfContents =
/*#__PURE__*/
styled("div")(
/*#__PURE__*/
_templateObject$G());
var isTableOfContentsTemplate = function isTableOfContentsTemplate(node) {
  if (node && node.props && node.type.componentType === "SectionTableOfContentsTemplate" && node.props.sectionFlag !== undefined) return true;else return false;
};
var SectionTableOfContentsTemplate =
/*#__PURE__*/
function (_React$PureComponent) {
  _inheritsLoose(SectionTableOfContentsTemplate, _React$PureComponent);

  function SectionTableOfContentsTemplate() {
    return _React$PureComponent.apply(this, arguments) || this;
  }

  return SectionTableOfContentsTemplate;
}(PureComponent);
SectionTableOfContentsTemplate.componentType = "SectionTableOfContentsTemplate";
SectionTableOfContentsTemplate.defaultProps = {
  sectionFlag:
  /*#__PURE__*/
  createElement(StatusFlag, null)
};

var SectionTableOfContents =
/*#__PURE__*/
function (_React$PureComponent2) {
  _inheritsLoose(SectionTableOfContents, _React$PureComponent2);

  function SectionTableOfContents() {
    var _this;

    _this = _React$PureComponent2.apply(this, arguments) || this;

    _this.moveIndicatorToCurrentSection = function (currentSectionIndex) {
      var getOffsetCompensationAmount = function getOffsetCompensationAmount() {
        if (_this.props.theme) {
          return _this.props.theme.baseTheme === "Concrete" ? 19 : 20;
        } else return 20;
      };

      if (currentSectionIndex !== null) {
        var offsetFactor = 28;
        return offsetFactor * (currentSectionIndex + 1) - getOffsetCompensationAmount() + "px";
      } else return "-500px";
    };

    _this.renderTestId = function () {
      if (_this.props.testId) return _this.props.testId.replace(/%(CURRENTINDEX)%/g, "" + _this.props.currentSectionIndex);else return "paneledpage-content-tableofcontents";
    };

    return _this;
  } // The Table of Contents is rendered inside a ContentAside which acts as a wrapper
  // This allows for more consistent styling and layout rules.


  var _proto = SectionTableOfContents.prototype;

  _proto.render = function render() {
    var _this2 = this;

    return createElement(PaneledPageContext.Consumer, null, function (pageContext) {
      return createElement(ContentAside, {
        pageContext: pageContext,
        testId: "content-aside-TOC-wrapper",
        fillContentHeight: false
      }, createElement(StyledTableOfContents, Object.assign({
        className: "section-table-of-contents",
        "data-testid": _this2.renderTestId()
      }, _this2.props.passThroughProps), createElement("ul", {
        className: "section-list"
      }, _this2.props.allSections && _this2.props.allSections.length > 0 ? _this2.props.allSections.map(function (section, index) {
        var sectionFlagged = section.sectionFlagged || false;
        return createElement("li", {
          key: index,
          className: "section-list-item",
          "data-current-section": section.sectionIndex === _this2.props.currentSectionIndex
        }, createElement("a", {
          onClick: function onClick() {
            return _this2.props.onSelectSection(section.sectionIndex);
          },
          title: "Go to section \"" + section.sectionTitle + "\""
        }, section.sectionTitle), sectionFlagged && createElement("div", {
          className: "section-flag-container",
          onClick: function onClick() {
            return _this2.props.onSelectSection(section.sectionIndex);
          }
        }, _this2.props.sectionFlag));
      }) : ""), createElement("div", {
        className: "selected-section-indicator",
        style: {
          top: _this2.moveIndicatorToCurrentSection(_this2.props.currentSectionIndex)
        }
      })));
    });
  };

  return SectionTableOfContents;
}(PureComponent);

SectionTableOfContents.componentType = "SectionTableOfContents";
var SectionTableOfContents$1 = /*#__PURE__*/
withTheme(SectionTableOfContents);

function _templateObject$H() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex: 1 0;\n  flex-wrap: nowrap;\n  align-items: stretch;\n  position: relative;\n  overflow: hidden;\n  background: ", ";\n  z-index: 0;\n\n  @media print {\n    height: auto;\n    overflow: visible;\n  }\n\n  &[data-has-table-of-contents=\"true\"] .page-content-main {\n    & > .content-inner-wrapper {\n      padding-bottom: ", ";\n    }\n  }\n\n  &:before {\n    content: \"\";\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    opacity: 0.8;\n    transition: 0.2s;\n  }\n  &[data-modal-overlay-active=\"true\"] {\n    .page-content-main {\n      overflow: hidden;\n    }\n\n    &:before {\n      background: ", ";\n      z-index: 5;\n    }\n  }\n  &[data-modal-overlay-active=\"false\"] {\n    .page-content-main {\n      overflow: auto;\n    }\n\n    &:before {\n      background: transparent;\n      z-index: -5;\n    }\n  }\n\n  &[data-has-content-aside=\"true\"],\n  &[data-has-table-of-contents=\"true\"] {\n    &[data-content-align=\"center\"] {\n      .page-content-aside {\n        left: ", ";\n      }\n      .page-content-main > .content-inner-wrapper {\n        margin-left: ", ";\n        margin-right: ", ";\n        max-width: ", ";\n      }\n    }\n\n    &[data-content-align=\"left\"] {\n      .page-content-aside {\n        left: 0;\n      }\n      .page-content-main > .content-inner-wrapper {\n        margin-left: ", ";\n        margin-right: auto;\n        max-width: ", ";\n      }\n    }\n  }\n\n  &[data-has-content-aside=\"false\"][data-has-table-of-contents=\"false\"] {\n    .page-content-main > .content-inner-wrapper {\n      max-width: ", ";\n    }\n\n    &[data-content-align=\"center\"] {\n      .page-content-main > .content-inner-wrapper {\n        margin-left: auto;\n        margin-right: auto;\n      }\n    }\n\n    &[data-content-align=\"left\"] {\n      .page-content-main > .content-inner-wrapper {\n        margin-left: 0;\n        margin-right: auto;\n      }\n    }\n  }\n"]);

  _templateObject$H = function _templateObject() {
    return data;
  };

  return data;
}

var getContentSectionListFromChildren = function getContentSectionListFromChildren(children) {
  if (children) {
    var sections = [];
    var contentSectionCount = 0;
    Children.forEach(children, function (node, index) {
      if (isContentSectionTemplate(node)) {
        sections.push({
          sectionIndex: contentSectionCount,
          sectionTitle: node.props.title,
          sectionFlagged: node.props.flagged
        });
        contentSectionCount++;
      }
    });
    return sections;
  } else return [];
};

var checkForTableOfContents = function checkForTableOfContents(children) {
  var tableOfContentsFound = false;

  if (children) {
    var numTOCChildNodes = 0;
    var childArray = Children.toArray(children);

    for (var index = 0; index < childArray.length; index++) {
      var node = childArray[index];

      if (isTableOfContentsTemplate(node)) {
        if (process.env.NODE_ENV === "development") {
          tableOfContentsFound = true;
          numTOCChildNodes++;
        } else {
          return true;
        }
      }
    }

    if (numTOCChildNodes > 1) {
      // No need to print more than one warning message if, for some bizarre reason, there was
      // an attempt to mount more than two <PaneledPage.Content.TableOfContents> components.
      console.warn("Invalid number of <PaneledPage.Content.TableOfContents> inside PaneledPage content\n" + "No more than one <PaneledPage.Content.TableOfContents> component should be used simultaneously in a PaneledPage's content.");
    }
  }

  return tableOfContentsFound;
};

var checkForAside = function checkForAside(children) {
  var asideFound = false;

  if (children) {
    var numAsideChildNodes = 0;
    var childArray = Children.toArray(children);

    for (var index = 0; index < childArray.length; index++) {
      var node = childArray[index];

      if (isContentAsideTemplate(node)) {
        if (process.env.NODE_ENV === "development") {
          asideFound = true;
          numAsideChildNodes++;
        } else {
          return true;
        }
      }
    }

    if (numAsideChildNodes > 1) {
      // No need to print more than one warning message if, for some bizarre reason, there was
      // an attempt to mount more than two <PaneledPage.Content.TableOfContents> components.
      console.warn("Invalid number of <PaneledPage.Content.Aside> inside PaneledPage content\n" + "No more than one <PaneledPage.Content.Aside> component should be used simultaneously in a PaneledPage's content.");
    }
  }

  return asideFound;
};

var refreshSectionFlagging = function refreshSectionFlagging(currentSectionList, children) {
  if (children) {
    var updatedSectionList = [].concat(currentSectionList);
    var contentSectionCount = 0;
    Children.forEach(children, function (node, index) {
      if (isContentSectionTemplate(node)) {
        updatedSectionList[contentSectionCount].sectionFlagged = node.props.flagged;
        contentSectionCount++;
      }
    });
    return updatedSectionList;
  } else return [];
};

var PageContentPanelTemplate =
/*#__PURE__*/
function (_React$PureComponent) {
  _inheritsLoose(PageContentPanelTemplate, _React$PureComponent);

  function PageContentPanelTemplate() {
    return _React$PureComponent.apply(this, arguments) || this;
  }

  var _proto = PageContentPanelTemplate.prototype;

  _proto.render = function render() {
    var _this = this;

    return createElement(PaneledPageContext.Consumer, null, function (pageContext) {
      return createElement(PageContentPanel, Object.assign({
        pageContext: pageContext
      }, _this.props));
    });
  };

  return PageContentPanelTemplate;
}(PureComponent);
PageContentPanelTemplate.Section = ContentSectionTemplate;
PageContentPanelTemplate.Aside = ContentAsideTemplate;
PageContentPanelTemplate.TableOfContents = SectionTableOfContentsTemplate;
var defaultScrollUpBuffer = 74;
var defaultScrollDownBuffer = 56;
var PageContentPanel =
/*#__PURE__*/
function (_React$PureComponent2) {
  _inheritsLoose(PageContentPanel, _React$PureComponent2);

  function PageContentPanel() {
    var _this2;

    _this2 = _React$PureComponent2.apply(this, arguments) || this;
    _this2.mainContainerRef = createRef();
    _this2.state = {
      allSections: getContentSectionListFromChildren(_this2.props.children),
      sectionScrollOffsets: [],
      currentSectionIndex: null,
      contentScrollPosition: 0,
      contentResizingCalcInProgress: false,
      currentWidth: 0,
      fillerHeight: 0,
      fillerWasResized: false,
      userRequestedScrollToSection: false,
      hasContentAside: checkForAside(_this2.props.children),
      hasTableOfContents: checkForTableOfContents(_this2.props.children)
    };

    _this2.handleMainContainerMounted = function () {
      var fillerHeight = _this2.calculateFillerHeight();

      var updatedScrollOffsets = _this2.getUpdatedSectionScrollOffsets(_this2.props.children, 0);

      _this2.setState(function (prevState) {
        return {
          sectionScrollOffsets: updatedScrollOffsets,
          currentSectionIndex: prevState.allSections && prevState.allSections.length > 0 ? prevState.allSections[0].sectionIndex : null,
          fillerHeight: fillerHeight
        };
      });
    };

    _this2.handleWindowResize = function (event) {
      _this2.setState({
        currentWidth: _this2.calculateWidth(),
        fillerHeight: _this2.calculateFillerHeight()
      });
    };

    _this2.calculateWidth = function () {
      var selfElement = findDOMNode(_assertThisInitialized(_this2));
      return selfElement ? selfElement.getBoundingClientRect().width : 0;
    };

    _this2.calculateFillerHeight = function () {
      var allSections = _this2.state.allSections;

      if (allSections && allSections.length > 0) {
        var container = findDOMNode(_this2.mainContainerRef.current);
        var lastSection = findDOMNode(_assertThisInitialized(_this2)).querySelector(".content-section[data-section-index=\"" + allSections[allSections.length - 1].sectionIndex + "\"]");

        if (container && lastSection) {
          var containerHeight = container.getBoundingClientRect().height;
          var lastSectionHeight = lastSection.getBoundingClientRect().height;
          var baseMargin = 82; // Takes into account the 32px bottom margin underneath each section

          return lastSectionHeight + baseMargin <= containerHeight ? containerHeight - (lastSectionHeight + baseMargin) : 0;
        } else return 0;
      } else return 0;
    };

    _this2.calculateScrollUpBuffer = function () {
      var container = findDOMNode(_this2.mainContainerRef.current);
      return container ? 0.68 * container.getBoundingClientRect().height : 0;
    };

    _this2.calculateScrollDownBuffer = function () {
      var container = findDOMNode(_this2.mainContainerRef.current);
      return container ? 0.52 * container.getBoundingClientRect().height : 0;
    };

    _this2.getUpdatedSectionScrollOffsets = function (childNodes, updatedScrollPosition) {
      var sectionScrollOffsets = [];

      if (_this2.mainContainerRef) {
        var container = findDOMNode(_this2.mainContainerRef.current);
        var contentSectionCount = 0;
        Children.forEach(childNodes, function (node, index) {
          if (isContentSectionTemplate(node)) {
            var section = container ? container.querySelector(".content-section[data-section-index=\"" + contentSectionCount + "\"]") : null;
            var scrollOffset = section ? Math.abs(Math.round(section.getBoundingClientRect().top - (container.getBoundingClientRect().top + 12 - updatedScrollPosition))) : -1;
            sectionScrollOffsets.push({
              sectionIndex: contentSectionCount,
              sectionScrollOffset: scrollOffset
            });
            contentSectionCount++;
          }
        });
      }

      return sectionScrollOffsets;
    };

    _this2.getCurrentSectionWithUpdatedPosition = function (currentScrollPosition, updatedScrollOffsets, scrollChange) {
      var lastPassedSectionIndex = null;

      var scrollUpBuffer = _this2.calculateScrollUpBuffer();

      var scrollDownBuffer = _this2.calculateScrollDownBuffer();

      var triggerInterferenceWithPreviousSections = function triggerInterferenceWithPreviousSections(currentIndex, currentSectionOffset, calculatedBuffer, defaultBuffer) {
        if (currentSectionOffset < calculatedBuffer) return true;else if (currentSectionOffset < 2 * calculatedBuffer - defaultBuffer + 100) {
          var allSections = _this2.state.allSections;
          var previousSection = allSections && allSections.length > 0 ? findDOMNode(_assertThisInitialized(_this2)).querySelector(".content-section[data-section-index=\"" + (currentIndex - 1) + "\"]") : null;
          var previousSectionHeight = previousSection ? previousSection.getBoundingClientRect().height : -1;
          if (previousSectionHeight > 0) return calculatedBuffer > 0 ? previousSectionHeight < calculatedBuffer : previousSectionHeight < defaultBuffer;else return true;
        } else return false;
      };

      if (updatedScrollOffsets && updatedScrollOffsets.length > 0) {
        var index = 0;
        var passedPreviousTrigger = true;

        while (index < updatedScrollOffsets.length && passedPreviousTrigger) {
          var lowTrigger = void 0;
          var sectionAtIndex = updatedScrollOffsets[index];
          if (index === 0) lowTrigger = 0;else {
            var sectionScrollOffset = sectionAtIndex.sectionScrollOffset;

            if (scrollChange && scrollChange < 0) {
              lowTrigger = scrollUpBuffer && !triggerInterferenceWithPreviousSections(index, sectionScrollOffset, scrollUpBuffer, defaultScrollUpBuffer) ? sectionScrollOffset - scrollUpBuffer : sectionScrollOffset - defaultScrollUpBuffer;
            } else {
              lowTrigger = scrollDownBuffer && !triggerInterferenceWithPreviousSections(index, sectionScrollOffset, scrollDownBuffer, defaultScrollDownBuffer) ? sectionScrollOffset - scrollDownBuffer : sectionScrollOffset - defaultScrollDownBuffer;
            }
          }
          if (lowTrigger <= currentScrollPosition) lastPassedSectionIndex = sectionAtIndex.sectionIndex;else passedPreviousTrigger = false;
          index++;
        }
      }

      return lastPassedSectionIndex !== null ? lastPassedSectionIndex : _this2.state.currentSectionIndex;
    };

    _this2.handleClickInside = function (event) {
      _this2.props.pageContext.onClickInsideContent(_this2.props.hideFiltersOnContentClicked || true);
    };

    _this2.handleScrollContent = function (event, updatedScrollPosition) {
      if (!_this2.state.fillerWasResized) {
        var scrollChange = _this2.state.userRequestedScrollToSection ? 0 : updatedScrollPosition - _this2.state.contentScrollPosition;
        var updatedSectionIndex = !_this2.state.userRequestedScrollToSection ? _this2.getCurrentSectionWithUpdatedPosition(updatedScrollPosition, _this2.state.sectionScrollOffsets, scrollChange) : _this2.state.currentSectionIndex;

        _this2.setState({
          contentScrollPosition: updatedScrollPosition,
          currentSectionIndex: updatedSectionIndex
        });

        _this2.delayUserScrollRequestReset();
      }
    };

    _this2.delayUserScrollRequestReset = debounce(function () {
      _this2.setState({
        userRequestedScrollToSection: false
      });
    }, 200);
    _this2.delayFillerResizeStatusReset = debounce(function () {
      _this2.setState({
        fillerWasResized: false
      });
    }, 200);

    _this2.handleSectionChangedHeight = function (isLastSection) {
      if (isLastSection) _this2.setState({
        fillerHeight: _this2.calculateFillerHeight(),
        fillerWasResized: true
      }, _this2.delayFillerResizeStatusReset);else _this2.setState({
        sectionScrollOffsets: _this2.getUpdatedSectionScrollOffsets(_this2.props.children, _this2.state.contentScrollPosition)
      });
    };

    _this2.handleSelectSection = debounce(function (selectedSectionIndex) {
      if (_this2.state.sectionScrollOffsets) {
        var sectionPosition = _this2.state.sectionScrollOffsets[selectedSectionIndex].sectionScrollOffset;
        _this2.mainContainerRef.current.scrollTop = sectionPosition > defaultScrollDownBuffer ? sectionPosition - defaultScrollDownBuffer : 0;

        _this2.setState({
          userRequestedScrollToSection: true,
          currentSectionIndex: selectedSectionIndex
        });
      }
    }, 250);
    return _this2;
  }

  var _proto2 = PageContentPanel.prototype;

  _proto2.componentDidMount = function componentDidMount() {
    var _this3 = this;

    var updatedScrollOffsets = this.getUpdatedSectionScrollOffsets(this.props.children, 0);
    var updatedWidth = this.calculateWidth();
    this.setState({
      allSections: getContentSectionListFromChildren(this.props.children),
      contentScrollPosition: 0,
      currentWidth: updatedWidth,
      sectionScrollOffsets: updatedScrollOffsets,
      userRequestedScrollToSection: false,
      hasContentAside: checkForAside(this.props.children),
      hasTableOfContents: checkForTableOfContents(this.props.children)
    }, function () {
      if (_this3.state.hasContentAside && _this3.state.hasTableOfContents) {
        console.warn("Invalid simultaneous use of children <PaneledPage.Content.Aside> and <PaneledPage.Content.TableOfContents>\n" + "<PaneledPage.Content.Aside> and <PaneledPage.Content.TableOfContents> components should not be used simultaneously in a PaneledPage's content.");
      }

      _this3.setState(function (prevState) {
        return {
          currentSectionIndex: prevState.allSections && prevState.allSections.length > 0 ? prevState.allSections[0].sectionIndex : null
        };
      });
    });
    window.addEventListener("resize", this.handleWindowResize, true);
  };

  _proto2.componentWillUnmount = function componentWillUnmount() {
    window.removeEventListener("resize", this.handleWindowResize, true);
  };

  _proto2.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (prevProps.children !== this.props.children) this.setState({
      allSections: refreshSectionFlagging(this.state.allSections, this.props.children)
    });
  };

  _proto2.render = function render() {
    var _this4 = this;

    var contentSectionCount = 0;
    return createElement(StyledPageContentPanel, Object.assign({
      className: "page-content-panel",
      "data-modal-overlay-active": this.props.pageContext.filtersPanelExpanded,
      "data-has-content-aside": this.state.hasContentAside,
      "data-has-table-of-contents": this.state.hasTableOfContents,
      "data-content-align": this.props.pageContext.contentAlign,
      maxpagewidth: this.props.pageContext.maxPageWidth,
      containerwidth: this.state.currentWidth,
      asidewidth: this.props.pageContext.asideWidth,
      fillerheight: this.state.fillerHeight,
      onClick: this.handleClickInside,
      "data-testid": this.props.testId || "paneledpage-content"
    }, this.props.passThroughProps), Children.map(this.props.children, function (node, index) {
      // Render only ContentAside and TableOfContents child elements outside the main container
      if (isContentAsideTemplate(node)) {
        return createElement(ContentAside, Object.assign({}, node.props, {
          key: index,
          pageContext: _this4.props.pageContext
        }));
      } else if (isTableOfContentsTemplate(node)) {
        return createElement(SectionTableOfContents$1, Object.assign({}, node.props, {
          key: index,
          allSections: _this4.state.allSections,
          currentSectionIndex: _this4.state.currentSectionIndex,
          onSelectSection: _this4.handleSelectSection
        }));
      }

      return null;
    }), createElement(ContentMain, {
      mainContainerRef: this.mainContainerRef,
      onScroll: this.handleScrollContent,
      onMount: this.handleMainContainerMounted,
      id: this.props.mainContainerId,
      testId: this.props.mainContainerTestId,
      innerWrapperId: this.props.contentInnerWrapperId,
      innerWrapperTestId: this.props.contentInnerWrapperTestId
    }, Children.map(this.props.children, function (node, index) {
      var numSections = _this4.state.allSections.length;

      if (node && isContentSectionTemplate(node)) {
        contentSectionCount++;
        var sectionIndex = contentSectionCount - 1;
        var isLast = sectionIndex === numSections - 1;
        return createElement(ContentSection, Object.assign({}, node.props, {
          key: index,
          index: sectionIndex,
          isCurrentSection: sectionIndex === _this4.state.currentSectionIndex,
          isLastSection: isLast,
          onHeightChange: _this4.handleSectionChangedHeight,
          tableOfContentsActive: _this4.state.hasTableOfContents
        })); // prevent render of ContentAside and Table of Contents child elements inside the Main container
      } else if (!isContentAsideTemplate(node) && !isTableOfContentsTemplate(node)) return node;

      return null;
    })));
  };

  return PageContentPanel;
}(PureComponent);
var StyledPageContentPanel =
/*#__PURE__*/
styled.div(
/*#__PURE__*/
_templateObject$H(), gray200$1, function (props) {
  return props.fillerheight ? props.fillerheight + "px" : 0;
}, gray400$1, function (props) {
  return props.maxpagewidth && props.maxpagewidth < props.containerwidth ? "calc(50% - " + props.maxpagewidth * 0.5 + "px)" : "0";
}, function (props) {
  return props.maxpagewidth && props.maxpagewidth < props.containerwidth ? "calc(50% - " + (props.maxpagewidth * 0.5 - props.asidewidth) + "px)" : props.asidewidth + "px";
}, function (props) {
  return props.maxpagewidth && props.maxpagewidth < props.containerwidth ? "calc(50% - " + props.maxpagewidth * 0.5 + "px)" : "0";
}, function (props) {
  return props.maxpagewidth ? props.maxpagewidth - props.asidewidth + "px" : "none";
}, function (props) {
  return props.asidewidth + "px";
}, function (props) {
  return props.maxpagewidth ? props.maxpagewidth - props.asidewidth + "px" : "none";
}, function (props) {
  return props.maxpagewidth ? props.maxpagewidth + "px" : "none";
});

var FiltersToggle =
/*#__PURE__*/
function (_React$PureComponent) {
  _inheritsLoose(FiltersToggle, _React$PureComponent);

  function FiltersToggle() {
    var _this;

    _this = _React$PureComponent.apply(this, arguments) || this;

    _this.handleClick = function (event, pageContext) {
      if (_this.props.toggleFiltersOnEvent === "click" && pageContext.onToggleFiltersPanel) pageContext.onToggleFiltersPanel(event);
    };

    _this.handleMouseEnter = function (event, pageContext) {
      if (_this.props.toggleFiltersOnEvent === "hover" && pageContext.onToggleFiltersPanel) pageContext.onToggleFiltersPanel(event);
    };

    return _this;
  }

  var _proto = FiltersToggle.prototype;

  _proto.render = function render() {
    var _this2 = this;

    return createElement(PaneledPageContext.Consumer, null, function (pageContext) {
      return createElement("span", {
        className: "filters-panel-toggle-listener",
        onClick: function onClick(event) {
          return _this2.handleClick(event, pageContext);
        },
        onMouseDown: function onMouseDown(event) {
          return _this2.handleMouseEnter(event, pageContext);
        }
      }, _this2.props.children);
    });
  };

  return FiltersToggle;
}(PureComponent);

function _templateObject$I() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  width: 100%;\n  height: 100%;\n  overflow-y: visible;\n  overflow-x: hidden;\n\n  @media print {\n    display: inline;\n  }\n\n  &.fit-to-page {\n    height: calc(100vh - 45px);\n  }\n  &.fit-to-container {\n    height: 100%;\n  }\n\n  .filters-panel-toggle-listener {\n    cursor: pointer;\n  }\n"]);

  _templateObject$I = function _templateObject() {
    return data;
  };

  return data;
}

var PaneledPage =
/*#__PURE__*/
function (_React$PureComponent) {
  _inheritsLoose(PaneledPage, _React$PureComponent);

  function PaneledPage() {
    var _this;

    _this = _React$PureComponent.apply(this, arguments) || this;
    _this.mounted = true;
    _this.state = {
      filtersPanelExpanded: false,
      filtersHasOpenDropdown: false,
      activeDropdownId: null,
      asideWidth: 200
    };

    _this.showFilters = function () {
      return _this.setState({
        filtersPanelExpanded: true
      });
    };

    _this.hideFilters = function () {
      return _this.setState({
        filtersPanelExpanded: false
      });
    };

    _this.handleClickInsidePage = function (event) {
      _this.dropdownCheckTimeout = setTimeout(function () {
        if (_this.mounted) _this.checkForOpenDropdowns();
      }, 50);
    };

    _this.handleClickInsideFilters = function (event) {
      if (!_this.state.filtersPanelExpanded) _this.showFilters();
    };

    _this.handleFiltersPanelToggled = function (event) {
      if (event) event.stopPropagation();
      if (!_this.state.filtersPanelExpanded) _this.showFilters();else _this.hideFilters();
    }; // The animation is a lot smoother and more effective when the default expansion of the filters is delayed somewhat.
    // It also catches a user's attention more readily when it occurs just a fraction of a second after the page loads.


    _this.handleDefaultExpandFilters = function () {
      return setTimeout(_this.showFilters, 450);
    };

    _this.checkForInvalidNodes = function () {
      if (process.env.NODE_ENV === "development" && _this.props.children) {
        var numHeaderPanelNodes = 0;
        var numContentPanelNodes = 0;
        Children.forEach(_this.props.children, function (node, index) {
          if (node && node.type !== undefined) {
            var nodeComponentTypeName = node.type.name || null;
            if (nodeComponentTypeName === "PageHeaderPanelTemplate") numHeaderPanelNodes++;else if (nodeComponentTypeName === "PageContentPanelTemplate") numContentPanelNodes++;else {
              console.warn("Invalid child node of <PaneledPage>\n" + ("<" + node.type + "> is not a valid immediate child of a <PaneledPage> component. ") + "We recommend using only <PaneledPage.Header> or <PaneledPage.Content> as immediate children of a <PaneledPage>.");
            }
          }
        });

        if (numHeaderPanelNodes > 1) {
          console.warn("Invalid duplicate children\n" + "<PaneledPage> should not have more than one <PaneledPage.Header> as a child component. " + "Duplicate <PaneledPage.Header> nodes will be ignored");
        }

        if (numContentPanelNodes > 1) {
          console.warn("Invalid duplicate children\n" + "<PaneledPage> should not have more than one <PaneledPage.Content> as a child component. " + "Duplicate <PaneledPage.Content> nodes will be ignored");
        }
      }
    };

    _this.checkForOpenDropdowns = function () {
      var activeElementId = document.activeElement ? document.activeElement.id || "unknown" : null;

      if (activeElementId && activeElementId.indexOf("react-select") !== -1) {
        if (_this.state.filtersHasOpenDropdown) {
          // If there already was an open dropdown in the filters panel, check if it's the same one the user just focused.
          // If so, the dropdown will hide; otherwise, the user opened some other dropdown in that panel.
          _this.setState(function (prevState) {
            return {
              filtersHasOpenDropdown: activeElementId !== prevState.activeDropdownId,
              activeDropdownId: activeElementId
            };
          });
        } else _this.setState({
          filtersHasOpenDropdown: true,
          activeDropdownId: activeElementId
        });
      } else _this.setState({
        filtersHasOpenDropdown: false,
        activeDropdownId: null
      });
    };

    _this.handleClickInsideContent = function (filtersPanelShouldHide) {
      if (_this.mounted) {
        if (!_this.state.filtersHasOpenDropdown) filtersPanelShouldHide && _this.hideFilters();else _this.setState({
          filtersHasOpenDropdown: false
        });
      }
    };

    _this.setAsideWidth = function (updatedWidth) {
      _this.setState({
        asideWidth: updatedWidth || defaultAsideWidth
      });
    };

    _this.userExpandedAnyDropdown = function () {
      if (document.activeElement && document.activeElement.id && document.activeElement.id.indexOf("react-select") !== -1) return true;else return false;
    };

    return _this;
  }

  var _proto = PaneledPage.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.checkForInvalidNodes();
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.mounted = false;
    if (!!this.dropdownCheckTimeout) clearTimeout(this.dropdownCheckTimeout);
  };

  _proto.render = function render() {
    var maxPageWidth = this.props.maxWidth && this.props.maxWidth > 0 ? this.props.maxWidth : null;
    var contentAlign = this.props.contentAlign || "center";
    var contextState = {
      maxPageWidth: maxPageWidth,
      contentAlign: contentAlign,
      asideWidth: this.state.asideWidth,
      setAsideWidth: this.setAsideWidth,
      filtersPanelExpanded: this.state.filtersPanelExpanded,
      filtersHasOpenDropdown: this.state.filtersHasOpenDropdown,
      activeDropdownId: this.state.activeDropdownId,
      onToggleFiltersPanel: this.handleFiltersPanelToggled,
      onDefaultExpandFilters: this.handleDefaultExpandFilters,
      onClickInsideFilters: this.handleClickInsideFilters,
      onClickInsideContent: this.handleClickInsideContent
    };
    return createElement(PaneledPageContext.Provider, {
      value: contextState
    }, createElement(StyledPaneledPage, Object.assign({
      className: "paneled-page-container fit-to-" + (this.props.fitTo || "page"),
      onClick: this.handleClickInsidePage,
      "data-testid": this.props.testId
    }, this.props.passThroughProps), this.props.children));
  };

  return PaneledPage;
}(PureComponent);
PaneledPage.Header = PageHeaderPanelTemplate;
PaneledPage.Content = PageContentPanelTemplate;
PaneledPage.FiltersToggle = FiltersToggle;
PaneledPage.defaultProps = {
  testId: "paneledpage-container"
};
PaneledPage.componentType = "PaneledPage";
var StyledPaneledPage =
/*#__PURE__*/
styled("div")(
/*#__PURE__*/
_templateObject$I());

function _templateObject$J() {
  var data = _taggedTemplateLiteralLoose(["\n  h1 {\n    font-size: ", ";\n\n    font-weight: ", ";\n  }\n"]);

  _templateObject$J = function _templateObject() {
    return data;
  };

  return data;
}
var StyledPageTitle =
/*#__PURE__*/
styled.div(
/*#__PURE__*/
_templateObject$J(), function (props) {
  return props.theme.baseTheme === "Ace" ? "2.4rem" : "1.65rem";
}, function (props) {
  return props.theme.baseTheme === "Ace" ? "400" : "700";
});
function PageTitle(_ref) {
  var children = _ref.children,
      props = _objectWithoutPropertiesLoose(_ref, ["children"]);

  return createElement(StyledPageTitle, null, createElement("div", Object.assign({
    className: "page-header"
  }, props), createElement("h1", null, children)));
}

var DetailPageTitle =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(DetailPageTitle, _React$Component);

  function DetailPageTitle() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = DetailPageTitle.prototype;

  _proto.render = function render() {
    return createElement("div", {
      className: "details-header-container"
    }, createElement("div", {
      id: "search-container"
    }, createElement("div", {
      id: "search-browse-box"
    }, createElement("button", {
      className: "next-button button-disabled",
      id: "next_button",

      /*onclick="search.getRecord(search.nextId)"*/
      disabled: true
    }, createElement("i", {
      className: "fa fa-chevron-right sixteenpx"
    })), createElement("button", {
      className: "previous-button button-disabled",
      id: "previous_button",

      /*onclick="search.getRecord(search.prevId)"*/
      disabled: true
    }, createElement("i", {
      className: "fa fa-chevron-left sixteenpx"
    })), createElement("div", {
      className: "dropdown-panel-search"
    }, createElement("div", {
      className: "dropdown-panel-search-input-container"
    }, createElement("div", {
      className: "dropdown-panel-search-icon"
    }, createElement("div", {
      className: "content"
    }, createElement("span", null, "\uF002"))), createElement("input", {
      id: "search_textbox",
      className: "dropdown-panel-search-input",
      type: "text",
      placeholder: "Search unregistered equipment..."
      /*maxlength="100" tabindex="-1" onkeyup="search.onSearchText(this)" onfocus="search.onFocusSearch()" onclick="search.onFocusSearch()" onkeypress="search.onEnterPress(event)"*/

    }), createElement("div", {
      id: "search-clear",
      className: "dropdown-panel-search-clear"
      /*onclick="search.onClearText()" style="display: none;"*/

    }, createElement("i", {
      className: "fa fa-times"
    }))))), createElement("div", {
      className: "search-list-filter-container"
      /*onclick="search.onClickFilterIcon()" style="display: none;"*/

    }, createElement("div", {
      className: "filter-text"
    }, "Filter: ", createElement("span", {
      id: "filterType"
    }, "Unregistered Equipment")), createElement("div", {
      className: "search-list-filter-icon search-list-advance-icon"
    }, createElement("div", {
      className: "content"
    }, createElement("div", {
      className: "valign"
    }, createElement("span", null, "\uF0B0")))), createElement("div", {
      className: "search-list-filter-icon search-list-filter-icon-down"
    }, createElement("div", {
      className: "content"
    }, createElement("div", {
      className: "valign"
    }, createElement("span", null, "\uF107"))))), createElement("div", null, createElement("table", {
      id: "filter-equipment-table",
      className: "e-dropdown-list-filter-option filter-group-advance-table"
      /*style="display: none;"*/

    }, createElement("tbody", null, createElement("tr", null, createElement("td", {
      id: "registered-equipment-selection"
    }), createElement("td", null, createElement("div", {
      className: "content"
    }, createElement("div", {
      className: "valign"
    }, createElement("span", null, "Registered"), createElement("span", null, " "), createElement("span", {
      className: "modal-filter-description"
    }))))), createElement("tr", null, createElement("td", {
      id: "unregistered-equipment-selection",
      className: "dropdown-list-filter-option-selected"
    }), createElement("td", null, createElement("div", {
      className: "content"
    }, createElement("div", {
      className: "valign"
    }, createElement("span", null, "Unregistered"), createElement("span", null, " "), createElement("span", {
      className: "modal-filter-description"
    }))))), createElement("tr", null, createElement("td", {
      id: "all-equipment-selection"
    }), createElement("td", null, createElement("div", {
      className: "content"
    }, createElement("div", {
      className: "valign"
    }, createElement("span", null, "All"), createElement("span", null, " "), createElement("span", {
      className: "modal-filter-description"
    })))))))), createElement("div", {
      className: "dropdown-panel-lists"
      /*style="display: none; height: 52px;"*/

    }, createElement("table", {
      id: "tbl-search-list",
      className: "search-table"
    }, createElement("tbody", {
      className: "v-scrollable"
    }, createElement("tr", {
      id: "1227e823-09f6-44da-b767-c2cd0eba3ae4",
      "data-id": "1227e823-09f6-44da-b767-c2cd0eba3ae4",
      "data-isregistered": "false",
      "data-code": "APV-2",
      "data-description": "",
      "data-type": "",
      className: "hover-click"
    }, createElement("td", {
      className: "dropdown-list-item-cell text-cell"
    }, createElement("div", {
      className: "content"
    }, createElement("div", {
      className: "valign"
    }, createElement("div", {
      className: "dropdown-list-item-code",
      title: "APV-2"
    }, "APV-2"), createElement("div", {
      className: "dropdown-list-item-description equipment",
      title: ""
    })))), createElement("td", {
      className: "dropdown-list-item-cell type-cell"
    }, createElement("div", {
      className: "content"
    }, createElement("div", {
      className: "valign"
    }, createElement("span", {
      className: "dropdown-list-item-description equipment",
      title: ""
    })))), createElement("td", {
      id: "LIST_1227e823-09f6-44da-b767-c2cd0eba3ae4",
      className: "dropdown-list-item-cell",
      "data-entity": "Equipment"
    })))))), createElement("div", {
      className: "page-header details-header"
    }, createElement("h1", null, this.props.children)));
  };

  return DetailPageTitle;
}(Component);
DetailPageTitle.defaultProps = {
  title: "Details Page Title"
};

function _templateObject$K() {
  var data = _taggedTemplateLiteralLoose(["\n  h3 {\n    font-size: ", ";\n    color: ", ";\n  }\n"]);

  _templateObject$K = function _templateObject() {
    return data;
  };

  return data;
}
var StyledSubTitle =
/*#__PURE__*/
styled.div(
/*#__PURE__*/
_templateObject$K(), function (props) {
  return props.theme.baseTheme === "Ace" ? "1.7rem" : "1.38rem";
}, function (props) {
  return props.theme.baseTheme === "Ace" ? "#808080" : "#000000";
});

var SubTitle =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(SubTitle, _React$Component);

  function SubTitle() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = SubTitle.prototype;

  _proto.render = function render() {
    return createElement(StyledSubTitle, null, createElement("div", null, createElement("h3", null, this.props.children)));
  };

  return SubTitle;
}(Component);

var Footer =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Footer, _React$Component);

  function Footer() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Footer.prototype;

  _proto.render = function render() {
    return createElement("footer", {
      className: "footer clear"
    }, createElement("div", {
      className: "center"
    }, createElement("a", {
      href: "http://www.hcss.com",
      target: "_blank",
      rel: "noopener noreferrer"
    }, "\xA9 ", new Date().getFullYear(), " HCSS"), this.props.children));
  };

  return Footer;
}(Component);
Footer.defaultProps = {
  children: " - Product 0.0.1"
};

function _templateObject4$9() {
  var data = _taggedTemplateLiteralLoose(["\n  & > div {\n    padding: 0.5em;\n  }\n"]);

  _templateObject4$9 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$e() {
  var data = _taggedTemplateLiteralLoose([""]);

  _templateObject3$e = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$o() {
  var data = _taggedTemplateLiteralLoose(["\n  background: ", ";\n  padding: 0.2em 0.5em;\n  font-size: 1.2em;\n  border-bottom: 1px solid\n    ", ";\n  height: 36px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n\n  i {\n    margin-right: 0.5em;\n  }\n\n  i.arrow {\n    float: right;\n    margin-top: 0.2em;\n    transition: transform 0.2s ease-in 0s;\n\n    &.open {\n      transform: rotate(90deg);\n    }\n  }\n"]);

  _templateObject2$o = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$L() {
  var data = _taggedTemplateLiteralLoose(["\n  white-space: nowrap;\n"]);

  _templateObject$L = function _templateObject() {
    return data;
  };

  return data;
}
var SectionWrapper =
/*#__PURE__*/
styled("div")(
/*#__PURE__*/
_templateObject$L());
var SectionHeader =
/*#__PURE__*/
styled("div")(
/*#__PURE__*/
_templateObject2$o(), function (props) {
  return props.theme.baseTheme === "Ace" ? gray300 : gray300$1;
}, function (props) {
  return props.theme.baseTheme === "Ace" ? gray400 : gray400$1;
});
var SectionBody =
/*#__PURE__*/
styled("div")(
/*#__PURE__*/
_templateObject3$e()); //Wrapping div around Section Body to fix choppy animations

var SectionCollapse =
/*#__PURE__*/
styled(Collapse)(
/*#__PURE__*/
_templateObject4$9());

var AsideSection =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(AsideSection, _React$Component);

  function AsideSection(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.state = {
      show: !_this.props.collapse
    };
    return _this;
  }

  var _proto = AsideSection.prototype;

  _proto.render = function render() {
    var _this2 = this;

    return createElement(SectionWrapper, {
      className: "modal-aside-section-wrapper"
    }, createElement(SectionHeader, {
      className: "modal-aside-section-header",
      onClick: function onClick() {
        return _this2.props.collapse && _this2.setState({
          show: !_this2.state.show
        });
      }
    }, this.props.iconName && createElement(Icon$1, {
      name: this.props.iconName
    }), this.props.title, this.props.collapse && createElement(Icon$1, {
      name: "chevron-right",
      className: this.state.show ? "arrow open" : "arrow"
    })), createElement(SectionCollapse, {
      "in": this.state.show
    }, createElement("div", null, createElement(SectionBody, {
      className: "modal-aside-section-body"
    }, this.props.children))));
  };

  return AsideSection;
}(Component);

function _templateObject5$5() {
  var data = _taggedTemplateLiteralLoose(["\n  width: 42px;\n  height: 40px;\n  font-size: 18px;\n  font-weight: 400;\n  color: #fff;\n  text-align: center;\n  border: none;\n  border-radius: 6px 0px 0px 6px;\n  padding: 6px 0 8px;\n  line-height: 1.7;\n  position: relative;\n  background: repeat-x\n    ", " !important;\n  z-index: 999;\n  position: relative;\n  float: left;\n  outline: 0;\n"]);

  _templateObject5$5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$a() {
  var data = _taggedTemplateLiteralLoose(["\n  overflow: hidden;\n"]);

  _templateObject4$a = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$f() {
  var data = _taggedTemplateLiteralLoose(["\n  font-size: 1.5em;\n  background-color: ", ";\n  color: ", ";\n  height: 40px;\n  font-weight: 600;\n  line-height: 1.8;\n  padding-left: 0.5em;\n  white-space: nowrap;\n  overflow: hidden;\n\n  & > button {\n    border: 0px;\n    background: none;\n    opacity: 0.75;\n    height: 40px;\n    color: white;\n    cursor: pointer;\n    outline: none;\n    font-size: 1.5em;\n    line-height: 0.5;\n    float: right;\n\n    &:hover {\n      opacity: 1;\n    }\n  }\n"]);

  _templateObject3$f = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$p() {
  var data = _taggedTemplateLiteralLoose(["\n  display: block;\n  background-color: white;\n  border: 0px solid\n    ", ";\n  box-shadow: -2px 1px 2px 0 rgba(0, 0, 0, 0.15);\n  border-radius: 0px;\n  overflow-y: auto;\n  width: auto;\n  max-width: 0;\n  max-height: 0;\n  float: left;\n  transition: max-width 0.25s linear 0s, max-height 0s linear 0.25s,\n    padding 0s linear 0.25s, border-width 0s linear 0.25s;\n\n  &.show {\n    max-width: ", ";\n    max-height: ", "px;\n    transition-delay: 0s;\n  }\n"]);

  _templateObject2$p = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$M() {
  var data = _taggedTemplateLiteralLoose(["\n  position: absolute;\n  z-index: 998;\n  right: 0;\n  top: auto;\n"]);

  _templateObject$M = function _templateObject() {
    return data;
  };

  return data;
}
var AsideWrapper =
/*#__PURE__*/
styled("div")(
/*#__PURE__*/
_templateObject$M());
var AsideContent =
/*#__PURE__*/
styled.div(
/*#__PURE__*/
_templateObject2$p(), function (props) {
  return props.theme.baseTheme === "Ace" ? gray300 : gray300$1;
}, function (props) {
  return props.maxWidth ? props.maxWidth : "420px";
}, function (props) {
  return props.maxHeight;
});
var AsideHeader =
/*#__PURE__*/
styled("div")(
/*#__PURE__*/
_templateObject3$f(), function (props) {
  return props.theme.baseTheme === "Ace" ? props.theme.navbarColor : "white";
}, function (props) {
  return props.theme.baseTheme === "Ace" ? "white" : "black";
});
var AsideBody =
/*#__PURE__*/
styled("div")(
/*#__PURE__*/
_templateObject4$a());
var ModalButton =
/*#__PURE__*/
styled("button")(
/*#__PURE__*/
_templateObject5$5(), function (props) {
  return props.theme.baseTheme === "Ace" ? "#ffb44b" : blue200;
}); // This needs to be a class so that it can export the AsideSection as a static property

var ModalAside =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(ModalAside, _React$Component);

  function ModalAside(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;

    _this.handleOpen = function () {
      // if we actually set the 'open' prop
      if (typeof _this.props.open === "boolean" && _this.props.onOpen) {
        // controlled behavior
        _this.props.onOpen();
      } else {
        // uncontrolled behavior
        _this.setState({
          show: true
        });
      }
    };

    _this.handleClose = function () {
      // if we actually set the 'open' prop
      if (typeof _this.props.open === "boolean" && _this.props.onClose) {
        // controlled behavior
        _this.props.onClose();
      } else {
        // uncontrolled behavior
        _this.setState({
          show: false
        });
      }
    };

    _this.toggleClick = function () {
      if (_this.state.show === true) {
        _this.handleClose();
      } else {
        _this.handleOpen();
      }
    };

    if (props.defaultOpen && typeof props.open !== "boolean") {
      _this.state = {
        show: true
      };
    } else {
      _this.state = {
        show: false
      };
    }

    return _this;
  }

  var _proto = ModalAside.prototype;

  _proto.componentDidUpdate = function componentDidUpdate() {
    if (this.props.open === true && this.state.show === false) {
      this.setState({
        show: true
      });
    }

    if (this.props.open === false && this.state.show === true) {
      this.setState({
        show: false
      });
    }
  };

  _proto.render = function render() {
    var _this$props$openIcon, _this$props$closeIcon;

    var maxHeight = Math.floor(window.innerHeight * 0.9);
    var open = (_this$props$openIcon = this.props.openIcon) !== null && _this$props$openIcon !== void 0 ? _this$props$openIcon : "fa fa-plus";
    var close = (_this$props$closeIcon = this.props.closeIcon) !== null && _this$props$closeIcon !== void 0 ? _this$props$closeIcon : "fa fa-minus";
    return createElement(AsideWrapper, {
      className: "modal-aside-wrapper"
    }, createElement(ModalButton, {
      onClick: this.toggleClick,
      className: "modal-aside-button"
    }, createElement("i", {
      className: this.state.show ? close : open
    })), createElement(AsideContent, {
      maxHeight: maxHeight,
      className: (this.state.show ? "show" : "") + " modal-aside-content",
      maxWidth: this.props.panelMaxWidth
    }, createElement(AsideHeader, {
      className: "modal-aside-header"
    }, this.props.title, createElement("button", {
      type: "button",
      onClick: this.handleClose
    }, createElement("span", {
      className: "white"
    }, "\xD7"))), createElement(AsideBody, {
      className: "modal-aside-body"
    }, this.props.children)));
  };

  return ModalAside;
}(Component);
ModalAside.Section = AsideSection;

function _templateObject$N() {
  var data = _taggedTemplateLiteralLoose(["\n  line-height: normal;\n"]);

  _templateObject$N = function _templateObject() {
    return data;
  };

  return data;
}

var L =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(L, _React$Component);

  function L() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = L.prototype;

  _proto.render = function render() {
    return this.props.isLoading ? createElement("i", {
      className: classNames(this.props.className, "fa fa-spinner fa-spin", this.props.size ? "fa-" + this.props.size + "x" : undefined)
    }) : null;
  };

  return L;
}(Component);

var StyledLoading =
/*#__PURE__*/
styled(L)(
/*#__PURE__*/
_templateObject$N());
function Loading(props) {
  return createElement(StyledLoading, Object.assign({}, props));
} //HACK: Somehow this is not working so doing this for now: https://react-styleguidist.js.org/docs/thirdparties.html#styled-components

function _templateObject3$g() {
  var data = _taggedTemplateLiteralLoose(["\n      & > div:last-child {\n        position: absolute;\n        top: 0;\n        left: 0;\n        bottom: 0;\n        right: 0;\n        background-color: rgba(255, 255, 255, 0.7);\n        overflow: hidden;\n        z-index: 1000;\n      }\n    "]);

  _templateObject3$g = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$q() {
  var data = _taggedTemplateLiteralLoose(["\n      width: fit-content;\n    "]);

  _templateObject2$q = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$O() {
  var data = _taggedTemplateLiteralLoose(["\n  position: relative;\n\n  ", " ", "\n\n\n  & > div:last-child > i {\n    position: absolute;\n    top: 35%;\n    width: 100%;\n    text-align: center;\n  }\n"]);

  _templateObject$O = function _templateObject() {
    return data;
  };

  return data;
}

var UnstyledLoadingContainer =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(UnstyledLoadingContainer, _React$Component);

  function UnstyledLoadingContainer() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = UnstyledLoadingContainer.prototype;

  _proto.render = function render() {
    return createElement("div", {
      className: this.props.className
    }, this.props.children, createElement("div", null, createElement(Loading, {
      isLoading: this.props.isLoading,
      size: this.props.size
    })));
  };

  return UnstyledLoadingContainer;
}(Component);

UnstyledLoadingContainer.defaultProps = {
  isLoading: false,
  fitContentWidth: false
};
var StyledLoadingContainer =
/*#__PURE__*/
styled(UnstyledLoadingContainer)(
/*#__PURE__*/
_templateObject$O(), function (props) {
  return props.fitContentWidth && css(_templateObject2$q());
}, function (props) {
  return props.isLoading && css(_templateObject3$g());
}); //HACK: stupid ts. Had to add any to props or else failing right now

function LoadingContainer(_ref) {
  var children = _ref.children,
      props = _objectWithoutPropertiesLoose(_ref, ["children"]);

  return createElement(StyledLoadingContainer, Object.assign({}, props), children);
} //HACK: Somehow this is not working so doing this for now: https://react-styleguidist.js.org/docs/thirdparties.html#styled-components

var WidgetContext =
/*#__PURE__*/
createContext({
  open: undefined,
  handleToggle: undefined
});

function _templateObject2$r() {
  var data = _taggedTemplateLiteralLoose(["\n  padding: 12px;\n"]);

  _templateObject2$r = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$P() {
  var data = _taggedTemplateLiteralLoose(["\n  color: ", ";\n"]);

  _templateObject$P = function _templateObject() {
    return data;
  };

  return data;
}

var Body = function Body(_ref) {
  var className = _ref.className,
      children = _ref.children,
      props = _objectWithoutPropertiesLoose(_ref, ["className", "ref", "children"]);

  var context = useContext(WidgetContext);
  if (context.open !== undefined) return createElement(Collapse, {
    "in": context.open
  }, createElement(WidgetBodyStyled, Object.assign({
    className: className
  }, props), createElement(WidgetMain, null, children)));
  return createElement(WidgetBodyStyled, Object.assign({
    className: className
  }, props), createElement(WidgetMain, null, children));
};
var WidgetBodyStyled =
/*#__PURE__*/
styled.div(
/*#__PURE__*/
_templateObject$P(), function (props) {
  return props.disabled ? "#707070" : "inherit";
});
var WidgetMain =
/*#__PURE__*/
styled.div(
/*#__PURE__*/
_templateObject2$r());

function _templateObject$Q() {
  var data = _taggedTemplateLiteralLoose(["\n  box-sizing: content-box;\n  position: relative;\n  height: 36px;\n  color: ", ";\n  border-bottom: ", ";\n  padding-left: 12px;\n\n  &.draggable {\n    cursor: move;\n    cursor: grab;\n    &:before {\n      content: \"\\e951\";\n      font-family: \"FontAwesome\";\n      margin-right: 10px;\n      width: 16px;\n      display: inline-block;\n    }\n    &:hover {\n      background-color: ", ";\n    }\n  }\n  &.draggable.active {\n    cursor: grabbing;\n  }\n  &:before,\n  &:after {\n    content: \"\";\n    display: table;\n    line-height: 0;\n  }\n\n  &:after {\n    clear: right;\n  }\n"], ["\n  box-sizing: content-box;\n  position: relative;\n  height: 36px;\n  color: ", ";\n  border-bottom: ", ";\n  padding-left: 12px;\n\n  &.draggable {\n    cursor: move;\n    cursor: grab;\n    &:before {\n      content: \"\\\\e951\";\n      font-family: \"FontAwesome\";\n      margin-right: 10px;\n      width: 16px;\n      display: inline-block;\n    }\n    &:hover {\n      background-color: ", ";\n    }\n  }\n  &.draggable.active {\n    cursor: grabbing;\n  }\n  &:before,\n  &:after {\n    content: \"\";\n    display: table;\n    line-height: 0;\n  }\n\n  &:after {\n    clear: right;\n  }\n"]);

  _templateObject$Q = function _templateObject() {
    return data;
  };

  return data;
}
var Header = function Header(_ref) {
  var className = _ref.className,
      children = _ref.children,
      draggable = _ref.draggable,
      theme = _ref.theme,
      props = _objectWithoutPropertiesLoose(_ref, ["className", "ref", "children", "draggable", "theme"]);

  var context = useContext(WidgetContext);
  var noBorder = false;

  if (props.hideBorder === true) {
    noBorder = true;
  }

  if (!context.open) {
    noBorder = true;
  }

  return createElement(StyledHeader, Object.assign({
    noBorder: noBorder,
    theme: theme,
    className: classNames(className, {
      draggable: draggable
    })
  }, props), children);
};
var ThemedHeader =
/*#__PURE__*/
withTheme(Header);
var StyledHeader =
/*#__PURE__*/
styled.div(
/*#__PURE__*/
_templateObject$Q(), function (props) {
  return props.theme && props.theme.baseTheme === "Concrete" ? gray700$1 : gray800;
}, function (props) {
  return props.noBorder ? "0px" : "1px solid #ddd";
}, function (props) {
  return props.theme !== undefined && props.theme.baseTheme === "Concrete" ? blue100 : gray100;
});

function _templateObject$R() {
  var data = _taggedTemplateLiteralLoose(["\n  font-weight: ", ";\n  color: ", ";\n\n  &.collapse {\n    cursor: pointer;\n    &::before {\n      content: \"\\f105\";\n      font-family: \"FontAwesome\";\n      margin-right: 10px;\n      width: 12px;\n    }\n  }\n  &.collapse.in {\n    &::before {\n      content: \"\\f107\";\n    }\n    display: inline;\n  }\n\n  line-height: 36px;\n  padding: 0;\n  margin: 0;\n  display: inline;\n\n  & > i,\n  & > .ace-icon {\n    margin-right: 0.7em;\n    font-weight: 400;\n    display: inline-block;\n  }\n"], ["\n  font-weight: ", ";\n  color: ", ";\n\n  &.collapse {\n    cursor: pointer;\n    &::before {\n      content: \"\\\\f105\";\n      font-family: \"FontAwesome\";\n      margin-right: 10px;\n      width: 12px;\n    }\n  }\n  &.collapse.in {\n    &::before {\n      content: \"\\\\f107\";\n    }\n    display: inline;\n  }\n\n  line-height: 36px;\n  padding: 0;\n  margin: 0;\n  display: inline;\n\n  & > i,\n  & > .ace-icon {\n    margin-right: 0.7em;\n    font-weight: 400;\n    display: inline-block;\n  }\n"]);

  _templateObject$R = function _templateObject() {
    return data;
  };

  return data;
}

var Title = function Title(_ref) {
  var className = _ref.className,
      children = _ref.children,
      props = _objectWithoutPropertiesLoose(_ref, ["className", "ref", "children"]);

  var context = useContext(WidgetContext);
  return createElement(StyledWidgetTitle, Object.assign({
    disabled: props.disabled,
    className: classNames(className, {
      collapse: context.handleToggle
    }, {
      "in": context.open
    })
  }, props, {
    onClick: context.handleToggle
  }), children);
};
var StyledWidgetTitle =
/*#__PURE__*/
styled.h4(
/*#__PURE__*/
_templateObject$R(), function (props) {
  return props.disabled ? "normal" : "bold";
}, function (props) {
  return props.disabled ? "#707070" : "inherit";
});

function _templateObject$S() {
  var data = _taggedTemplateLiteralLoose(["\n  line-height: 36px;\n  padding: 0;\n  margin: 0;\n  display: block;\n  padding: 0 10px;\n  line-height: 36px;\n  float: right;\n  position: relative;\n  &:before {\n    display: inline-block;\n    content: \"\";\n    position: absolute;\n    top: 3px;\n    bottom: 3px;\n    left: -1px;\n    border: 1px solid #d9d9d9;\n    border-width: 0 1px 0 0;\n  }\n\n  &.no-border:before {\n    display: none;\n  }\n\n  & > label {\n    display: inline-block;\n    vertical-align: middle;\n    margin-bottom: 0;\n  }\n\n  & > .widget-menu {\n    display: inline-block;\n    position: relative;\n  }\n\n  & > .widget-menu > a,\n  & > a {\n    font-size: 14px;\n    display: inline-block;\n    padding: 0;\n    line-height: 36px;\n  }\n\n  & > .widget-menu > a:hover,\n  & > a:hover {\n    text-decoration: none;\n  }\n\n  & > .widget-menu > a[data-action],\n  & > a[data-action] {\n    -webkit-transition: transform 0.1s;\n    -o-transition: transform 0.1s;\n    transition: transform 0.1s;\n  }\n  & > .widget-menu > a[data-action] > .ace-icon,\n  & > a[data-action] > .ace-icon {\n    margin-right: 0;\n  }\n  & > .widget-menu > a[data-action]:focus,\n  & > a[data-action]:focus {\n    text-decoration: none;\n    outline: 0;\n  }\n  & > .widget-menu > a[data-action]:hover,\n  & > a[data-action]:hover {\n    -moz-transform: scale(1.2);\n    -webkit-transform: scale(1.2);\n    -o-transform: scale(1.2);\n    -ms-transform: scale(1.2);\n    transform: scale(1.2);\n  }\n  & .progress {\n    vertical-align: middle;\n    display: inline-block;\n    margin: 0;\n  }\n  & > .dropdown,\n  & > .dropup {\n    display: inline-block;\n  }\n  .widget-toolbox.toolbox-vertical,\n  .widget-toolbox.toolbox-vertical + .widget-main {\n    display: table-cell;\n    vertical-align: top;\n  }\n  & > .nav-tabs {\n    border-bottom-width: 0;\n    margin-bottom: 0;\n    top: auto;\n    margin-top: 3px !important;\n  }\n  & > .nav-tabs > li {\n    margin-bottom: auto;\n  }\n  & > .nav-tabs > li > a {\n    box-shadow: none;\n    position: relative;\n    top: 1px;\n    margin-top: 1px;\n  }\n  & > .nav-tabs > li:not(.active) > a {\n    border-color: transparent;\n    background-color: transparent;\n  }\n  & > .nav-tabs > li:not(.active) > a:hover {\n    background-color: transparent;\n  }\n  & > .nav-tabs > li.active > a {\n    background-color: #fff;\n    border-bottom-color: transparent;\n    box-shadow: none;\n    margin-top: auto;\n  }\n  & > .nav-tabs .widget-color-orange > .widget-header > li > a {\n    color: #855d10;\n  }\n\n  & > .btn-toolbar {\n    margin: 0 !important;\n    padding: 0;\n  }\n"]);

  _templateObject$S = function _templateObject() {
    return data;
  };

  return data;
}

var Tools = function Tools(_ref) {
  var className = _ref.className,
      children = _ref.children,
      props = _objectWithoutPropertiesLoose(_ref, ["className", "ref", "children"]);

  return createElement(Toolbar, Object.assign({
    className: className
  }, props), children);
};
var Toolbar =
/*#__PURE__*/
styled.div(
/*#__PURE__*/
_templateObject$S());

function _templateObject2$s() {
  var data = _taggedTemplateLiteralLoose(["\n  padding: 0;\n  margin: 3px 0;\n  border: ", ";\n"]);

  _templateObject2$s = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$T() {
  var data = _taggedTemplateLiteralLoose(["\n  background-color: ", ";\n"]);

  _templateObject$T = function _templateObject() {
    return data;
  };

  return data;
}

var Widget =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Widget, _React$Component);

  function Widget(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;

    _this.handleToggle = function () {
      _this.setState({
        open: !_this.state.open
      });
    };

    _this.state = {
      open: props.open ? props.open : false,
      handleToggle: _this.handleToggle
    };
    return _this;
  }

  var _proto = Widget.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        children = _this$props.children,
        collapsible = _this$props.collapsible,
        props = _objectWithoutPropertiesLoose(_this$props, ["className", "ref", "children", "collapsible", "hideBorder"]);

    var additionalClasses = "";

    if (this.props.isCard) {
      additionalClasses = " card ";
    }

    var noBorder = false;

    if (this.props.hideBorder) {
      noBorder = true;
    }

    var backgroundColor = "";

    if (this.props.disabled) {
      backgroundColor = "#f6f6f6";
    }

    if (this.props.overrideBackgroundColor) {
      backgroundColor = this.props.overrideBackgroundColor;
    }

    var disabled = false;

    if (this.props.disabled) {
      disabled = true;
    }

    var WidgetComponent = createElement(WidgetContainer, Object.assign({
      backgroundColor: backgroundColor,
      className: additionalClasses + " " + this.props.className,
      disabled: disabled
    }, props), createElement(WidgetBox, {
      hideBorder: noBorder
    }, children));
    if (collapsible) return createElement(WidgetContext.Provider, {
      value: this.state
    }, WidgetComponent);else return createElement(Fragment, null, WidgetComponent);
  };

  return Widget;
}(Component);
Widget.defaultProps = {
  isCard: true,
  hideBorder: false
};
Widget.Body = Body;
Widget.Header = ThemedHeader;
Widget.Title = Title;
Widget.Tools = Tools;
var WidgetContainer =
/*#__PURE__*/
styled.div(
/*#__PURE__*/
_templateObject$T(), function (props) {
  return props.backgroundColor || "#fff";
});
var WidgetBox =
/*#__PURE__*/
styled.div(
/*#__PURE__*/
_templateObject2$s(), function (props) {
  return props.hideBorder ? "0px" : "1px solid #ccc";
});

var TextField =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(TextField, _React$Component);

  function TextField(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.leftLabel = null;
    _this.rightLabel = null;
    _this.state = {
      paddingStyle: {}
    };
    return _this;
  }

  var _proto = TextField.prototype;

  _proto.componentDidMount = function componentDidMount() {
    var leftPadding = this.props.leftUnit && this.leftLabel ? this.leftLabel.offsetWidth + 10 + "px" : "4px";
    var rightPadding = this.props.rightUnit && this.rightLabel ? this.rightLabel.offsetWidth + 10 + "px" : "4px";
    var fieldWidth = this.props.leftUnit || this.props.rightUnit ? "180px" : "auto";

    if (this.props.leftUnit || this.props.rightUnit) {
      this.setState({
        paddingStyle: {
          paddingLeft: leftPadding,
          paddingRight: rightPadding,
          width: fieldWidth
        }
      });
    }
  };

  _proto.render = function render() {
    var _this2 = this;

    var _this$props = this.props,
        leftUnit = _this$props.leftUnit,
        rightUnit = _this$props.rightUnit,
        other = _objectWithoutPropertiesLoose(_this$props, ["leftUnit", "rightUnit"]);

    var base = createElement("input", Object.assign({
      type: "text",
      style: this.state.paddingStyle
    }, other));
    var left = this.props.leftUnit ? createElement("label", {
      ref: function ref(_ref) {
        return _this2.leftLabel = _ref;
      },
      className: "input-group-unit"
    }, leftUnit) : null;
    var right = this.props.rightUnit ? createElement("label", {
      ref: function ref(_ref2) {
        return _this2.rightLabel = _ref2;
      },
      className: "input-group-unit"
    }, rightUnit) : null;

    if (this.props.rightUnit || this.props.leftUnit) {
      return createElement("div", {
        className: "input-group input-group-sm"
      }, left, base, right);
    }

    return base;
  };

  return TextField;
}(Component);

function _templateObject$U() {
  var data = _taggedTemplateLiteralLoose(["\n  .react-date-picker {\n    display: inline-flex;\n    position: relative;\n    -moz-box-sizing: border-box;\n    -webkit-box-sizing: border-box;\n    box-sizing: border-box;\n\n    & *,\n    & *:before,\n    & *:after {\n      -moz-box-sizing: border-box;\n      -webkit-box-sizing: border-box;\n      box-sizing: border-box;\n    }\n\n    &.react-date-picker--disabled {\n      background-color: #f0f0f0;\n      color: #6d6d6d;\n    }\n\n    & .react-date-picker__button {\n      display: flex;\n      border: 0px;\n\n      & > .react-date-picker__button__input:not(:disabled):hover,\n      & > .react-date-picker__button__input:not(:disabled):hover,\n      & > .react-date-picker__button__icon:not([disabled]):hover,\n      & > .react-date-picker__button__icon:not([disabled]):hover {\n        border-color: #ff893c;\n        z-index: 100;\n      }\n\n      & > .react-date-picker__button__input:focus,\n      & > .react-date-picker__button__icon:focus {\n        border-color: #f59942;\n      }\n\n      & .react-date-picker__button__input {\n        min-width: calc(4px + (4px * 3) + 4.32em + 0.434em);\n        flex-grow: 1;\n        display: flex;\n        padding: 0 5px;\n        border: 1px solid #cccccc;\n        margin-right: -1px;\n        align-items: baseline;\n\n        .react-date-picker__button__input__divider {\n          padding: 1px 2px;\n        }\n        .react-date-picker__button__input__input {\n          min-width: 0.54em;\n          height: 100%;\n          position: relative;\n          padding: 0px;\n          border: 0;\n          background: none;\n          -moz-appearance: textfield;\n\n          &::-webkit-inner-spin-button,\n          &::-webkit-outer-spin-button {\n            -webkit-appearance: none;\n            margin: 0;\n          }\n\n          &:invalid {\n            background: #ffc0d0;\n            background: rgba(255, 0, 0, 0.1);\n          }\n\n          &.react-date-picker__button__input__input--hasLeadingZero {\n            min-width: calc(4px + 1.08em);\n            margin-left: -0.54em;\n            padding-left: calc(1px + 0.54em);\n          }\n        }\n      }\n\n      & .react-date-picker__clear-button {\n        display: none;\n      }\n\n      & .react-date-picker__calendar-button {\n        &:hover,\n        &:focus {\n          color: #005eb8;\n        }\n\n        &:disabled {\n          > i {\n            color: #6d6d6d;\n          }\n        }\n      }\n\n      .react-date-picker__button__icon {\n        border: 1px solid #cccccc;\n        background: #eeeeee;\n        padding: 4px 8px;\n\n        &:enabled {\n          cursor: pointer;\n\n          & svg {\n            display: inherit;\n          }\n        }\n      }\n    }\n\n    .react-date-picker__calendar {\n      position: absolute;\n      width: 300px;\n      max-width: 100vw;\n      padding: 4px;\n      margin-top: 40px;\n      margin-left: ", ";\n      z-index: 150;\n      background: #ffffff;\n      border: 1px solid #cccccc;\n      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\n\n      &:before {\n        content: \"\\25B2\";\n        display: block;\n        position: absolute;\n        top: -14px;\n        left: ", ";\n        color: #ffffff;\n        text-shadow: 0px -3px 0px rgba(0, 0, 0, 0.2);\n      }\n\n      &.react-date-picker__calendar--closed {\n        display: none;\n      }\n      &.react-date-picker__calendar--above-label {\n        bottom: 100%;\n        top: auto;\n      }\n\n      & .react-calendar {\n        border: 1px thin #a0a096;\n        background: #ffffff;\n        font-family: Arial, Helvetica, sans-serif;\n        line-height: 1.125em;\n\n        & button {\n          margin: 0;\n          border: 0;\n          outline: none;\n\n          &:enabled:hover {\n            cursor: pointer;\n          }\n        }\n\n        & > .react-calendar__navigation {\n          height: 30px;\n          margin-bottom: 0;\n          font-weight: 700;\n\n          & button {\n            min-width: 30px;\n            background: none;\n            padding-bottom: 5px;\n\n            &:enabled {\n              &:hover,\n              &:focus {\n                background: #e6e6e6;\n              }\n            }\n\n            &[disabled],\n            &:disabled {\n              background: #f0f0f0;\n            }\n\n            &.react-calendar__navigation__arrow {\n              font-size: 1.1em;\n            }\n            &.react-calendar__navigation__label {\n              font-size: 0.9em;\n              line-height: 28px;\n            }\n\n            &.react-calendar__navigation__prev2-button,\n            &.react-calendar__navigation__next2-button {\n              display: none !important;\n            }\n          }\n        }\n\n        & > .react-calendar__month-view {\n          & .react-calendar__month-view__weekdays {\n            text-align: center;\n            font-weight: 700;\n            font-size: 0.875em;\n\n            & .react-calendar__month-view__weekdays__weekday {\n              padding: 0.4em 0.2em 0.4em 0.5em;\n            }\n          }\n\n          & .react-calendar__month-view__days__day--neighboringMonth {\n            color: #969696;\n          }\n        }\n\n        & .react-calendar__year-view .react-calendar__tile,\n        & .react-calendar__decade-view .react-calendar__tile,\n        & .react-calendar__century-view .react-calendar__tile {\n          padding: 2em 0.5em;\n        }\n\n        & .react-calendar__tile {\n          max-width: 100%;\n          font-size: 0.95em;\n          font-weight: 400;\n          text-align: center;\n          padding: 0.5em 0.2em;\n          background: none;\n\n          &:disabled,\n          &[disabled] {\n            background-color: #f0f0f0;\n          }\n\n          &:enabled {\n            &:hover,\n            &:focus {\n              background: #ececec;\n            }\n          }\n        }\n\n        & .react-calendar__tile--hasActive {\n          background: #76baff;\n          &:enabled {\n            &:hover,\n            &:focus {\n              background: #a9d4ff;\n            }\n          }\n        }\n\n        .react-calendar__tile--active {\n          background: #005eb8;\n          color: #ffffff;\n\n          &:enabled {\n            &:hover,\n            &:focus {\n              background: #1087ff;\n            }\n          }\n        }\n      }\n    }\n  }\n"], ["\n  .react-date-picker {\n    display: inline-flex;\n    position: relative;\n    -moz-box-sizing: border-box;\n    -webkit-box-sizing: border-box;\n    box-sizing: border-box;\n\n    & *,\n    & *:before,\n    & *:after {\n      -moz-box-sizing: border-box;\n      -webkit-box-sizing: border-box;\n      box-sizing: border-box;\n    }\n\n    &.react-date-picker--disabled {\n      background-color: #f0f0f0;\n      color: #6d6d6d;\n    }\n\n    & .react-date-picker__button {\n      display: flex;\n      border: 0px;\n\n      & > .react-date-picker__button__input:not(:disabled):hover,\n      & > .react-date-picker__button__input:not(:disabled):hover,\n      & > .react-date-picker__button__icon:not([disabled]):hover,\n      & > .react-date-picker__button__icon:not([disabled]):hover {\n        border-color: #ff893c;\n        z-index: 100;\n      }\n\n      & > .react-date-picker__button__input:focus,\n      & > .react-date-picker__button__icon:focus {\n        border-color: #f59942;\n      }\n\n      & .react-date-picker__button__input {\n        min-width: calc(4px + (4px * 3) + 4.32em + 0.434em);\n        flex-grow: 1;\n        display: flex;\n        padding: 0 5px;\n        border: 1px solid #cccccc;\n        margin-right: -1px;\n        align-items: baseline;\n\n        .react-date-picker__button__input__divider {\n          padding: 1px 2px;\n        }\n        .react-date-picker__button__input__input {\n          min-width: 0.54em;\n          height: 100%;\n          position: relative;\n          padding: 0px;\n          border: 0;\n          background: none;\n          -moz-appearance: textfield;\n\n          &::-webkit-inner-spin-button,\n          &::-webkit-outer-spin-button {\n            -webkit-appearance: none;\n            margin: 0;\n          }\n\n          &:invalid {\n            background: #ffc0d0;\n            background: rgba(255, 0, 0, 0.1);\n          }\n\n          &.react-date-picker__button__input__input--hasLeadingZero {\n            min-width: calc(4px + 1.08em);\n            margin-left: -0.54em;\n            padding-left: calc(1px + 0.54em);\n          }\n        }\n      }\n\n      & .react-date-picker__clear-button {\n        display: none;\n      }\n\n      & .react-date-picker__calendar-button {\n        &:hover,\n        &:focus {\n          color: #005eb8;\n        }\n\n        &:disabled {\n          > i {\n            color: #6d6d6d;\n          }\n        }\n      }\n\n      .react-date-picker__button__icon {\n        border: 1px solid #cccccc;\n        background: #eeeeee;\n        padding: 4px 8px;\n\n        &:enabled {\n          cursor: pointer;\n\n          & svg {\n            display: inherit;\n          }\n        }\n      }\n    }\n\n    .react-date-picker__calendar {\n      position: absolute;\n      width: 300px;\n      max-width: 100vw;\n      padding: 4px;\n      margin-top: 40px;\n      margin-left: ", ";\n      z-index: 150;\n      background: #ffffff;\n      border: 1px solid #cccccc;\n      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\n\n      &:before {\n        content: \"\\\\25B2\";\n        display: block;\n        position: absolute;\n        top: -14px;\n        left: ", ";\n        color: #ffffff;\n        text-shadow: 0px -3px 0px rgba(0, 0, 0, 0.2);\n      }\n\n      &.react-date-picker__calendar--closed {\n        display: none;\n      }\n      &.react-date-picker__calendar--above-label {\n        bottom: 100%;\n        top: auto;\n      }\n\n      & .react-calendar {\n        border: 1px thin #a0a096;\n        background: #ffffff;\n        font-family: Arial, Helvetica, sans-serif;\n        line-height: 1.125em;\n\n        & button {\n          margin: 0;\n          border: 0;\n          outline: none;\n\n          &:enabled:hover {\n            cursor: pointer;\n          }\n        }\n\n        & > .react-calendar__navigation {\n          height: 30px;\n          margin-bottom: 0;\n          font-weight: 700;\n\n          & button {\n            min-width: 30px;\n            background: none;\n            padding-bottom: 5px;\n\n            &:enabled {\n              &:hover,\n              &:focus {\n                background: #e6e6e6;\n              }\n            }\n\n            &[disabled],\n            &:disabled {\n              background: #f0f0f0;\n            }\n\n            &.react-calendar__navigation__arrow {\n              font-size: 1.1em;\n            }\n            &.react-calendar__navigation__label {\n              font-size: 0.9em;\n              line-height: 28px;\n            }\n\n            &.react-calendar__navigation__prev2-button,\n            &.react-calendar__navigation__next2-button {\n              display: none !important;\n            }\n          }\n        }\n\n        & > .react-calendar__month-view {\n          & .react-calendar__month-view__weekdays {\n            text-align: center;\n            font-weight: 700;\n            font-size: 0.875em;\n\n            & .react-calendar__month-view__weekdays__weekday {\n              padding: 0.4em 0.2em 0.4em 0.5em;\n            }\n          }\n\n          & .react-calendar__month-view__days__day--neighboringMonth {\n            color: #969696;\n          }\n        }\n\n        & .react-calendar__year-view .react-calendar__tile,\n        & .react-calendar__decade-view .react-calendar__tile,\n        & .react-calendar__century-view .react-calendar__tile {\n          padding: 2em 0.5em;\n        }\n\n        & .react-calendar__tile {\n          max-width: 100%;\n          font-size: 0.95em;\n          font-weight: 400;\n          text-align: center;\n          padding: 0.5em 0.2em;\n          background: none;\n\n          &:disabled,\n          &[disabled] {\n            background-color: #f0f0f0;\n          }\n\n          &:enabled {\n            &:hover,\n            &:focus {\n              background: #ececec;\n            }\n          }\n        }\n\n        & .react-calendar__tile--hasActive {\n          background: #76baff;\n          &:enabled {\n            &:hover,\n            &:focus {\n              background: #a9d4ff;\n            }\n          }\n        }\n\n        .react-calendar__tile--active {\n          background: #005eb8;\n          color: #ffffff;\n\n          &:enabled {\n            &:hover,\n            &:focus {\n              background: #1087ff;\n            }\n          }\n        }\n      }\n    }\n  }\n"]);

  _templateObject$U = function _templateObject() {
    return data;
  };

  return data;
}
var DatePickerWrapper =
/*#__PURE__*/
styled.div(
/*#__PURE__*/
_templateObject$U(), function (props) {
  return props.xOffset * -1 + -5 + "px";
}, function (props) {
  return props.xOffset + 36 + "px";
});

var DatePicker =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(DatePicker, _React$Component);

  function DatePicker() {
    var _this;

    _this = _React$Component.apply(this, arguments) || this;
    _this.datePicker = createRef();
    _this.state = {
      xOffset: 0
    };

    _this.calculateOffset = function () {
      var windowWidth = window.innerWidth;

      var dpDomRect = _this.datePicker.current.getBoundingClientRect();

      var leftDisp = dpDomRect.left;
      var distanceFromRight = windowWidth - leftDisp;

      if (distanceFromRight < 300) {
        var xOffset = Math.abs(distanceFromRight - 300);

        _this.setState({
          xOffset: xOffset
        });
      } else {
        _this.setState({
          xOffset: 0
        });
      }
    };

    return _this;
  }

  var _proto = DatePicker.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.calculateOffset();
  };

  _proto.render = function render() {
    var _this$props = this.props,
        className = _this$props.className,
        calendarClassName = _this$props.calendarClassName,
        containerClassName = _this$props.containerClassName,
        other = _objectWithoutPropertiesLoose(_this$props, ["className", "calendarClassName", "containerClassName"]);

    return createElement(DatePickerWrapper, {
      className: classNames("date-picker-wrapper", containerClassName),
      ref: this.datePicker,
      onClick: this.calculateOffset,
      xOffset: this.state.xOffset
    }, createElement(ReactDatePicker, Object.assign({
      className: classNames("hcss-date-picker", className),
      calendarClassName: classNames("hcss-date-picker-calendar", calendarClassName)
    }, other)));
  };

  return DatePicker;
}(Component);
DatePicker.defaultProps = {
  locale: "en-US",
  minDetail: "decade",
  calendarIcon:
  /*#__PURE__*/
  createElement("i", {
    className: "fa fa-calendar"
  })
};

function _templateObject$V() {
  var data = _taggedTemplateLiteralLoose(["\n  textarea {\n    min-height: 50px;\n    color: black;\n    border: 1px solid #d5d5d5;\n    border-radius: 0;\n    box-shadow: none !important;\n    padding: 5px 4px 6px;\n\n    :hover {\n      border-color: #b5b5b5;\n    }\n    :focus {\n      border-color: #f59942;\n      outline: none;\n      color: black;\n    }\n\n    ::placeholder {\n      color: #777777;\n      font-style: italic;\n    }\n  }\n\n  .textarea-counter {\n    display: block;\n    color: #777;\n    font-size: 13px;\n  }\n"]);

  _templateObject$V = function _templateObject() {
    return data;
  };

  return data;
}
var TextareaWrapper =
/*#__PURE__*/
styled.span(
/*#__PURE__*/
_templateObject$V());
var Textarea = function Textarea(props) {
  var textareaRef = useRef(null);

  var _useState = useState(0),
      remainingCharsCount = _useState[0],
      setRemainingCharsCount = _useState[1]; // Set to autosize if prop exists


  useEffect(function () {
    if (props.autoSize && textareaRef.current) {
      autosize(textareaRef.current);
    }
  }, [props.autoSize]); // Set initial Remaining characters count

  useEffect(function () {
    if (props.maxLength) {
      var _ref, _textareaRef$current, _textareaRef$current$;

      var initialTextAreaLength = (_ref = textareaRef === null || textareaRef === void 0 ? void 0 : (_textareaRef$current = textareaRef.current) === null || _textareaRef$current === void 0 ? void 0 : (_textareaRef$current$ = _textareaRef$current.value) === null || _textareaRef$current$ === void 0 ? void 0 : _textareaRef$current$.length) !== null && _ref !== void 0 ? _ref : 0;
      setRemainingCharsCount(props.maxLength - initialTextAreaLength);
    }
  }, [props.maxLength, setRemainingCharsCount]);

  var handleChange = function handleChange(event) {
    // Recalculate remaining characters on change
    if (props.maxLength && textareaRef.current) {
      setRemainingCharsCount(props.maxLength - textareaRef.current.value.length);
    } // Pass event on to change handler


    if (props.onChange) {
      props.onChange(event);
    }
  };

  var formControl = props.formControl,
      className = props.className,
      other = _objectWithoutPropertiesLoose(props, ["autoSize", "formControl", "className"]);

  return React__default.createElement(TextareaWrapper, null, React__default.createElement("textarea", Object.assign({}, other, {
    className: classNames(className, {
      "form-control": formControl
    }),
    ref: textareaRef,
    onChange: handleChange
  })), props.maxLength && React__default.createElement("span", {
    className: "textarea-counter"
  }, remainingCharsCount, " characters left"));
};

function _templateObject$W() {
  var data = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  & > div.drop-zone-class {\n    color: #f00;\n    width: 100%;\n    height: 100%;\n    display: table;\n    vertical-align: middle;\n    border: 2px dashed ", ";\n  }\n  & > div.drop-zone-class > div {\n    width: 100%;\n    height: 100%;\n    display: table-cell;\n    vertical-align: middle;\n    text-align: center;\n    display: inline-cell;\n    color: #000;\n    margin: 10px;\n  }\n"]);

  _templateObject$W = function _templateObject() {
    return data;
  };

  return data;
}
var StyledDropzone =
/*#__PURE__*/
styled.div(
/*#__PURE__*/
_templateObject$W(), gray500);

var Dropzone =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Dropzone, _React$Component);

  function Dropzone() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Dropzone.prototype;

  _proto.render = function render() {
    var message = this.props.message ? this.props.message : "Please drop your file(s) here or click to select";
    return createElement(StyledDropzone, null, createElement(ReactDropzone, Object.assign({
      className: "drop-zone-class"
    }, this.props), createElement("div", null, message)));
  };

  return Dropzone;
}(Component);

function _templateObject$X() {
  var data = _taggedTemplateLiteralLoose(["\n    label.required::after {\n        content: \" *\";\n        color: red;\n    } /* Putting this here as I don't know where else to put it*/\n  "]);

  _templateObject$X = function _templateObject() {
    return data;
  };

  return data;
}
var GlobalStyle =
/*#__PURE__*/
createGlobalStyle(
/*#__PURE__*/
_templateObject$X());

var _default =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(_default, _React$Component);

  function _default() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = _default.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        children = _this$props.children,
        props = _objectWithoutPropertiesLoose(_this$props, ["children"]);

    return createElement(ThemeProvider, Object.assign({}, props), createElement(Fragment, null, createElement(GlobalStyle, null), children));
  };

  return _default;
}(Component);

function _templateObject$Y() {
  var data = _taggedTemplateLiteralLoose(["\n  div[class^=\"AlertContainer-container\"] {\n    top: 50px;\n    z-index: 1051;\n  }\n\n  div.alert {\n    position: relative !important;\n    padding: 20px 24px 16px 24px;\n    min-width: 300px;\n    max-width: 400px;\n    font-family: Inter, Arial, sans-serif;\n  }\n\n  div.alert-success,\n  div.alert-info,\n  div.alert-warning,\n  div.alert-danger {\n    background-color: ", ";\n    color: white;\n    border: 0px solid white;\n    border-left-width: 40px;\n    box-shadow: 0 2px 8px -2px ", ";\n    border-radius: 4px;\n  }\n\n  .alert:before {\n    position: absolute;\n    font-size: 20px;\n  }\n\n  div.alert-success h4,\n  div.alert-info h4,\n  div.alert-warning h4,\n  div.alert-danger h4 {\n    font-weight: 600;\n    margin-bottom: 10px;\n  }\n  div.alert-success {\n    border-color: ", ";\n  }\n\n  div.alert-info {\n    border-color: ", ";\n  }\n  div.alert-warning {\n    border-color: #f67e17;\n  }\n  div.alert-danger {\n    border-color: ", ";\n  }\n  div.alert-success i,\n  div.alert-info i,\n  div.alert-warning i,\n  div.alert-danger i {\n    display: none;\n  }\n\n  div.alert-success:before,\n  div.alert-info:before,\n  div.alert-warning:before,\n  div.alert-danger:before {\n    font-family: \"FontAwesome\";\n    display: block;\n    width: 10px;\n    height: 0px;\n  }\n\n  div.alert-success:before {\n    content: \"\f00c\";\n    top: 13px;\n    left: -30px;\n  }\n  div.alert-info:before {\n    content: \"\f129\";\n    top: 14px;\n    left: -23px;\n  }\n  div.alert-warning:before {\n    content: \"\f071\";\n    top: 14px;\n    left: -30px;\n  }\n  div.alert-danger:before {\n    content: \"\f12a\";\n    top: 14px;\n    left: -23px;\n  }\n\n  .alert-dismissable > button[class*=\"close\"] {\n    display: none !important;\n  }\n\n  .alert > div[class*=\"msgContainer\"] {\n    width: 100%;\n  }\n  .alert > div[class*=\"msgContainer\"] > h4[class*=\"headline\"] {\n    font-size: 1.8rem;\n    color: #ffffff;\n  }\n  .alert > div[class*=\"msgContainer\"] > div[class*=\"body\"] {\n    font-size: 1.4rem;\n    white-space: normal;\n    word-break: break-all;\n    overflow: hidden;\n    max-width: unset;\n    color: ", ";\n  }\n\n  .alert .message-container {\n    & > .message-body-wrapper {\n      margin-bottom: 20px;\n    }\n    & > .message-footer-wrapper {\n      & > .alert-action-button {\n        padding: 4px 0;\n        margin-right: 8px;\n\n        border-width: 0;\n        font-size: 1.3rem;\n        font-weight: 600;\n        text-transform: uppercase;\n        color: #ffffff;\n\n        opacity: 1;\n        outline: none;\n\n        &,\n        &:active,\n        &:active:focus {\n          outline: none;\n        }\n\n        &:active,\n        &:active:focus {\n          color: ", ";\n        }\n      }\n    }\n  }\n"], ["\n  div[class^=\"AlertContainer-container\"] {\n    top: 50px;\n    z-index: 1051;\n  }\n\n  div.alert {\n    position: relative !important;\n    padding: 20px 24px 16px 24px;\n    min-width: 300px;\n    max-width: 400px;\n    font-family: Inter, Arial, sans-serif;\n  }\n\n  div.alert-success,\n  div.alert-info,\n  div.alert-warning,\n  div.alert-danger {\n    background-color: ", ";\n    color: white;\n    border: 0px solid white;\n    border-left-width: 40px;\n    box-shadow: 0 2px 8px -2px ", ";\n    border-radius: 4px;\n  }\n\n  .alert:before {\n    position: absolute;\n    font-size: 20px;\n  }\n\n  div.alert-success h4,\n  div.alert-info h4,\n  div.alert-warning h4,\n  div.alert-danger h4 {\n    font-weight: 600;\n    margin-bottom: 10px;\n  }\n  div.alert-success {\n    border-color: ", ";\n  }\n\n  div.alert-info {\n    border-color: ", ";\n  }\n  div.alert-warning {\n    border-color: #f67e17;\n  }\n  div.alert-danger {\n    border-color: ", ";\n  }\n  div.alert-success i,\n  div.alert-info i,\n  div.alert-warning i,\n  div.alert-danger i {\n    display: none;\n  }\n\n  div.alert-success:before,\n  div.alert-info:before,\n  div.alert-warning:before,\n  div.alert-danger:before {\n    font-family: \"FontAwesome\";\n    display: block;\n    width: 10px;\n    height: 0px;\n  }\n\n  div.alert-success:before {\n    content: \"\\f00c\";\n    top: 13px;\n    left: -30px;\n  }\n  div.alert-info:before {\n    content: \"\\f129\";\n    top: 14px;\n    left: -23px;\n  }\n  div.alert-warning:before {\n    content: \"\\f071\";\n    top: 14px;\n    left: -30px;\n  }\n  div.alert-danger:before {\n    content: \"\\f12a\";\n    top: 14px;\n    left: -23px;\n  }\n\n  .alert-dismissable > button[class*=\"close\"] {\n    display: none !important;\n  }\n\n  .alert > div[class*=\"msgContainer\"] {\n    width: 100%;\n  }\n  .alert > div[class*=\"msgContainer\"] > h4[class*=\"headline\"] {\n    font-size: 1.8rem;\n    color: #ffffff;\n  }\n  .alert > div[class*=\"msgContainer\"] > div[class*=\"body\"] {\n    font-size: 1.4rem;\n    white-space: normal;\n    word-break: break-all;\n    overflow: hidden;\n    max-width: unset;\n    color: ", ";\n  }\n\n  .alert .message-container {\n    & > .message-body-wrapper {\n      margin-bottom: 20px;\n    }\n    & > .message-footer-wrapper {\n      & > .alert-action-button {\n        padding: 4px 0;\n        margin-right: 8px;\n\n        border-width: 0;\n        font-size: 1.3rem;\n        font-weight: 600;\n        text-transform: uppercase;\n        color: #ffffff;\n\n        opacity: 1;\n        outline: none;\n\n        &,\n        &:active,\n        &:active:focus {\n          outline: none;\n        }\n\n        &:active,\n        &:active:focus {\n          color: ", ";\n        }\n      }\n    }\n  }\n"]);

  _templateObject$Y = function _templateObject() {
    return data;
  };

  return data;
}
/** Expect single instance of Notification */

/** @ignore */

var Notification =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Notification, _React$Component);

  function Notification(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.state = {
      alerts: []
    };

    _this.onAlertDismissed = function (alert) {
      _this.setState(function (prevState) {
        return {
          alerts: prevState.alerts.filter(function (a) {
            return a !== alert;
          })
        };
      });
    };

    _this.formatAlertMessage = function (alertId, message) {
      var handleDismiss = function handleDismiss() {
        var currentAlert = _this.state.alerts.find(function (a) {
          return a.id === alertId;
        });

        _this.onAlertDismissed(currentAlert);
      };

      var renderMessageBody = function renderMessageBody() {
        return createElement("div", {
          className: "message-body-wrapper"
        }, message);
      };

      var renderMessageFooter = function renderMessageFooter() {
        if (!!_this.props.theme && _this.props.theme.baseTheme === "Concrete") {
          return createElement("div", {
            className: "message-footer-wrapper"
          }, createElement(Button, {
            className: "alert-dismiss-button alert-action-button",
            onClick: handleDismiss,
            title: "Dismiss"
          }, "Dismiss"));
        }

        return null;
      };

      return createElement("div", {
        className: "message-container"
      }, !!message && renderMessageBody(), renderMessageFooter());
    };

    _this.notify = function (type, headline, message, timeout) {
      if (message === void 0) {
        message = "";
      }

      _this.setState(function (prevState) {
        var newAlertId = new Date().getTime();
        return {
          alerts: [].concat(prevState.alerts, [{
            id: newAlertId,
            type: type,
            headline: headline,
            message: _this.formatAlertMessage(newAlertId, message),
            timeout: timeout
          }])
        };
      });
    };

    _this.renderConcreteStyleOverrides = function () {
      if (!!_this.props.theme && _this.props.theme.baseTheme === "Concrete") return createElement(ConcreteStyles, null);
      return null;
    };

    Notification.Instance = _assertThisInitialized(_this);
    return _this;
  }

  var _proto = Notification.prototype;

  _proto.render = function render() {
    return createElement(Fragment, null, this.renderConcreteStyleOverrides(), createElement(AlertList, {
      alerts: this.state.alerts,
      onDismiss: this.onAlertDismissed
    }));
  };

  return Notification;
}(Component);
function notify(type, headline, message, timeout) {
  if (timeout === void 0) {
    timeout = 5000;
  }

  Notification.Instance.notify(type, headline, message, timeout);
}
var ConcreteStyles =
/*#__PURE__*/
createGlobalStyle(
/*#__PURE__*/
_templateObject$Y(), gray700$1, gray500$1, green200, blue200, red200, gray400$1, gray400$1);
var ThemedNotification =
/*#__PURE__*/
withTheme(Notification);

function _templateObject$Z() {
  var data = _taggedTemplateLiteralLoose(["\n  @media (min-width: 768px) {\n    .modal-dialog {\n      margin-top: 60px;\n    }\n  }\n\n  .modal-content {\n    border-radius: 0;\n    box-shadow: none;\n  }\n  .modal-header {\n    background-color: ", ";\n    color: ", ";\n    border-bottom-width: ", ";\n\n    & > button.close {\n      color: ", ";\n      opacity: 0.4;\n      font-size: 28px;\n      :hover {\n        opacity: 0.9;\n      }\n    }\n  }\n\n  .modal-footer {\n    background-color: ", ";\n    border-top-color: ", ";\n  }\n\n  &.modal-draggable {\n    .modal-dialog {\n      margin: 0;\n    }\n    .modal-header {\n      :before {\n        content: \"\\e951\";\n        font-family: \"FontAwesome\";\n        display: inline-block;\n        font-size: 16px;\n        margin-right: 8px;\n      }\n      & > h4 {\n        display: inline-block;\n      }\n    }\n  }\n"], ["\n  @media (min-width: 768px) {\n    .modal-dialog {\n      margin-top: 60px;\n    }\n  }\n\n  .modal-content {\n    border-radius: 0;\n    box-shadow: none;\n  }\n  .modal-header {\n    background-color: ", ";\n    color: ", ";\n    border-bottom-width: ", ";\n\n    & > button.close {\n      color: ", ";\n      opacity: 0.4;\n      font-size: 28px;\n      :hover {\n        opacity: 0.9;\n      }\n    }\n  }\n\n  .modal-footer {\n    background-color: ", ";\n    border-top-color: ", ";\n  }\n\n  &.modal-draggable {\n    .modal-dialog {\n      margin: 0;\n    }\n    .modal-header {\n      :before {\n        content: \"\\\\e951\";\n        font-family: \"FontAwesome\";\n        display: inline-block;\n        font-size: 16px;\n        margin-right: 8px;\n      }\n      & > h4 {\n        display: inline-block;\n      }\n    }\n  }\n"]);

  _templateObject$Z = function _templateObject() {
    return data;
  };

  return data;
}
var ModalWrapper =
/*#__PURE__*/
styled(Modal$1)(
/*#__PURE__*/
_templateObject$Z(), function (props) {
  return props.theme.baseTheme === "Ace" ? props.theme.navbarColor : "White";
}, function (props) {
  return props.theme.baseTheme === "Ace" ? "White" : "Black";
}, function (props) {
  return props.theme.baseTheme === "Ace" ? "1px" : "0px";
}, function (props) {
  return props.theme.baseTheme === "Ace" ? "White" : "Black";
}, function (props) {
  return props.theme.baseTheme === "Ace" ? "#EFF3F8" : "White";
}, function (props) {
  return props.theme.baseTheme === "Ace" ? "#E4E9EE" : "White";
});

var Modal =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Modal, _React$Component);

  function Modal(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this._waitingForMouseUp = false;
    _this._ignoreBackdropClick = false; // Check if user clicked down in modal

    _this.handleMouseDown = function (event) {
      if (event.target.dataset.__tag__ !== "hcss-modal-wrapper") {
        _this._waitingForMouseUp = true;
      }
    }; // Check If user started down click in modal and
    // up click was in the backdrop. If so, ignore backdrop click.


    _this.handleMouseUp = function (event) {
      if (_this._waitingForMouseUp && event.target.dataset.__tag__ === "hcss-modal-wrapper") {
        _this._ignoreBackdropClick = true;
      }

      _this._waitingForMouseUp = false;
    }; // Ignore Hiding if we are bypassing backdrop click


    _this.handleOnHide = function () {
      if (_this._ignoreBackdropClick) {
        _this._ignoreBackdropClick = false;
        return;
      }

      _this.props.onHide();
    };

    _this._modalRef = createRef();
    return _this;
  }

  var _proto = Modal.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        children = _this$props.children,
        className = _this$props.className,
        draggable = _this$props.draggable,
        props = _objectWithoutPropertiesLoose(_this$props, ["children", "className", "draggable", "onHide"]);

    return createElement(ModalWrapper, Object.assign({
      "data-__tag__": "hcss-modal-wrapper",
      className: classNames(className, {
        "modal-draggable": draggable
      }),
      onMouseDown: this.handleMouseDown,
      onMouseUp: this.handleMouseUp,
      onHide: this.handleOnHide,
      ref: this._modalRef
    }, props), children);
  };

  return Modal;
}(Component);
Modal.Header = ModalHeader;
Modal.Body = ModalBody;
Modal.Footer = ModalFooter;
Modal.Title = ModalTitle;
Modal.Dialog = ModalDialog;

function _templateObject$_() {
  var data = _taggedTemplateLiteralLoose(["\n  .react-select__control {\n    &.react-select__control--is-focused {\n      border-color: ", ";\n    }\n  }\n\n  .react-select__option {\n    &.react-select__option--is-focused:not(.react-select__option--is-selected) {\n      background-color: ", ";\n    }\n    &.react-select__option--is-selected {\n      background-color: ", ";\n    }\n  }\n\n  .react-select__multi-value {\n    background-color: ", ";\n  }\n  .react-select__multi-value__remove {\n    :hover {\n      color: ", ";\n      background-color: ", ";\n    }\n  }\n"]);

  _templateObject$_ = function _templateObject() {
    return data;
  };

  return data;
}
var StyledSelect =
/*#__PURE__*/
styled(ReactSelect)(
/*#__PURE__*/
_templateObject$_(), blue200, blue100, blue200, gray300$1, red200, red100);

var Select =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Select, _React$Component);

  function Select() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Select.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        children = _this$props.children,
        className = _this$props.className,
        props = _objectWithoutPropertiesLoose(_this$props, ["children", "className", "classNamePrefix"]);

    return createElement(StyledSelect, Object.assign({
      className: classNames("react-select", className),
      classNamePrefix: "react-select"
    }, props), children);
  };

  return Select;
}(Component);

var Toolbar$1 = function Toolbar(_ref) {
  var children = _ref.children,
      className = _ref.className,
      props = _objectWithoutPropertiesLoose(_ref, ["children", "className"]);

  return createElement("div", Object.assign({
    className: classNames("panel-toolbar", className)
  }, props), children);
};

function _templateObject$$() {
  var data = _taggedTemplateLiteralLoose(["\n  .panel {\n    border: none;\n    box-shadow: none;\n  }\n\n  a.collapsed {\n    .panel-title {\n      background-color: rgb(246, 246, 246);\n      color: #343434;\n      font-weight: 400;\n      :hover {\n      }\n      ::before {\n        content: \"\\F105\";\n      }\n    }\n\n    .panel-heading {\n      border-left: solid 2px rgb(217, 217, 217);\n    }\n  }\n\n  & > a:hover {\n    text-decoration: none;\n  }\n\n  .panel + .panel {\n    margin-top: 4px;\n  }\n\n  .panel-heading {\n    padding: 0;\n    background-color: rgb(245, 245, 245);\n    min-height: 36px;\n  }\n\n  .panel-title {\n    font-size: 13px;\n    padding: 10px;\n    display: inline-block;\n    position: relative;\n    line-height: 1;\n    color: #343434;\n    font-weight: 700;\n    :hover {\n      text-decoration: none;\n    }\n\n    ::before {\n      content: \"\\F107\";\n      font-family: \"FontAwesome\";\n      margin: 0 10px 0 5px;\n      width: 9px;\n      display: inline-block;\n      font-size: 15px;\n    }\n  }\n\n  .panel-toolbar {\n    float: right;\n    line-height: 36px;\n    display: block;\n    position: relative;\n    padding-right: 10px;\n\n    & label {\n      margin-bottom: 0;\n    }\n  }\n\n  .collapse {\n    background-color: #fff;\n  }\n\n  .panel.panel-default > .panel-collapse.in > div.panel-body {\n    border-top: 2px solid;\n    border-color: ", ";\n  }\n  .panel.panel-default > .panel-collapse > div.panel-body {\n    border-color: ", ";\n    border-width: 2px;\n  }\n"], ["\n  .panel {\n    border: none;\n    box-shadow: none;\n  }\n\n  a.collapsed {\n    .panel-title {\n      background-color: rgb(246, 246, 246);\n      color: #343434;\n      font-weight: 400;\n      :hover {\n      }\n      ::before {\n        content: \"\\\\F105\";\n      }\n    }\n\n    .panel-heading {\n      border-left: solid 2px rgb(217, 217, 217);\n    }\n  }\n\n  & > a:hover {\n    text-decoration: none;\n  }\n\n  .panel + .panel {\n    margin-top: 4px;\n  }\n\n  .panel-heading {\n    padding: 0;\n    background-color: rgb(245, 245, 245);\n    min-height: 36px;\n  }\n\n  .panel-title {\n    font-size: 13px;\n    padding: 10px;\n    display: inline-block;\n    position: relative;\n    line-height: 1;\n    color: #343434;\n    font-weight: 700;\n    :hover {\n      text-decoration: none;\n    }\n\n    ::before {\n      content: \"\\\\F107\";\n      font-family: \"FontAwesome\";\n      margin: 0 10px 0 5px;\n      width: 9px;\n      display: inline-block;\n      font-size: 15px;\n    }\n  }\n\n  .panel-toolbar {\n    float: right;\n    line-height: 36px;\n    display: block;\n    position: relative;\n    padding-right: 10px;\n\n    & label {\n      margin-bottom: 0;\n    }\n  }\n\n  .collapse {\n    background-color: #fff;\n  }\n\n  .panel.panel-default > .panel-collapse.in > div.panel-body {\n    border-top: 2px solid;\n    border-color: ", ";\n  }\n  .panel.panel-default > .panel-collapse > div.panel-body {\n    border-color: ", ";\n    border-width: 2px;\n  }\n"]);

  _templateObject$$ = function _templateObject() {
    return data;
  };

  return data;
}

function ToggabledTitle(_ref) {
  var children = _ref.children,
      props = _objectWithoutPropertiesLoose(_ref, ["children"]);

  return createElement(Panel.Toggle, null, createElement(Panel.Title, Object.assign({}, props), children));
}

var StyledAccordion =
/*#__PURE__*/
styled(Accordion$1)(
/*#__PURE__*/
_templateObject$$(), function (props) {
  return props.theme.primaryColor;
}, function (props) {
  return props.theme.primaryColor;
});

var Accordion =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Accordion, _React$Component);

  function Accordion() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Accordion.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        children = _this$props.children,
        props = _objectWithoutPropertiesLoose(_this$props, ["children"]);

    return createElement(StyledAccordion, Object.assign({}, props), children);
  };

  return Accordion;
}(Component);
Accordion.Panel = Panel;
Accordion.Heading = PanelHeading;
Accordion.Title = ToggabledTitle;
Accordion.Toggle = PanelToggle;
Accordion.Body = PanelBody;
Accordion.Toolbar = Toolbar$1;

function _templateObject$10() {
  var data = _taggedTemplateLiteralLoose(["\n  .nav-tabs {\n    border-color: #c5d0dc;\n    margin-left: 0;\n    position: relative;\n    top: 1px;\n    li > a {\n      border-radius: 0;\n      border-color: #c5d0dc;\n      background-color: #f9f9f9;\n      margin-right: -1px;\n      color: #999;\n      padding: 7px 12px 8px;\n      line-height: 18px;\n      :hover,\n      :focus {\n        background-color: #fff;\n        color: #4c8fbd;\n      }\n      :focus {\n        outline: none;\n      }\n    }\n    li.active > a,\n    li.active > a:focus,\n    li.active > a:hover {\n      border-color: #c5d0dc #c5d0dc transparent;\n      border-top: 2px solid #4c8fbd;\n      box-shadow: 0 -2px 3px 0 rgba(0, 0, 0, 0.15);\n      margin-top: -1px;\n      z-index: 1;\n      background-color: #fff;\n    }\n  }\n\n  .tab-content {\n    margin-bottom: 1.5em;\n    border: 1px solid #c5d0dc;\n    padding: 16px 12px;\n  }\n"]);

  _templateObject$10 = function _templateObject() {
    return data;
  };

  return data;
}
var Tabs = /*#__PURE__*/
styled(Tabs$1)(
/*#__PURE__*/
_templateObject$10());

function _templateObject$11() {
  var data = _taggedTemplateLiteralLoose(["\n  .nav-tabs {\n    border-color: #c5d0dc;\n    margin-left: 0;\n    position: relative;\n    top: 1px;\n    li > a {\n      border-radius: 0;\n      border-color: #c5d0dc;\n      background-color: #f9f9f9;\n      margin-right: -1px;\n      color: #999;\n      padding: 7px 12px 8px;\n      line-height: 18px;\n      :hover,\n      :focus {\n        background-color: #fff;\n        color: #4c8fbd;\n      }\n      :focus {\n        outline: none;\n      }\n    }\n    li.active > a,\n    li.active > a:focus,\n    li.active > a:hover {\n      border-color: #c5d0dc #c5d0dc transparent;\n      border-top: 2px solid #4c8fbd;\n      box-shadow: 0 -2px 3px 0 rgba(0, 0, 0, 0.15);\n      margin-top: -1px;\n      z-index: 1;\n      background-color: #fff;\n    }\n    li.dropdown.open > a {\n      background-color: #4f99c6;\n      border-color: #4f99c6;\n      color: #fff;\n    }\n    li.dropdown.active a {\n      cursor: pointer;\n    }\n    ul.dropdown-menu {\n      border-radius: 0;\n      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\n      li > a {\n        padding: 1px 11px 4px;\n        background-color: #fff;\n        color: #333;\n        margin: 0;\n        :hover,\n        :focus,\n        :active {\n          background-color: #6fb3e0;\n          color: #fff;\n        }\n      }\n      li.active > a {\n        background-color: #6fb3e0;\n        color: #fff;\n        border: none;\n        box-shadow: none;\n        :hover {\n          margin: 0;\n        }\n      }\n    }\n  }\n\n  .tab-content {\n    border: 1px solid #c5d0dc;\n    padding: 16px 12px;\n  }\n"]);

  _templateObject$11 = function _templateObject() {
    return data;
  };

  return data;
}
var StyledContainer =
/*#__PURE__*/
styled(TabContainer)(
/*#__PURE__*/
_templateObject$11());

var Tab =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Tab, _React$Component);

  function Tab() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Tab.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        children = _this$props.children,
        props = _objectWithoutPropertiesLoose(_this$props, ["children"]);

    return createElement(Tab$1, Object.assign({}, props), children);
  };

  return Tab;
}(Component);
Tab.Container = StyledContainer;
Tab.Pane = TabPane;
Tab.Content = TabContent;

function _templateObject$12() {
  var data = _taggedTemplateLiteralLoose(["\n  font-weight: normal;\n  cursor: pointer;\n  padding-left: 10px;\n  position: relative;\n\n  &.disabled:hover {\n    cursor: not-allowed;\n  }\n\n  input[type=\"checkbox\"] {\n    opacity: 0;\n  }\n  .checkbox-hcss {\n    display: inline-block;\n    width: 16px;\n    height: 16px;\n    border: 1px solid #ccc;\n    position: absolute;\n    top: 3px;\n    left: 0;\n    margin: 1px;\n    background-color: #fafafa;\n    border-radius: 2px;\n\n    :hover {\n      border-color: #ff893c;\n    }\n  }\n  input[type=\"checkbox\"]:disabled + .checkbox-hcss,\n  input[type=\"checkbox\"]:disabled:checked + .checkbox-hcss {\n    background-color: #ddd;\n    border-color: #ccc;\n  }\n\n  input[type=\"checkbox\"]:checked + .checkbox-hcss {\n    background-color: ", ";\n    border-color: ", ";\n    border-radius: 2px;\n  }\n  input[type=\"checkbox\"]:checked + .checkbox-hcss::before {\n    font-family: \"FontAwesome\";\n    content: \"\\F00C\";\n    position: absolute;\n    left: 1px;\n    color: #fff;\n    font-size: 12px;\n    line-height: 12px;\n  }\n  input[type=\"checkbox\"]:checked:disabled + .checkbox-hcss::before {\n    color: #bbb;\n  }\n\n  input[type=\"checkbox\"]:focus + .checkbox-hcss {\n    border-color: #ff893c;\n  }\n"], ["\n  font-weight: normal;\n  cursor: pointer;\n  padding-left: 10px;\n  position: relative;\n\n  &.disabled:hover {\n    cursor: not-allowed;\n  }\n\n  input[type=\"checkbox\"] {\n    opacity: 0;\n  }\n  .checkbox-hcss {\n    display: inline-block;\n    width: 16px;\n    height: 16px;\n    border: 1px solid #ccc;\n    position: absolute;\n    top: 3px;\n    left: 0;\n    margin: 1px;\n    background-color: #fafafa;\n    border-radius: 2px;\n\n    :hover {\n      border-color: #ff893c;\n    }\n  }\n  input[type=\"checkbox\"]:disabled + .checkbox-hcss,\n  input[type=\"checkbox\"]:disabled:checked + .checkbox-hcss {\n    background-color: #ddd;\n    border-color: #ccc;\n  }\n\n  input[type=\"checkbox\"]:checked + .checkbox-hcss {\n    background-color: ", ";\n    border-color: ", ";\n    border-radius: 2px;\n  }\n  input[type=\"checkbox\"]:checked + .checkbox-hcss::before {\n    font-family: \"FontAwesome\";\n    content: \"\\\\F00C\";\n    position: absolute;\n    left: 1px;\n    color: #fff;\n    font-size: 12px;\n    line-height: 12px;\n  }\n  input[type=\"checkbox\"]:checked:disabled + .checkbox-hcss::before {\n    color: #bbb;\n  }\n\n  input[type=\"checkbox\"]:focus + .checkbox-hcss {\n    border-color: #ff893c;\n  }\n"]);

  _templateObject$12 = function _templateObject() {
    return data;
  };

  return data;
}
var StyledLabel =
/*#__PURE__*/
styled.label(
/*#__PURE__*/
_templateObject$12(), hcssHeavyJob, hcssHeavyJob);
var Checkbox = function Checkbox(_ref) {
  var children = _ref.children,
      className = _ref.className,
      props = _objectWithoutPropertiesLoose(_ref, ["children", "type", "className"]);

  return createElement(StyledLabel, {
    className: classNames(className, {
      disabled: props.disabled
    })
  }, createElement("input", Object.assign({
    type: "checkbox"
  }, props)), createElement("span", {
    className: "checkbox-hcss"
  }), children);
};

function _templateObject$13() {
  var data = _taggedTemplateLiteralLoose(["\n  font-weight: normal;\n  cursor: pointer;\n  &.disabled:hover {\n    cursor: not-allowed;\n  }\n\n  input[type=\"radio\"] {\n    display: none;\n  }\n  .radio-hcss {\n    display: inline-block;\n    width: 16px;\n    height: 16px;\n    border: 1px solid #ccc;\n    position: relative;\n    top: 3px;\n    margin: 1px;\n    background-color: #fafafa;\n    border-radius: 50px;\n    margin-right: 5px;\n\n    :hover {\n      border-color: #ff893c;\n    }\n  }\n  input[type=\"radio\"]:disabled + .radio-hcss,\n  input[type=\"radio\"]:disabled:checked + .radio-hcss {\n    background-color: #ddd;\n    border-color: #ccc;\n  }\n\n  input[type=\"radio\"]:checked + .radio-hcss {\n    background-color: #fff;\n    border-color: #ff893c;\n    border-radius: 50px;\n  }\n\n  input[type=\"radio\"]:checked + .radio-hcss::before {\n    font-family: \"FontAwesome\";\n    content: \"\\F111\";\n    position: absolute;\n    top: -3px;\n    left: 2.25px;\n    color: ", ";\n    font-size: 12px;\n  }\n\n  input[type=\"radio\"]:checked:disabled + .radio-hcss::before {\n    color: #bbb;\n  }\n"], ["\n  font-weight: normal;\n  cursor: pointer;\n  &.disabled:hover {\n    cursor: not-allowed;\n  }\n\n  input[type=\"radio\"] {\n    display: none;\n  }\n  .radio-hcss {\n    display: inline-block;\n    width: 16px;\n    height: 16px;\n    border: 1px solid #ccc;\n    position: relative;\n    top: 3px;\n    margin: 1px;\n    background-color: #fafafa;\n    border-radius: 50px;\n    margin-right: 5px;\n\n    :hover {\n      border-color: #ff893c;\n    }\n  }\n  input[type=\"radio\"]:disabled + .radio-hcss,\n  input[type=\"radio\"]:disabled:checked + .radio-hcss {\n    background-color: #ddd;\n    border-color: #ccc;\n  }\n\n  input[type=\"radio\"]:checked + .radio-hcss {\n    background-color: #fff;\n    border-color: #ff893c;\n    border-radius: 50px;\n  }\n\n  input[type=\"radio\"]:checked + .radio-hcss::before {\n    font-family: \"FontAwesome\";\n    content: \"\\\\F111\";\n    position: absolute;\n    top: -3px;\n    left: 2.25px;\n    color: ", ";\n    font-size: 12px;\n  }\n\n  input[type=\"radio\"]:checked:disabled + .radio-hcss::before {\n    color: #bbb;\n  }\n"]);

  _templateObject$13 = function _templateObject() {
    return data;
  };

  return data;
}
var StyledLabel$1 =
/*#__PURE__*/
styled.label(
/*#__PURE__*/
_templateObject$13(), hcssHeavyJob);
var Radio = function Radio(_ref) {
  var children = _ref.children,
      className = _ref.className,
      props = _objectWithoutPropertiesLoose(_ref, ["children", "type", "className"]);

  return createElement(StyledLabel$1, {
    className: classNames(className, {
      disabled: props.disabled
    })
  }, createElement("input", Object.assign({
    type: "radio"
  }, props)), createElement("span", {
    className: "radio-hcss"
  }), children);
};

function _templateObject$14() {
  var data = _taggedTemplateLiteralLoose(["\n  input[type=\"checkbox\"] {\n    cursor: pointer;\n    display: none;\n\n    + span {\n      position: relative;\n      cursor: pointer;\n    }\n\n    & + span::before,\n    &::after {\n      font-family: \"FontAwesome\";\n      font-weight: lighter;\n      transition: background 0.25s ease;\n      text-shadow: 0 -1px 0 rgba(0, 0, 0, 0.25);\n    }\n\n    & + span::before {\n      content: \"\\f00d\";\n      font-size: 16px;\n      border: 1px solid #ccc;\n      text-indent: 32px;\n      width: 52px;\n      height: 22px;\n      position: relative;\n      display: inline-block;\n      border-radius: 12px;\n      background-color: #888;\n      color: #f2f2f2;\n      box-shadow: inset 0 1px 1px 0 rgba(0, 0, 0, 0.15);\n      line-height: 18px;\n      border-width: 0;\n    }\n\n    & + span::after {\n      content: \"\";\n      border: 4px solid #fff;\n      height: 18px;\n      width: 18px;\n      position: absolute;\n      border-radius: 100%;\n      background-color: #fff;\n      text-align: center;\n      box-shadow: 0 -1px 0 rgba(0, 0, 0, 0.25);\n      top: 0;\n      left: 3px;\n      transition: left 0.25s ease;\n    }\n\n    &:checked + span {\n      ::before {\n        content: \"\\f00c\";\n        color: #f2f2f2;\n        background-color: #ff9e1b;\n        text-indent: 6px;\n      }\n      ::after {\n        left: 32px;\n      }\n    }\n\n    &:disabled + span::before {\n      background-color: #ddd;\n      box-shadow: none;\n      color: #bbb;\n    }\n    &:disabled + span::after {\n      box-shadow: none;\n    }\n\n    &:disabled + span:hover {\n      cursor: not-allowed;\n    }\n  }\n"], ["\n  input[type=\"checkbox\"] {\n    cursor: pointer;\n    display: none;\n\n    + span {\n      position: relative;\n      cursor: pointer;\n    }\n\n    & + span::before,\n    &::after {\n      font-family: \"FontAwesome\";\n      font-weight: lighter;\n      transition: background 0.25s ease;\n      text-shadow: 0 -1px 0 rgba(0, 0, 0, 0.25);\n    }\n\n    & + span::before {\n      content: \"\\\\f00d\";\n      font-size: 16px;\n      border: 1px solid #ccc;\n      text-indent: 32px;\n      width: 52px;\n      height: 22px;\n      position: relative;\n      display: inline-block;\n      border-radius: 12px;\n      background-color: #888;\n      color: #f2f2f2;\n      box-shadow: inset 0 1px 1px 0 rgba(0, 0, 0, 0.15);\n      line-height: 18px;\n      border-width: 0;\n    }\n\n    & + span::after {\n      content: \"\";\n      border: 4px solid #fff;\n      height: 18px;\n      width: 18px;\n      position: absolute;\n      border-radius: 100%;\n      background-color: #fff;\n      text-align: center;\n      box-shadow: 0 -1px 0 rgba(0, 0, 0, 0.25);\n      top: 0;\n      left: 3px;\n      transition: left 0.25s ease;\n    }\n\n    &:checked + span {\n      ::before {\n        content: \"\\\\f00c\";\n        color: #f2f2f2;\n        background-color: #ff9e1b;\n        text-indent: 6px;\n      }\n      ::after {\n        left: 32px;\n      }\n    }\n\n    &:disabled + span::before {\n      background-color: #ddd;\n      box-shadow: none;\n      color: #bbb;\n    }\n    &:disabled + span::after {\n      box-shadow: none;\n    }\n\n    &:disabled + span:hover {\n      cursor: not-allowed;\n    }\n  }\n"]);

  _templateObject$14 = function _templateObject() {
    return data;
  };

  return data;
}
var StyledLabel$2 =
/*#__PURE__*/
styled.label(
/*#__PURE__*/
_templateObject$14());
var Toggle =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Toggle, _React$Component);

  function Toggle() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Toggle.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        props = _objectWithoutPropertiesLoose(_this$props, ["type"]);

    return createElement(StyledLabel$2, null, createElement("input", Object.assign({
      type: "checkbox"
    }, props)), createElement("span", null));
  };

  return Toggle;
}(Component);

function _templateObject$15() {
  var data = _taggedTemplateLiteralLoose(["\n  .btn.btn-default {\n    background-color: transparent;\n    border-color: transparent;\n    border-radius: 0px;\n    border: 0px solid transparent;\n    border-bottom-width: 4px;\n    color: black;\n    line-height: 1.5;\n    margin-right: 10px;\n    padding-left: 5px;\n    padding-right: 5px;\n  }\n  .btn.btn-default:hover {\n    border-color: ", ";\n  }\n  .btn.btn-default.active {\n    border-color: ", ";\n    box-shadow: none;\n  }\n  .btn.btn-default:active {\n    box-shadow: none;\n  }\n\n  .btn.btn-default.active:after,\n  .btn.btn-default.active:before {\n    top: 100%;\n    left: 50%;\n    border: solid transparent;\n    content: \" \";\n    height: 0;\n    width: 0;\n    position: absolute;\n    pointer-events: none;\n  }\n\n  .btn.btn-default.active:after {\n    border-color: rgba(136, 183, 213, 0);\n    border-bottom-color: ", ";\n    border-width: 8px;\n    margin-left: -8px;\n    margin-top: -13px;\n  }\n"]);

  _templateObject$15 = function _templateObject() {
    return data;
  };

  return data;
}
var ToggleButtonGroup = /*#__PURE__*/
styled(ToggleButtonGroup$1)(
/*#__PURE__*/
_templateObject$15(), gray500, gray700, gray700);

function _templateObject$16() {
  var data = _taggedTemplateLiteralLoose(["\n  height: 41px;\n  vertical-align: middle;\n  transition: all 0.2s ease 0s;\n  padding: 10px 16px;\n  background-color: #d6d6d6;\n  :hover {\n    cursor: pointer;\n  }\n\n  & > .fa.fa-chevron-down {\n    margin-right: 10px;\n    margin-top: 2px;\n    font-size: 12px;\n    vertical-align: text-top;\n  }\n"]);

  _templateObject$16 = function _templateObject() {
    return data;
  };

  return data;
}
var ModalPanelHeaderWrapper =
/*#__PURE__*/
styled.div(
/*#__PURE__*/
_templateObject$16());
var ModalPanelHeader = function ModalPanelHeader(props) {
  var className = props.className,
      children = props.children,
      other = _objectWithoutPropertiesLoose(props, ["className", "children", "ref"]);

  return createElement(ModalPanelHeaderWrapper, Object.assign({
    className: classNames("modal-panel-header", className)
  }, other), createElement(Icon$1, {
    name: "chevron-down"
  }), children);
};

function _templateObject$17() {
  var data = _taggedTemplateLiteralLoose(["\n  position: absolute;\n  width: 100%;\n  z-index: 50;\n  height: 0;\n  overflow: hidden;\n  transition: 0.25s;\n"]);

  _templateObject$17 = function _templateObject() {
    return data;
  };

  return data;
}
var ModalPanelBodyWrapper =
/*#__PURE__*/
styled.div(
/*#__PURE__*/
_templateObject$17());
var ModalPanelBody = function ModalPanelBody(props) {
  var className = props.className,
      other = _objectWithoutPropertiesLoose(props, ["className", "ref"]);

  return createElement(ModalPanelBodyWrapper, Object.assign({
    className: classNames("modal-panel-body", className)
  }, other), props.children);
};

function _templateObject$18() {
  var data = _taggedTemplateLiteralLoose(["\n  position: absolute;\n  height: 100%;\n  width: 100%;\n  background-color: #d6d6d6;\n  opacity: 0.8;\n  top: 0;\n  left: 0;\n"]);

  _templateObject$18 = function _templateObject() {
    return data;
  };

  return data;
}
var BackdropWrapper =
/*#__PURE__*/
styled.div(
/*#__PURE__*/
_templateObject$18());
var Backdrop =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Backdrop, _React$Component);

  function Backdrop() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Backdrop.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        elementRef = _this$props.elementRef,
        other = _objectWithoutPropertiesLoose(_this$props, ["elementRef"]);

    if (elementRef.current) {
      return createPortal(createElement(BackdropWrapper, Object.assign({}, other)), elementRef.current);
    } else {
      console.warn("Ref passed to `Backdrop` is null");
      return null;
    }
  };

  return Backdrop;
}(Component);

function _templateObject$19() {
  var data = _taggedTemplateLiteralLoose(["\n  position: relative;\n  margin-top: 10px;\n  transition: 0.25s;\n  background-color: white;\n\n  &.open {\n    & > .modal-panel-header {\n      background-color: #fff;\n      & > .fa.fa-chevron-down {\n        transform: rotate(-180deg);\n        padding-bottom: 2px;\n      }\n    }\n    & > .modal-panel-body {\n      overflow: visible;\n      background: #fff;\n      box-shadow: 0 16px 20px -12px #aaaaaa, 0 16px 20px -12px #aaaaaa;\n      height: auto;\n    }\n  }\n"]);

  _templateObject$19 = function _templateObject() {
    return data;
  };

  return data;
}
var ModalPanelWrapper =
/*#__PURE__*/
styled.div(
/*#__PURE__*/
_templateObject$19());
var ModalPanel =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(ModalPanel, _React$Component);

  function ModalPanel() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = ModalPanel.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        className = _this$props.className,
        open = _this$props.open,
        contentContainerRef = _this$props.contentContainerRef,
        onClose = _this$props.onClose,
        other = _objectWithoutPropertiesLoose(_this$props, ["className", "children", "open", "contentContainerRef", "onClose", "ref"]);

    return createElement(ModalPanelWrapper, Object.assign({
      className: classNames("modal-panel", className, {
        open: open
      })
    }, other), this.props.children, this.props.open && createElement(Backdrop, {
      elementRef: contentContainerRef,
      onClick: onClose
    }));
  };

  return ModalPanel;
}(Component);
ModalPanel.Header = ModalPanelHeader;
ModalPanel.Body = ModalPanelBody;

function _templateObject$1a() {
  var data = _taggedTemplateLiteralLoose(["\n  > .modal-panel.open > .modal-panel-header.with-filters {\n    background-color: #fff;\n  }\n  > .modal-panel > .modal-panel-header {\n    &.with-filters {\n      background-color: #dfeffb;\n    }\n\n    .filters-title {\n      font-size: 13px;\n      & > .filters-label {\n        font-weight: bold;\n      }\n      & > .filters-control-message {\n        color: ", ";\n        min-width: 9em;\n        display: inline-block;\n      }\n      & > .filters-clear-message {\n        color: #005bca;\n        margin-left: 50px;\n        :hover {\n          text-decoration: underline;\n        }\n      }\n    }\n  }\n"]);

  _templateObject$1a = function _templateObject() {
    return data;
  };

  return data;
}
var FiltersWrapper =
/*#__PURE__*/
styled.div(
/*#__PURE__*/
_templateObject$1a(), gray700);
var defaultMessages = {
  title: "Filters",
  hideFilters: "(Click to hide...)",
  expandFilters: "(Click to expand...)"
};
var Filters = function Filters(props) {
  var onClose = props.onClose,
      open = props.open,
      contentContainerRef = props.contentContainerRef,
      bodyProps = props.bodyProps,
      children = props.children,
      numberOfFiltersApplied = props.numberOfFiltersApplied,
      onClearFilters = props.onClearFilters,
      messages = props.messages,
      other = _objectWithoutPropertiesLoose(props, ["onClose", "open", "contentContainerRef", "ref", "bodyProps", "children", "numberOfFiltersApplied", "onClearFilters", "messages"]);

  var headerProps = other.headerProps;
  var hasFiltersApplied = onClearFilters && numberOfFiltersApplied && numberOfFiltersApplied > 0 ? true : false;

  var strings = _extends({}, defaultMessages, {}, messages);

  if (hasFiltersApplied && headerProps) {
    headerProps = _extends({
      className: classNames(headerProps.className, {
        "with-filters": hasFiltersApplied
      })
    }, headerProps);
  } else if (hasFiltersApplied) {
    headerProps = {
      className: "with-filters"
    };
  }

  var clearFilters = function clearFilters(event) {
    event.stopPropagation();
    if (onClearFilters) onClearFilters();
  };

  return createElement(FiltersWrapper, null, createElement(ModalPanel, Object.assign({
    onClose: onClose,
    open: open,
    contentContainerRef: contentContainerRef
  }, other), createElement(ModalPanel.Header, Object.assign({
    onClick: props.onClose
  }, headerProps), createElement("span", {
    className: "filters-title"
  }, createElement("span", {
    className: "filters-label"
  }, strings.title), " ", createElement("span", {
    className: "filters-control-message"
  }, props.open ? strings.hideFilters : strings.expandFilters), hasFiltersApplied && createElement("span", {
    className: "filters-clear-message",
    onClick: clearFilters
  }, createElement(Icon$1, {
    name: "times",
    margin: "right"
  }), strings.clearFilters || "Clear Filters (" + numberOfFiltersApplied + " applied)"))), createElement(ModalPanel.Body, Object.assign({}, bodyProps), children)));
};

function _templateObject$1b() {
  var data = _taggedTemplateLiteralLoose(["\n  /* This is a copy & paste from 'react-checkbox-tree/lib/react-checkbox-tree.css';*/\n  .react-checkbox-tree {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-orient: horizontal;\n    -webkit-box-direction: reverse;\n    -ms-flex-direction: row-reverse;\n    flex-direction: row-reverse;\n    font-size: 16px;\n  }\n\n  .react-checkbox-tree > ol {\n    -webkit-box-flex: 1;\n    -ms-flex: 1 1 auto;\n    flex: 1 1 auto;\n  }\n\n  .react-checkbox-tree ol {\n    margin: 0;\n    padding-left: 0;\n    list-style-type: none;\n  }\n\n  .react-checkbox-tree ol ol {\n    padding-left: 24px;\n  }\n\n  .react-checkbox-tree button {\n    line-height: normal;\n    color: inherit;\n  }\n\n  .react-checkbox-tree button:focus {\n    outline: none;\n  }\n\n  .react-checkbox-tree button:disabled {\n    cursor: not-allowed;\n  }\n\n  .react-checkbox-tree .rct-bare-label {\n    cursor: default;\n  }\n\n  .react-checkbox-tree label {\n    margin-bottom: 0;\n    cursor: pointer;\n  }\n\n  .react-checkbox-tree label:hover {\n    background: rgba(51, 51, 204, 0.1);\n  }\n\n  .react-checkbox-tree label:active {\n    background: rgba(51, 51, 204, 0.15);\n  }\n\n  .react-checkbox-tree:not(.rct-native-display) input {\n    display: none;\n  }\n\n  .react-checkbox-tree.rct-native-display input {\n    margin: 0 5px;\n  }\n\n  .react-checkbox-tree .rct-icon {\n    font-family: \"FontAwesome\";\n    font-style: normal;\n  }\n\n  .rct-disabled > .rct-text > label {\n    opacity: 0.75;\n    cursor: not-allowed;\n  }\n\n  .rct-disabled > .rct-text > label:hover {\n    background: transparent;\n  }\n\n  .rct-disabled > .rct-text > label:active {\n    background: transparent;\n  }\n\n  .rct-text {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n  }\n\n  .rct-options {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 auto;\n    flex: 0 0 auto;\n    margin-left: 0.5rem;\n    text-align: right;\n  }\n\n  .rct-option {\n    opacity: 0.75;\n    border: 0;\n    background: none;\n    cursor: pointer;\n    padding: 0 4px;\n    font-size: 18px;\n  }\n\n  .rct-option:hover {\n    opacity: 1;\n  }\n\n  .rct-option + .rct-option {\n    margin-left: 2px;\n  }\n\n  .rct-collapse,\n  .rct-checkbox,\n  .rct-node-icon {\n    padding: 0 5px;\n  }\n\n  .rct-collapse *,\n  .rct-checkbox *,\n  .rct-node-icon * {\n    display: inline-block;\n    margin: 0;\n    width: 14px;\n  }\n\n  .rct-collapse {\n    border: 0;\n    background: none;\n    line-height: normal;\n    color: inherit;\n    font-size: 12px;\n  }\n\n  .rct-collapse.rct-collapse-btn {\n    cursor: pointer;\n  }\n\n  .rct-collapse > .rct-icon-expand-close {\n    opacity: 0.5;\n  }\n\n  .rct-collapse > .rct-icon-expand-close:hover {\n    opacity: 1;\n  }\n\n  .rct-native-display .rct-checkbox {\n    display: none;\n  }\n\n  .rct-node-clickable {\n    cursor: pointer;\n  }\n\n  .rct-node-clickable:hover {\n    background: rgba(51, 51, 204, 0.1);\n  }\n\n  .rct-node-clickable:focus {\n    outline: 0;\n    background: rgba(51, 51, 204, 0.2);\n  }\n\n  .rct-node-icon {\n    color: #33c;\n  }\n\n  .rct-title {\n    padding: 0 5px;\n  }\n\n  .rct-icon-expand-close::before {\n    content: \"\f054\";\n  }\n\n  .rct-icon-expand-open::before {\n    content: \"\f078\";\n  }\n\n  .rct-icon-uncheck::before {\n    content: \"\f096\";\n  }\n\n  .rct-icon-check::before {\n    content: \"\f046\";\n  }\n\n  .rct-icon-half-check::before {\n    opacity: 0.5;\n    content: \"\f046\";\n  }\n\n  .rct-icon-leaf::before {\n    content: \"\f016\";\n  }\n\n  .rct-icon-parent-open::before {\n    content: \"\f115\";\n  }\n\n  .rct-icon-parent-close::before {\n    content: \"\f114\";\n  }\n\n  .rct-icon-expand-all::before {\n    content: \"\f0fe\";\n  }\n\n  .rct-icon-collapse-all::before {\n    content: \"\f146\";\n  }\n\n  /*Custom styles begin here*/\n  .rct-node-icon {\n    color: ", ";\n    padding: 0;\n\n    & > span {\n    }\n  }\n\n  .rct-checkbox {\n    color: ", ";\n  }\n\n  .rct-title {\n    padding: 0 5px;\n    font-weight: normal;\n    font-size: 15px;\n  }\n"], ["\n  /* This is a copy & paste from 'react-checkbox-tree/lib/react-checkbox-tree.css';*/\n  .react-checkbox-tree {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-orient: horizontal;\n    -webkit-box-direction: reverse;\n    -ms-flex-direction: row-reverse;\n    flex-direction: row-reverse;\n    font-size: 16px;\n  }\n\n  .react-checkbox-tree > ol {\n    -webkit-box-flex: 1;\n    -ms-flex: 1 1 auto;\n    flex: 1 1 auto;\n  }\n\n  .react-checkbox-tree ol {\n    margin: 0;\n    padding-left: 0;\n    list-style-type: none;\n  }\n\n  .react-checkbox-tree ol ol {\n    padding-left: 24px;\n  }\n\n  .react-checkbox-tree button {\n    line-height: normal;\n    color: inherit;\n  }\n\n  .react-checkbox-tree button:focus {\n    outline: none;\n  }\n\n  .react-checkbox-tree button:disabled {\n    cursor: not-allowed;\n  }\n\n  .react-checkbox-tree .rct-bare-label {\n    cursor: default;\n  }\n\n  .react-checkbox-tree label {\n    margin-bottom: 0;\n    cursor: pointer;\n  }\n\n  .react-checkbox-tree label:hover {\n    background: rgba(51, 51, 204, 0.1);\n  }\n\n  .react-checkbox-tree label:active {\n    background: rgba(51, 51, 204, 0.15);\n  }\n\n  .react-checkbox-tree:not(.rct-native-display) input {\n    display: none;\n  }\n\n  .react-checkbox-tree.rct-native-display input {\n    margin: 0 5px;\n  }\n\n  .react-checkbox-tree .rct-icon {\n    font-family: \"FontAwesome\";\n    font-style: normal;\n  }\n\n  .rct-disabled > .rct-text > label {\n    opacity: 0.75;\n    cursor: not-allowed;\n  }\n\n  .rct-disabled > .rct-text > label:hover {\n    background: transparent;\n  }\n\n  .rct-disabled > .rct-text > label:active {\n    background: transparent;\n  }\n\n  .rct-text {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n  }\n\n  .rct-options {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 auto;\n    flex: 0 0 auto;\n    margin-left: 0.5rem;\n    text-align: right;\n  }\n\n  .rct-option {\n    opacity: 0.75;\n    border: 0;\n    background: none;\n    cursor: pointer;\n    padding: 0 4px;\n    font-size: 18px;\n  }\n\n  .rct-option:hover {\n    opacity: 1;\n  }\n\n  .rct-option + .rct-option {\n    margin-left: 2px;\n  }\n\n  .rct-collapse,\n  .rct-checkbox,\n  .rct-node-icon {\n    padding: 0 5px;\n  }\n\n  .rct-collapse *,\n  .rct-checkbox *,\n  .rct-node-icon * {\n    display: inline-block;\n    margin: 0;\n    width: 14px;\n  }\n\n  .rct-collapse {\n    border: 0;\n    background: none;\n    line-height: normal;\n    color: inherit;\n    font-size: 12px;\n  }\n\n  .rct-collapse.rct-collapse-btn {\n    cursor: pointer;\n  }\n\n  .rct-collapse > .rct-icon-expand-close {\n    opacity: 0.5;\n  }\n\n  .rct-collapse > .rct-icon-expand-close:hover {\n    opacity: 1;\n  }\n\n  .rct-native-display .rct-checkbox {\n    display: none;\n  }\n\n  .rct-node-clickable {\n    cursor: pointer;\n  }\n\n  .rct-node-clickable:hover {\n    background: rgba(51, 51, 204, 0.1);\n  }\n\n  .rct-node-clickable:focus {\n    outline: 0;\n    background: rgba(51, 51, 204, 0.2);\n  }\n\n  .rct-node-icon {\n    color: #33c;\n  }\n\n  .rct-title {\n    padding: 0 5px;\n  }\n\n  .rct-icon-expand-close::before {\n    content: \"\\f054\";\n  }\n\n  .rct-icon-expand-open::before {\n    content: \"\\f078\";\n  }\n\n  .rct-icon-uncheck::before {\n    content: \"\\f096\";\n  }\n\n  .rct-icon-check::before {\n    content: \"\\f046\";\n  }\n\n  .rct-icon-half-check::before {\n    opacity: 0.5;\n    content: \"\\f046\";\n  }\n\n  .rct-icon-leaf::before {\n    content: \"\\f016\";\n  }\n\n  .rct-icon-parent-open::before {\n    content: \"\\f115\";\n  }\n\n  .rct-icon-parent-close::before {\n    content: \"\\f114\";\n  }\n\n  .rct-icon-expand-all::before {\n    content: \"\\f0fe\";\n  }\n\n  .rct-icon-collapse-all::before {\n    content: \"\\f146\";\n  }\n\n  /*Custom styles begin here*/\n  .rct-node-icon {\n    color: ", ";\n    padding: 0;\n\n    & > span {\n    }\n  }\n\n  .rct-checkbox {\n    color: ", ";\n  }\n\n  .rct-title {\n    padding: 0 5px;\n    font-weight: normal;\n    font-size: 15px;\n  }\n"]);

  _templateObject$1b = function _templateObject() {
    return data;
  };

  return data;
}
var TreeSelectorWrapper =
/*#__PURE__*/
styled.div(
/*#__PURE__*/
_templateObject$1b(), function (props) {
  return props.theme.primaryColor;
}, hcssHeavyJob);

var CheckboxTree =
/*#__PURE__*/
require("react-checkbox-tree");

var defaultIcons = {
  check:
  /*#__PURE__*/
  createElement("i", {
    className: "fa fa-check-square",
    "aria-hidden": "true"
  }),
  uncheck:
  /*#__PURE__*/
  createElement("i", {
    className: "fa fa-square-o",
    "aria-hidden": "true"
  }),
  halfCheck:
  /*#__PURE__*/
  createElement("span", {
    className: "rct-icon rct-icon-half-check"
  }),
  expandClose:
  /*#__PURE__*/
  createElement("i", {
    className: "fa fa-plus"
  }),
  expandOpen:
  /*#__PURE__*/
  createElement("i", {
    className: "fa fa-minus"
  }),
  expandAll:
  /*#__PURE__*/
  createElement("span", {
    className: "rct-icon rct-icon-expand-all"
  }),
  collapseAll:
  /*#__PURE__*/
  createElement("span", {
    className: "rct-icon rct-icon-collapse-all"
  }),
  parentClose: "",
  parentOpen: "",
  leaf: ""
};

var TreeSelector =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(TreeSelector, _React$Component);

  function TreeSelector() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = TreeSelector.prototype;

  _proto.render = function render() {
    var icons = this.props.icons ? this.props.icons : defaultIcons;
    return createElement(TreeSelectorWrapper, null, createElement(CheckboxTree, Object.assign({}, this.props, {
      icons: icons
    })));
  };

  return TreeSelector;
}(Component);

/**
 * A Simple Data Selector component for the SelectModal component to be able
 * to offer an out of the box selection, it simply shows all the data on a Table,
 * no paging, sorting, filtering or any of that functionalities yet which makes this
 * Selector not very useful unless is used with small amount of data but perhaps
 * we could improve this selector so that the SelectModal can offer a decent out of the box
 * functionality without the caller needing to create it's own DataSelector component
 */

var SimpleTableSelector =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(SimpleTableSelector, _React$Component);

  function SimpleTableSelector(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.state = {
      selectedItems: []
    };

    _this.onRowClick = function (selectedItem) {
      if (_this.state.selectedItems.indexOf(selectedItem) === -1) {
        _this.addItem(selectedItem);
      } else {
        _this.removeItem(selectedItem);
      }
    };

    _this.addItem = function (selectedItem) {
      _this.setState(function (state) {
        var selectedItems = [].concat(state.selectedItems, [selectedItem]);
        return {
          selectedItems: selectedItems
        };
      });
    };

    _this.removeItem = function (selectedItem) {
      _this.setState(function (state) {
        var selectedItems = state.selectedItems.filter(function (item) {
          return item[_this.columnKey] !== selectedItem[_this.columnKey];
        });
        return {
          selectedItems: selectedItems
        };
      });
    };

    _this.getItemsSelected = function () {
      return _this.state.selectedItems;
    };

    _this.columnKey = props.columnKey;

    if (props.initialSelectedIds) {
      var selectedItems = props.initialSelectedIds.map(function (id) {
        return props.rows.find(function (r) {
          return r[props.columnKey] === id;
        });
      });
      _this.state = {
        selectedItems: selectedItems
      };
    }

    return _this;
  }

  var _proto = SimpleTableSelector.prototype;

  _proto.render = function render() {
    var _this2 = this;

    return createElement("table", {
      className: "table"
    }, createElement("thead", null, createElement("tr", null, this.props.columns.map(function (c) {
      return createElement("th", {
        key: c.name
      }, c.title);
    }))), createElement("tbody", null, this.props.rows.map(function (r) {
      var isSelected = _this2.state.selectedItems.indexOf(r) !== -1;
      return createElement("tr", {
        key: r[_this2.columnKey],
        onClick: function onClick() {
          return _this2.onRowClick(r);
        },
        className: isSelected ? "active" : ""
      }, _this2.props.columns.map(function (c) {
        return createElement("td", {
          key: c.name
        }, r[c.name]);
      }));
    })));
  };

  return SimpleTableSelector;
}(Component);

var isFunction = function isFunction(functionToCheck) {
  var getType = {};
  return functionToCheck && getType.toString.call(functionToCheck) === "[object Function]";
};
var getDefaultSelectModalMessages = function getDefaultSelectModalMessages() {
  return {
    ok: "Ok",
    cancel: "Cancel"
  };
};

/**
 * Basic Selection Modal, it shows a Modal with a default modal header title
 * and a footer with a Cancel and Ok Button, the way the data is going to selected
 * is up to the caller since the prop dataSelector expect a React component that display
 * and select the data the only condition is that it must Implement IDataSelector and
 * returns the selected items on the getItemsSelected method if no dataSelector is provided
 * it will use a default SimpleTable Selector
 */

var SelectModal =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(SelectModal, _React$Component);

  function SelectModal() {
    var _this;

    _this = _React$Component.apply(this, arguments) || this;

    _this.setDataSelectorRef = function (dataSelector) {
      _this.dataSelector = dataSelector;
    };
    /**
     * It checks if a Custom Data Selector has been provided, if it has
     * it create the CustomDataSelector and pass the corresponding properties and
     * add the reference in order be able to call it's getItemsSelected method
     * if no dataSelector is provided it's uses SimpleTableSelector
     */


    _this.createDataSelector = function () {
      var CustomDataSelector = _this.props.dataSelector;
      var dataSelectorProps = {
        columnKey: _this.props.columnKey,
        columns: _this.props.columns,
        rows: _this.props.rows,
        initialSelectedIds: _this.props.initialSelectedIds
      };

      if (isValidElement(CustomDataSelector)) {
        return cloneElement(CustomDataSelector, _extends({}, {
          ref: _this.setDataSelectorRef
        }, {}, dataSelectorProps));
      }

      if (CustomDataSelector && isFunction(CustomDataSelector)) {
        return createElement(CustomDataSelector, Object.assign({
          ref: _this.setDataSelectorRef
        }, dataSelectorProps));
      }

      return createElement(SimpleTableSelector, {
        ref: _this.setDataSelectorRef,
        columnKey: _this.props.columnKey,
        columns: _this.props.columns,
        rows: _this.props.rows,
        initialSelectedIds: _this.props.initialSelectedIds
      });
    };

    _this.onHide = function () {
      // Cancel
      _this.props.onHide();
    };

    _this.onSelectionConfirm = function () {
      // Confirm selected items
      var selectedItems = _this.dataSelector.getItemsSelected();

      _this.props.onSelectionConfirm(selectedItems);
    };

    return _this;
  }

  var _proto = SelectModal.prototype;

  _proto.render = function render() {
    return createElement(Modal, {
      show: this.props.show,
      onHide: this.onHide
    }, createElement(Modal.Header, {
      closeButton: true
    }, createElement("h4", {
      className: "modal-title"
    }, this.props.title)), createElement(Modal.Body, null, this.createDataSelector()), createElement(Modal.Footer, null, createElement(stupidVariable, {
      onClick: this.onHide,
      hcssStyle: "ThemeInverted"
    }, createElement(Icon$1, {
      name: "remove",
      margin: "right"
    }), "Cancel"), createElement(stupidVariable, {
      onClick: this.onSelectionConfirm
    }, createElement(Icon$1, {
      name: "check",
      margin: "right"
    }), "Ok")));
  };

  return SelectModal;
}(Component);

var ExpandableContentStatus;

(function (ExpandableContentStatus) {
  ExpandableContentStatus["Collapsed"] = "collapsed";
  ExpandableContentStatus["Collapsing"] = "collapsing";
  ExpandableContentStatus["Expanded"] = "expanded";
  ExpandableContentStatus["Expanding"] = "expanding";
})(ExpandableContentStatus || (ExpandableContentStatus = {}));

function _templateObject8() {
  var data = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  margin-bottom: 24px;\n  padding: 0 20px 20px 20px;\n  background: #ffffff;\n  text-align: center;\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7$2() {
  var data = _taggedTemplateLiteralLoose(["\n  height: 100px;\n  flex-grow: 1;\n  margin-bottom: 16px;\n  padding: 0 20px;\n  overflow: auto;\n"]);

  _templateObject7$2 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6$2() {
  var data = _taggedTemplateLiteralLoose(["\n  display: inline-block;\n  font-size: 20px;\n  font-weight: 700;\n  vertical-align: middle;\n  margin: 0;\n"]);

  _templateObject6$2 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5$6() {
  var data = _taggedTemplateLiteralLoose(["\n  display: inline-block;\n  position: absolute;\n  top: 36px;\n  right: 20px;\n  font-size: 20px;\n  color: #707070;\n  line-height: 24px;\n  vertical-align: middle;\n  cursor: pointer;\n  transition: 0.2s;\n\n  &:hover {\n    color: #1e1e1e;\n  }\n"]);

  _templateObject5$6 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$b() {
  var data = _taggedTemplateLiteralLoose(["\n  position: relative;\n  padding: 36px 20px 16px 20px;\n  background: #f6f6f6;\n"]);

  _templateObject4$b = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$h() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-wrap: nowrap;\n  flex-direction: column;\n  position: absolute;\n  width: 480px;\n  top: 0;\n  height: 100%;\n  background: #ffffff;\n  box-shadow: 0 0 20px -5px #000000;\n  z-index: 2020;\n  transition: 0.4s;\n"]);

  _templateObject3$h = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$t() {
  var data = _taggedTemplateLiteralLoose(["\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.5);\n  z-index: 2010;\n  transition: 0.3s;\n"]);

  _templateObject2$t = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$1c() {
  var data = _taggedTemplateLiteralLoose(["\n  position: absolute;\n  margin: 0;\n  padding: 0;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n\n  &[data-panel-status=\"expanding\"] {\n    & > .modal-panel-overlay-screen {\n      opacity: 0;\n    }\n    & > .modal-panel-content {\n      right: -500px;\n    }\n  }\n  &[data-panel-status=\"expanded\"] {\n    .modal-panel-overlay-screen {\n      opacity: 1;\n    }\n    & > .modal-panel-content {\n      right: 0;\n    }\n  }\n  &[data-panel-status=\"collapsing\"] {\n    .modal-panel-overlay-screen {\n      opacity: 0;\n    }\n    & > .modal-panel-content {\n      right: -500px;\n    }\n  }\n  &[data-panel-status=\"collapsed\"] {\n    .modal-panel-overlay-screen {\n      opacity: 0;\n    }\n    & > .modal-panel-content {\n      right: -500px;\n    }\n  }\n"]);

  _templateObject$1c = function _templateObject() {
    return data;
  };

  return data;
}
var SlideoutPanelHeader =
/*#__PURE__*/
function (_React$PureComponent) {
  _inheritsLoose(SlideoutPanelHeader, _React$PureComponent);

  function SlideoutPanelHeader() {
    var _this;

    _this = _React$PureComponent.apply(this, arguments) || this;

    _this.handleHidePanelRequested = function (event) {
      _this.props.onHide(event);
    };

    return _this;
  }

  var _proto = SlideoutPanelHeader.prototype;

  _proto.render = function render() {
    return React__default.createElement(StyledSlideoutPanelHeader, {
      className: "modal-panel-header"
    }, React__default.createElement(StyledSlideoutPanelCloseButton, {
      className: "modal-panel-close-button",
      onClick: this.handleHidePanelRequested
    }, React__default.createElement("i", {
      className: "fa fa-times"
    })), React__default.createElement(StyledSlideoutPanelTitle, {
      className: "modal-panel-title"
    }, this.props.panelTitle));
  };

  return SlideoutPanelHeader;
}(React__default.PureComponent);
var SlideoutPanelBody =
/*#__PURE__*/
function (_React$PureComponent2) {
  _inheritsLoose(SlideoutPanelBody, _React$PureComponent2);

  function SlideoutPanelBody() {
    return _React$PureComponent2.apply(this, arguments) || this;
  }

  var _proto2 = SlideoutPanelBody.prototype;

  _proto2.render = function render() {
    return React__default.createElement(StyledSlideoutPanelBody, {
      className: "modal-panel-body"
    }, this.props.children);
  };

  return SlideoutPanelBody;
}(React__default.PureComponent);
var SlideoutPanelFooter =
/*#__PURE__*/
function (_React$PureComponent3) {
  _inheritsLoose(SlideoutPanelFooter, _React$PureComponent3);

  function SlideoutPanelFooter() {
    return _React$PureComponent3.apply(this, arguments) || this;
  }

  var _proto3 = SlideoutPanelFooter.prototype;

  _proto3.render = function render() {
    return React__default.createElement(StyledSlideoutPanelFooter, {
      className: "modal-panel-footer"
    }, this.props.children);
  };

  return SlideoutPanelFooter;
}(React__default.PureComponent);
var SlideoutPanel =
/*#__PURE__*/
function (_React$PureComponent4) {
  _inheritsLoose(SlideoutPanel, _React$PureComponent4);

  function SlideoutPanel() {
    var _this2;

    _this2 = _React$PureComponent4.apply(this, arguments) || this;
    _this2.state = {
      panelStatus: ExpandableContentStatus.Collapsed
    };

    _this2.handleHidePanelRequested = function () {
      _this2.props.onHide();
    };

    _this2.handleKeyPressed = function (event) {
      if (event.key === "Escape") _this2.handleHidePanelRequested();
    };

    return _this2;
  }

  var _proto4 = SlideoutPanel.prototype;

  _proto4.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
    var _this3 = this;

    if (prevProps.isActive !== this.props.isActive) {
      document.addEventListener("keydown", this.handleKeyPressed, false);

      if (this.props.isActive) {
        this.setState({
          panelStatus: ExpandableContentStatus.Expanding
        }, debounce$1(function () {
          return _this3.setState({
            panelStatus: ExpandableContentStatus.Expanded
          });
        }, 50));
      } else {
        document.removeEventListener("keydown", this.handleKeyPressed, false);
        this.setState({
          panelStatus: ExpandableContentStatus.Collapsing
        }, debounce$1(function () {
          return _this3.setState({
            panelStatus: ExpandableContentStatus.Collapsed
          });
        }, 425));
      }
    }
  };

  _proto4.render = function render() {
    return this.state.panelStatus !== ExpandableContentStatus.Collapsed && React__default.createElement(StyledSlideoutPanel, {
      className: "modal-panel" + (this.props.className ? " " + this.props.className : ""),
      "data-panel-status": this.state.panelStatus.toString()
    }, React__default.createElement(StyledSlideoutPanelOverlayScreen, {
      className: "modal-panel-overlay-screen",
      onClick: this.handleHidePanelRequested
    }), React__default.createElement(StyledSlideoutPanelContent, {
      className: "modal-panel-content"
    }, this.props.children));
  };

  return SlideoutPanel;
}(React__default.PureComponent);
SlideoutPanel.Header = SlideoutPanelHeader;
SlideoutPanel.Body = SlideoutPanelBody;
SlideoutPanel.Footer = SlideoutPanelFooter;
var StyledSlideoutPanel =
/*#__PURE__*/
styled("div")(
/*#__PURE__*/
_templateObject$1c());
var StyledSlideoutPanelOverlayScreen =
/*#__PURE__*/
styled("div")(
/*#__PURE__*/
_templateObject2$t());
var StyledSlideoutPanelContent =
/*#__PURE__*/
styled("div")(
/*#__PURE__*/
_templateObject3$h());
var StyledSlideoutPanelHeader =
/*#__PURE__*/
styled("div")(
/*#__PURE__*/
_templateObject4$b());
var StyledSlideoutPanelCloseButton =
/*#__PURE__*/
styled("div")(
/*#__PURE__*/
_templateObject5$6());
var StyledSlideoutPanelTitle =
/*#__PURE__*/
styled("h3")(
/*#__PURE__*/
_templateObject6$2());
var StyledSlideoutPanelBody =
/*#__PURE__*/
styled("div")(
/*#__PURE__*/
_templateObject7$2());
var StyledSlideoutPanelFooter =
/*#__PURE__*/
styled("div")(
/*#__PURE__*/
_templateObject8());

function _templateObject$1d() {
  var data = _taggedTemplateLiteralLoose(["\n  float: left;\n\n  :hover {\n    text-decoration: none;\n  }\n"]);

  _templateObject$1d = function _templateObject() {
    return data;
  };

  return data;
}
var LinkWrapper =
/*#__PURE__*/
styled(Link)(
/*#__PURE__*/
_templateObject$1d());

var TreeSelectModal =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(TreeSelectModal, _React$Component);

  function TreeSelectModal() {
    var _this;

    _this = _React$Component.apply(this, arguments) || this;
    _this.state = {
      checked: _this.props.initialCheckedValues || [],
      expanded: _this.props.initialExpandedValues || []
    };

    _this.onHide = function () {
      // Cancel
      _this.props.onHide();
    };

    _this.onSelectionConfirm = function () {
      // Confirm selected items
      _this.props.onSelectionConfirm(_this.state.checked);
    };

    return _this;
  }

  var _proto = TreeSelectModal.prototype;

  _proto.render = function render() {
    var _this2 = this;

    var defaultMessages = getDefaultSelectModalMessages();
    var defaultCheckBoxProps = {
      nodes: this.props.nodes ? this.props.nodes : [],
      checked: this.state.checked,
      expanded: this.state.expanded,
      onCheck: function onCheck(checked) {
        return _this2.setState({
          checked: checked
        });
      },
      onExpand: function onExpand(expanded) {
        return _this2.setState({
          expanded: expanded
        });
      }
    };

    if (this.props.checkBoxProps) {
      defaultCheckBoxProps = _extends({}, this.props.checkBoxProps);
    }

    defaultMessages.clearAllSelection = "Clear all selection";

    var _this$props = this.props,
        title = _this$props.title,
        messages = _this$props.messages,
        modalProps = _objectWithoutPropertiesLoose(_this$props, ["title", "nodes", "onSelectionConfirm", "messages", "initialCheckedValues", "initialExpandedValues", "checkBoxProps"]);

    defaultMessages = _extends({}, defaultMessages, {}, messages);
    return createElement(Modal, Object.assign({}, modalProps), createElement(Modal.Header, {
      closeButton: true
    }, createElement("h4", {
      className: "modal-title"
    }, title)), createElement(Modal.Body, null, createElement(TreeSelector, Object.assign({}, defaultCheckBoxProps))), createElement(Modal.Footer, null, createElement(LinkWrapper, {
      onClick: function onClick() {
        return _this2.setState({
          checked: []
        });
      },
      hcssStyle: "Delete"
    }, createElement(Icon$1, {
      name: "minus-circle",
      margin: "right"
    }), defaultMessages.clearAllSelection), createElement(stupidVariable, {
      onClick: this.onHide,
      hcssStyle: "ThemeInverted"
    }, createElement(Icon$1, {
      name: "remove",
      margin: "left"
    }), defaultMessages.cancel), createElement(stupidVariable, {
      onClick: this.onSelectionConfirm
    }, createElement(Icon$1, {
      name: "check",
      margin: "right"
    }), defaultMessages.ok)));
  };

  return TreeSelectModal;
}(Component);

var Draggable = function Draggable(props) {
  var _React$useState = useState({
    x: props.initialX,
    y: props.initialY,
    previous: {
      x: 0,
      y: 0
    }
  }),
      position = _React$useState[0],
      setPosition = _React$useState[1];

  var _React$useState2 = useState(false),
      isDragging = _React$useState2[0],
      setIsDragging = _React$useState2[1];

  var handleOnMouseDown = function handleOnMouseDown(e) {
    var x = e.clientX;
    var y = e.clientY;
    setIsDragging(true);
    setPosition(function (position) {
      return Object.assign({}, position, {
        previous: {
          x: x,
          y: y
        }
      });
    });
    document.addEventListener("mousemove", handleOnMouseMove.current);
  };

  var handleOnMouseUp = function handleOnMouseUp() {
    document.removeEventListener("mousemove", handleOnMouseMove.current);
    setIsDragging(false);
    setPosition(function (position) {
      return Object.assign({}, position, {
        previous: {}
      });
    });
  };

  var handleOnMouseMove = useRef(function (e) {
    e.preventDefault();
    setPosition(function (position) {
      var xDiff = position.previous.x - e.clientX;
      var yDiff = position.previous.y - e.clientY;
      return {
        x: position.x - xDiff,
        y: position.y - yDiff,
        previous: {
          x: e.clientX,
          y: e.clientY
        }
      };
    });
  });
  var draggableStyle = {
    position: "fixed",
    top: position.y + "px",
    left: position.x + "px",
    zIndex: 9980
  };
  var handleStyle = {
    cursor: isDragging ? "grabbing" : "grab"
  };
  return createElement(Fragment, null, props.children({
    draggableStyle: draggableStyle,
    draggableProps: {
      draggable: true
    },
    handleProps: {
      onMouseDown: handleOnMouseDown,
      onMouseUp: handleOnMouseUp
    },
    handleStyle: handleStyle
  }));
};

var InputFieldContext =
/*#__PURE__*/
createContext({
  validationState: null,
  required: false
});

function _templateObject$1e() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: row;\n  flex-wrap: nowrap;\n  align-items: center;\n  justify-content: flex-start;\n  margin-top: 4px;\n\n  > .help-block {\n    margin: 1px 0 0 0;\n    font-size: 12px;\n    color: ", ";\n    &[data-message-shown=\"true\"] {\n      display: block;\n    }\n    &[data-message-shown=\"false\"] {\n      display: none;\n    }\n  }\n\n  > .fa {\n    padding-right: 6px;\n    font-size: 14px;\n    padding-bottom: 2px;\n  }\n  > .fa-exclamation-circle {\n    color: ", ";\n  }\n  > .fa-check-circle {\n    color: ", ";\n  }\n\n  &.has-error > .help-block {\n    color: ", ";\n  }\n"]);

  _templateObject$1e = function _templateObject() {
    return data;
  };

  return data;
}
var MessageWrapper =
/*#__PURE__*/
styled.div(
/*#__PURE__*/
_templateObject$1e(), gray700, errorRed, successGreen, errorRed);
var Message = function Message(_ref) {
  var children = _ref.children,
      className = _ref.className,
      props = _objectWithoutPropertiesLoose(_ref, ["children", "className"]);

  var context = useContext(InputFieldContext);
  var feedback = null;
  if (context.validationState === "error") feedback = createElement(Icon$1, {
    name: "exclamation-circle"
  });else if (context.validationState === "success") feedback = createElement(Icon$1, {
    name: "check-circle"
  });
  var classes = classNames("form-feedback", className, {
    "has-error": context.validationState === "error" || props.validationState === "error",
    "has-success": context.validationState === "success" || props.validationState === "success"
  });
  return createElement(MessageWrapper, Object.assign({
    className: classes
  }, props), feedback, createElement(HelpBlock, null, children));
};

function _templateObject$1f() {
  var data = _taggedTemplateLiteralLoose(["\n  font-size: 13px;\n  font-family: Arial, Helvetica, sans-serif;\n  font-weight: 600;\n  margin-bottom: 4px;\n  line-height: normal;\n  .fa-asterisk {\n    position: absolute;\n    margin-left: 2px;\n    margin-top: -1px;\n    font-size: 9px;\n    color: ", ";\n  }\n\n  &.has-error {\n    color: ", ";\n  }\n  &.has-success {\n    color: ", ";\n  }\n"]);

  _templateObject$1f = function _templateObject() {
    return data;
  };

  return data;
}
var LabelWrapper =
/*#__PURE__*/
styled(ControlLabel)(
/*#__PURE__*/
_templateObject$1f(), errorRed, errorRed, successGreen);
var Label = function Label(_ref) {
  var children = _ref.children,
      className = _ref.className,
      props = _objectWithoutPropertiesLoose(_ref, ["children", "className"]);

  var context = useContext(InputFieldContext);
  var classes = classNames(className, {
    "has-error": context.validationState === "error" || props.validationState === "error",
    "has-success": context.validationState === "success" || props.validationState === "success"
  });
  return createElement(LabelWrapper, Object.assign({}, props, {
    className: classes
  }), children, (context.required || props.required) && createElement(Icon$1, {
    name: "asterisk"
  }));
};

function _templateObject$1g() {
  var data = _taggedTemplateLiteralLoose(["\n  display: block;\n  width: 100%;\n  padding: 4px 8px;\n  transition: 0.2s;\n  :focus {\n    box-shadow: none;\n    border-color: ", ";\n  }\n\n  &.has-error {\n    background: #ffeff0;\n  }\n"]);

  _templateObject$1g = function _templateObject() {
    return data;
  };

  return data;
}
var StyledField =
/*#__PURE__*/
styled(FormControl)(
/*#__PURE__*/
_templateObject$1g(), blue200);
var TextField$1 = function TextField(_ref) {
  var children = _ref.children,
      className = _ref.className,
      required = _ref.required,
      props = _objectWithoutPropertiesLoose(_ref, ["children", "className", "required"]);

  var context = useContext(InputFieldContext);
  var classes = classNames(className, {
    "has-error": context.validationState === "error" || props.validationState === "error",
    "has-success": context.validationState === "success" || props.validationState === "success"
  });
  return createElement(StyledField, Object.assign({}, props, {
    className: classes,
    required: context.required || required
  }), children);
};

function _templateObject$1h() {
  var data = _taggedTemplateLiteralLoose(["\n  &.form-group {\n    display: block;\n  }\n\n  /* &.has-success {\n    .form-control,\n    .form-control:focus {\n      box-shadow: none;\n    }\n\n    .help-block {\n      color: #006627;\n    }\n  } */\n\n  /* &.has-error {\n    .control-label {\n      color: #a60000;\n    }\n\n    .form-control,\n    .form-control:focus {\n      background: #ffeff0;\n      box-shadow: none;\n    }\n\n    .help-block {\n      color: #a60000;\n    }\n  } */\n"]);

  _templateObject$1h = function _templateObject() {
    return data;
  };

  return data;
}
var StyledGroup =
/*#__PURE__*/
styled(FormGroup)(
/*#__PURE__*/
_templateObject$1h());

var Input =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Input, _React$Component);

  function Input() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Input.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        children = _this$props.children,
        props = _objectWithoutPropertiesLoose(_this$props, ["children", "ref"]);

    var value = {
      validationState: props.validationState,
      required: props.required
    };
    return createElement(InputFieldContext.Provider, {
      value: value
    }, createElement(StyledGroup, Object.assign({}, props), children));
  };

  return Input;
}(Component);
Input.Message = Message;
Input.Label = Label;
Input.TextField = TextField$1;

var InputTextField = function InputTextField(_ref) {
  var label = _ref.label,
      message = _ref.message,
      id = _ref.id,
      props = _objectWithoutPropertiesLoose(_ref, ["label", "message", "id"]);

  return createElement(Input, {
    validationState: props.validationState,
    required: props.required
  }, createElement(Input.Label, {
    htmlFor: id
  }, label), createElement(Input.TextField, Object.assign({
    id: id
  }, props)), createElement(Input.Message, null, message));
};

function _templateObject$1i() {
  var data = _taggedTemplateLiteralLoose(["\n  position: absolute;\n  top: 22px;\n  right: 14px;\n\n  background: #ffffff;\n  box-shadow: 0 0 0 2px #ffffff;\n  border-radius: 50px;\n\n  color: ", ";\n  font-size: 18px;\n  line-height: 1;\n  z-index: 5;\n\n  & > i {\n    line-height: 0;\n  }\n"]);

  _templateObject$1i = function _templateObject() {
    return data;
  };

  return data;
}

var StepCompleteIndicator = function StepCompleteIndicator(props) {
  // Deconstruct props
  var index = props.index,
      containerBackground = props.containerBackground,
      rest = _objectWithoutPropertiesLoose(props, ["index", "containerBackground"]);

  var useCustomBackgroundClear = function useCustomBackgroundClear() {
    if (containerBackground) return {
      background: containerBackground,
      boxShadow: "0 0 0 2px " + containerBackground
    };
    return undefined;
  }; //
  //
  //


  return React__default.createElement(StyledCompletionIndicatorContainer, Object.assign({
    className: "step-completion-indicator",
    "data-testid": "step-" + (index + 1) + "-completion-indicator",
    style: useCustomBackgroundClear()
  }, rest), React__default.createElement(Icon$1, {
    name: "check-circle"
  }));
};

var StyledCompletionIndicatorContainer =
/*#__PURE__*/
styled.div(
/*#__PURE__*/
_templateObject$1i(), green200);

function _templateObject2$u() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n\n  position: relative;\n  background: none;\n  border: none;\n  padding: 0;\n\n  transition: 0.3s;\n\n  & > .step-number,\n  & > .step-name {\n    text-align: center;\n    width: 64px;\n    cursor: default;\n  }\n\n  & > .step-number {\n    display: flex;\n    flex-wrap: nowrap;\n    justify-content: space-around;\n    margin-bottom: 8px;\n    transition: 0.3s;\n\n    & > span {\n      display: flex;\n      flex-wrap: nowrap;\n      align-items: center;\n      justify-content: center;\n      width: 40px;\n      height: 40px;\n\n      background: #ffffff;\n      box-shadow: 0 0 0 8px #ffffff;\n      border: 2px solid ", ";\n      border-radius: 96px;\n\n      color: ", ";\n      font-size: 1.8rem;\n      font-weight: 600;\n      transition: 0.3s;\n    }\n  }\n\n  & > .step-name {\n    width: 80px;\n    height: 60px;\n\n    color: ", ";\n    font-size: 1.3rem;\n    letter-spacing: 0.02em;\n    line-height: 16px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n\n    transition: color 0.3s;\n  }\n\n  &.is-current {\n    & > .step-number {\n      & > span {\n        border: 2px solid ", ";\n        font-weight: 800;\n        color: ", ";\n      }\n    }\n\n    & > .step-name {\n      color: ", ";\n      font-weight: 600;\n    }\n  }\n\n  &.is-clickable:not(.is-current) {\n    cursor: pointer;\n\n    & > .step-number,\n    & > .step-name {\n      cursor: pointer;\n    }\n\n    & > .step-number {\n      & > span {\n        border: 2px solid ", ";\n        color: ", ";\n        font-weight: 600;\n      }\n    }\n\n    & > .step-name {\n      color: ", ";\n      font-weight: 400;\n    }\n\n    &:hover {\n      & > .step-name,\n      & > .step-number > span {\n        color: ", ";\n      }\n    }\n  }\n\n  :focus,\n  :active:focus {\n    outline: none;\n  }\n"]);

  _templateObject2$u = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$1j() {
  var data = _taggedTemplateLiteralLoose(["\n  display: inline-block;\n  position: relative;\n  padding: 16px 20px 6px;\n"]);

  _templateObject$1j = function _templateObject() {
    return data;
  };

  return data;
}

var ProgressStep = function ProgressStep(props) {
  // Destructure props
  var index = props.index,
      name = props.name,
      onClick = props.onClick,
      isClickable = props.isClickable,
      isComplete = props.isComplete,
      isCurrentStep = props.isCurrentStep,
      stepCompleteIndicatorComponent = props.stepCompleteIndicatorComponent,
      containerBackground = props.containerBackground;

  var handleStepRequested = function handleStepRequested() {
    if (isClickable) onClick(index);
  };

  var useCustomBackgroundClear = function useCustomBackgroundClear() {
    if (containerBackground) return {
      background: containerBackground,
      boxShadow: "0 0 0 8px " + containerBackground
    };
    return undefined;
  };

  var getButtonClassName = function getButtonClassName() {
    var value = "wizard-progress-step-button";
    if (isClickable) value += " is-clickable";
    if (isCurrentStep) value += " is-current";
    return value;
  }; //
  //
  //


  var renderStepCompleteIndicator = function renderStepCompleteIndicator() {
    var Indicator = stepCompleteIndicatorComponent || StepCompleteIndicator;
    if (isComplete) return React__default.createElement(Indicator, {
      index: index,
      containerBackground: containerBackground
    });
    return null;
  };

  return React__default.createElement(ProgressStepWrapper, {
    key: "step_" + (index + 1),
    className: "wizard-progress-step",
    "data-testid": "progress-step-" + (index + 1)
  }, React__default.createElement(ProgressStepButton, {
    className: getButtonClassName(),
    onClick: handleStepRequested,
    title: "Step " + (index + 1) + " \u2014 " + name,
    "data-testid": "progress-step-" + (index + 1) + "-button",
    disabled: !isClickable
  }, React__default.createElement("div", {
    className: "step-number",
    "data-testid": "progress-step-" + (index + 1) + "-number",
    style: useCustomBackgroundClear()
  }, React__default.createElement("span", null, index + 1)), React__default.createElement("div", {
    className: "step-name",
    "data-testid": "progress-step-" + (index + 1) + "-name"
  }, name), renderStepCompleteIndicator()));
};

var ProgressStepWrapper =
/*#__PURE__*/
styled.li(
/*#__PURE__*/
_templateObject$1j());
var ProgressStepButton =
/*#__PURE__*/
styled.button(
/*#__PURE__*/
_templateObject2$u(), gray100$1, gray400$1, gray500$1, blue200, gray700$1, gray700$1, gray400$1, gray500$1, gray700$1, blue200);

function _templateObject2$v() {
  var data = _taggedTemplateLiteralLoose(["\n  display: inline-block;\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 100%;\n\n  background: ", ";\n  transform: translateZ(0);\n  transition: 0.3s linear;\n"]);

  _templateObject2$v = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$1k() {
  var data = _taggedTemplateLiteralLoose(["\n  position: absolute;\n  height: 2px;\n  width: calc(100% - 80px);\n  margin-top: 36px;\n  margin-left: 40px;\n\n  background: ", ";\n  transform: translateZ(0);\n  transition: 0.3s linear;\n"]);

  _templateObject$1k = function _templateObject() {
    return data;
  };

  return data;
}

var ProgressTrack = function ProgressTrack(props) {
  // Destructure props
  var currentStep = props.currentStep;

  var calcCompletionTrackLength = function calcCompletionTrackLength() {
    var numberMarkerWidth = 40;
    return (currentStep + 1) * numberMarkerWidth + currentStep * 80;
  }; //
  //
  //


  return React__default.createElement(TrackContainer, {
    className: "wizard-progress-track-line",
    "data-testid": "progress-track-line"
  }, React__default.createElement(CompletionTrack, {
    style: {
      width: calcCompletionTrackLength()
    }
  }));
};

var TrackContainer =
/*#__PURE__*/
styled.div(
/*#__PURE__*/
_templateObject$1k(), gray300$1);
var CompletionTrack =
/*#__PURE__*/
styled.div(
/*#__PURE__*/
_templateObject2$v(), gray400$1);

function _templateObject2$w() {
  var data = _taggedTemplateLiteralLoose(["\n  margin: 0;\n  list-style-type: none;\n  transform: translateZ(0);\n"]);

  _templateObject2$w = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$1l() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  position: relative;\n  align-items: center;\n  justify-content: center;\n  margin: 0 auto 16px;\n\n  font-family: \"Inter\", Arial, Helvetica, sans-serif;\n  transform: translateZ(0);\n\n  & > .progress-container-inner-wrapper {\n    display: inline-block;\n    position: relative;\n    transform: translateZ(0);\n  }\n"]);

  _templateObject$1l = function _templateObject() {
    return data;
  };

  return data;
}

var WizardProgress = function WizardProgress(props) {
  // Destructure props
  var currentStep = props.currentStep,
      onChangeStep = props.onChangeStep,
      stepNames = props.stepNames,
      lastCompletedStepIndex = props.lastCompletedStepIndex,
      progressStepComponent = props.progressStepComponent,
      progressTrackComponent = props.progressTrackComponent,
      stepCompleteIndicatorComponent = props.stepCompleteIndicatorComponent,
      style = props.style,
      testId = props.testId,
      containerBackground = props.containerBackground; //
  //
  //
  // Render a clickable step marker in the progress bar for
  // each individual step in the Wizard

  var renderProgressStep = function renderProgressStep(name, index) {
    var isComplete = index <= lastCompletedStepIndex;
    var isCurrentStep = index === currentStep;
    var isClickable = index <= lastCompletedStepIndex + 1 && !isCurrentStep;
    var StepMarker = progressStepComponent || ProgressStep;
    return React__default.createElement(StepMarker, {
      key: index,
      onClick: onChangeStep,
      index: index,
      name: name,
      isClickable: isClickable,
      isComplete: isComplete,
      isCurrentStep: isCurrentStep,
      stepCompleteIndicatorComponent: stepCompleteIndicatorComponent,
      containerBackground: containerBackground
    });
  }; //
  //
  //
  // Render the track line that connects the step markers in the
  // progress bar and helps indicate to the user how much they've
  // completed and how much is left.


  var renderProgressTrack = function renderProgressTrack() {
    var TrackLine = progressTrackComponent || ProgressTrack;
    return React__default.createElement(TrackLine, {
      currentStep: currentStep
    });
  }; //
  //
  //


  return React__default.createElement(ProgressContainer, {
    className: "wizard-progress-container",
    "data-testid": testId || "wizard-progress-container",
    style: style
  }, React__default.createElement("div", {
    className: "progress-container-inner-wrapper"
  }, renderProgressTrack(), React__default.createElement(ProgressStepList, {
    className: "wizard-progress-step-list",
    "data-testid": "wizard-progress-step-list"
  }, stepNames.map(renderProgressStep))));
};

var ProgressContainer =
/*#__PURE__*/
styled.div(
/*#__PURE__*/
_templateObject$1l());
var ProgressStepList =
/*#__PURE__*/
styled.ul(
/*#__PURE__*/
_templateObject2$w());

function _templateObject$1m() {
  var data = _taggedTemplateLiteralLoose(["\n  position: relative;\n  opacity: 1;\n  transform: translateZ(0);\n  transition: 0.25s;\n\n  &.transition-active {\n    opacity: 0;\n  }\n"]);

  _templateObject$1m = function _templateObject() {
    return data;
  };

  return data;
}

var StepContainer = function StepContainer(props) {
  // Deconstruct props
  var currentStepIndex = props.currentStepIndex,
      isTransitioning = props.isTransitioning,
      minContentHeight = props.minContentHeight,
      testId = props.testId,
      style = props.style,
      children = props.children;

  var getClassName = function getClassName() {
    var value = "wizard-step-container wizard-current-step-content-container";
    value += " step-" + (currentStepIndex + 1) + "-content-container";
    if (isTransitioning) value += " transition-active";
    return value;
  };

  return React__default.createElement(StyledStepContainer, {
    className: getClassName(),
    "data-testid": testId || "wizard-current-step-content-container",
    style: _extends({
      minHeight: minContentHeight
    }, style)
  }, children);
};

var StyledStepContainer =
/*#__PURE__*/
styled.div(
/*#__PURE__*/
_templateObject$1m());

function _templateObject$1n() {
  var data = _taggedTemplateLiteralLoose(["\n  position: relative;\n  transform: translateZ(0);\n"]);

  _templateObject$1n = function _templateObject() {
    return data;
  };

  return data;
}

var Wizard = function Wizard(props) {
  // Destructure props
  var currentStep = props.currentStep,
      onChangeStep = props.onChangeStep,
      steps = props.steps,
      components = props.components,
      styles = props.styles,
      className = props.className,
      testIds = props.testIds,
      containerBackground = props.containerBackground,
      disableTransitionEffect = props.disableTransitionEffect,
      minContentHeight = props.minContentHeight,
      children = props.children; //
  //
  //
  // Store the names of each step

  var _useState = useState([]),
      stepNames = _useState[0],
      setStepNames = _useState[1];

  useEffect(function () {
    // Only update stored step name array if there has been some
    // kind of change, either in the actual names themselves or in
    // the order of the steps.
    // This is meant to prevent unnecessary props updates to (and
    // rerenders of) the progress bar, which uses the array of names
    // to render the progress steps.
    var updatedNames = steps.map(function (step) {
      return step.name;
    });
    setStepNames(function (names) {
      return JSON.stringify(names) !== JSON.stringify(updatedNames) ? updatedNames : names;
    });
  }, [steps]); //
  //
  //
  // Track the user's completion

  var _useState2 = useState(currentStep ? currentStep - 1 : -1),
      lastCompletedStepIndex = _useState2[0],
      setLastCompletedStepIndex = _useState2[1];

  useEffect(function () {
    setLastCompletedStepIndex(function (last) {
      return currentStep - 1 > last ? currentStep - 1 : last;
    });
  }, [currentStep]); //
  //
  //
  // Render the progress bar

  var progressBar = useMemo(function () {
    var ProgressBar = (components === null || components === void 0 ? void 0 : components.progress) || WizardProgress;
    return React__default.createElement(ProgressBar, {
      currentStep: currentStep,
      onChangeStep: onChangeStep,
      stepNames: stepNames,
      lastCompletedStepIndex: lastCompletedStepIndex,
      style: styles === null || styles === void 0 ? void 0 : styles.progress,
      testId: testIds === null || testIds === void 0 ? void 0 : testIds.progress,
      progressStepComponent: components === null || components === void 0 ? void 0 : components.progressStep,
      progressTrackComponent: components === null || components === void 0 ? void 0 : components.progressTrack,
      stepCompleteIndicatorComponent: components === null || components === void 0 ? void 0 : components.stepCompleteIndicator,
      containerBackground: containerBackground
    });
  }, [currentStep, onChangeStep, lastCompletedStepIndex, stepNames, components, styles, testIds, containerBackground]); //
  //
  // Transition between displayed content as user progresses
  // through the steps in the Wizard. Disable this effect if
  // disableTransitionEffect is set to false.

  var _useState3 = useState(currentStep),
      displayedStep = _useState3[0],
      setDisplayedStep = _useState3[1];

  var _useState4 = useState(true),
      isTransitioning = _useState4[0],
      setIsTransitioning = _useState4[1];

  useEffect(function () {
    var transitionTimeout;

    if (disableTransitionEffect) {
      setDisplayedStep(currentStep);
      setIsTransitioning(false);
    } else {
      setIsTransitioning(true);
      transitionTimeout = setTimeout(function () {
        setDisplayedStep(currentStep);
        setIsTransitioning(false);
      }, 500);
    }

    return function () {
      if (!!transitionTimeout) clearTimeout(transitionTimeout);
    };
  }, [currentStep, disableTransitionEffect]); // Render the content of the displayed step

  var renderCurrentStepContent = function renderCurrentStepContent() {
    var CurrentStep = (components === null || components === void 0 ? void 0 : components.stepContainer) || StepContainer;
    return React__default.createElement(CurrentStep, {
      currentStepIndex: displayedStep,
      isTransitioning: isTransitioning,
      minContentHeight: minContentHeight,
      style: styles === null || styles === void 0 ? void 0 : styles.step,
      testId: testIds === null || testIds === void 0 ? void 0 : testIds.step
    }, steps[displayedStep].content);
  }; //
  //
  //


  var Wrapper = (components === null || components === void 0 ? void 0 : components.wrapper) || StyledWizardWrapper;
  return React__default.createElement(Wrapper, {
    className: "wizard-content-wrapper " + className,
    "data-testid": (testIds === null || testIds === void 0 ? void 0 : testIds.wrapper) || "wizard-content-wrapper",
    style: styles === null || styles === void 0 ? void 0 : styles.wrapper
  }, progressBar, renderCurrentStepContent(), children);
};

var StyledWizardWrapper =
/*#__PURE__*/
styled.div(
/*#__PURE__*/
_templateObject$1n());

var WizardComponents = {
  Progress: WizardProgress,
  ProgressStep: ProgressStep,
  ProgressTrack: ProgressTrack,
  StepContainer: StepContainer
};

var StandardColors = standardColors; // Ace Colors

var AceColors = aceColors; // Concrete Colors

var ConcreteColors = concreteColors;

export { Accordion, AceColors, Backdrop, Breadcrumbs, stupidVariable as Button, Checkbox, ConcreteColors, DatePicker, DetailPageTitle, Draggable, ThemedDropdownButton as DropdownButton, Dropzone, Filters, Footer, Icon$1 as Icon, Input as InputFormGroup, Layout, Layout$1 as LayoutConcrete, Link, Loading, LoadingContainer, Modal, ModalAside, ModalPanel, ThemedNotification as Notification, PageTitle, PaneledPage, Radio, Select, SelectModal, SlideoutPanel, StandardColors, StatusFlag, SubTitle, Tab, StyledContainer as TabContainer, Tabs, TextField, InputTextField as TextFormGroup, Textarea, _default as ThemeProvider, Toggle, ToggleButtonGroup, TreeSelectModal, TreeSelector, Widget, Wizard, WizardComponents, notify, themes, useDropdownMenuManager };
//# sourceMappingURL=hcss-components.esm.js.map
